var mf = { exports: {} }, xn = {};
var xd;
function oy() {
  if (xd) return xn;
  xd = 1;
  var S = /* @__PURE__ */ Symbol.for("react.transitional.element"), U = /* @__PURE__ */ Symbol.for("react.fragment");
  function j(h, B, L) {
    var sl = null;
    if (L !== void 0 && (sl = "" + L), B.key !== void 0 && (sl = "" + B.key), "key" in B) {
      L = {};
      for (var ll in B)
        ll !== "key" && (L[ll] = B[ll]);
    } else L = B;
    return B = L.ref, {
      $$typeof: S,
      type: h,
      key: sl,
      ref: B !== void 0 ? B : null,
      props: L
    };
  }
  return xn.Fragment = U, xn.jsx = j, xn.jsxs = j, xn;
}
var jd;
function ry() {
  return jd || (jd = 1, mf.exports = oy()), mf.exports;
}
var f = ry(), yf = { exports: {} }, jn = {}, vf = { exports: {} }, gf = {};
var Od;
function dy() {
  return Od || (Od = 1, (function(S) {
    function U(b, _) {
      var Y = b.length;
      b.push(_);
      l: for (; 0 < Y; ) {
        var ul = Y - 1 >>> 1, ol = b[ul];
        if (0 < B(ol, _))
          b[ul] = _, b[Y] = ol, Y = ul;
        else break l;
      }
    }
    function j(b) {
      return b.length === 0 ? null : b[0];
    }
    function h(b) {
      if (b.length === 0) return null;
      var _ = b[0], Y = b.pop();
      if (Y !== _) {
        b[0] = Y;
        l: for (var ul = 0, ol = b.length, r = ol >>> 1; ul < r; ) {
          var z = 2 * (ul + 1) - 1, x = b[z], M = z + 1, Q = b[M];
          if (0 > B(x, Y))
            M < ol && 0 > B(Q, x) ? (b[ul] = Q, b[M] = Y, ul = M) : (b[ul] = x, b[z] = Y, ul = z);
          else if (M < ol && 0 > B(Q, Y))
            b[ul] = Q, b[M] = Y, ul = M;
          else break l;
        }
      }
      return _;
    }
    function B(b, _) {
      var Y = b.sortIndex - _.sortIndex;
      return Y !== 0 ? Y : b.id - _.id;
    }
    if (S.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var L = performance;
      S.unstable_now = function() {
        return L.now();
      };
    } else {
      var sl = Date, ll = sl.now();
      S.unstable_now = function() {
        return sl.now() - ll;
      };
    }
    var O = [], T = [], $ = 1, R = null, dl = 3, Rl = !1, Cl = !1, Ml = !1, ht = !1, Xl = typeof setTimeout == "function" ? setTimeout : null, mt = typeof clearTimeout == "function" ? clearTimeout : null, Tl = typeof setImmediate < "u" ? setImmediate : null;
    function Jl(b) {
      for (var _ = j(T); _ !== null; ) {
        if (_.callback === null) h(T);
        else if (_.startTime <= b)
          h(T), _.sortIndex = _.expirationTime, U(O, _);
        else break;
        _ = j(T);
      }
    }
    function et(b) {
      if (Ml = !1, Jl(b), !Cl)
        if (j(O) !== null)
          Cl = !0, Hl || (Hl = !0, H());
        else {
          var _ = j(T);
          _ !== null && Ll(et, _.startTime - b);
        }
    }
    var Hl = !1, V = -1, Ol = 5, kl = -1;
    function It() {
      return ht ? !0 : !(S.unstable_now() - kl < Ol);
    }
    function yt() {
      if (ht = !1, Hl) {
        var b = S.unstable_now();
        kl = b;
        var _ = !0;
        try {
          l: {
            Cl = !1, Ml && (Ml = !1, mt(V), V = -1), Rl = !0;
            var Y = dl;
            try {
              t: {
                for (Jl(b), R = j(O); R !== null && !(R.expirationTime > b && It()); ) {
                  var ul = R.callback;
                  if (typeof ul == "function") {
                    R.callback = null, dl = R.priorityLevel;
                    var ol = ul(
                      R.expirationTime <= b
                    );
                    if (b = S.unstable_now(), typeof ol == "function") {
                      R.callback = ol, Jl(b), _ = !0;
                      break t;
                    }
                    R === j(O) && h(O), Jl(b);
                  } else h(O);
                  R = j(O);
                }
                if (R !== null) _ = !0;
                else {
                  var r = j(T);
                  r !== null && Ll(
                    et,
                    r.startTime - b
                  ), _ = !1;
                }
              }
              break l;
            } finally {
              R = null, dl = Y, Rl = !1;
            }
            _ = void 0;
          }
        } finally {
          _ ? H() : Hl = !1;
        }
      }
    }
    var H;
    if (typeof Tl == "function")
      H = function() {
        Tl(yt);
      };
    else if (typeof MessageChannel < "u") {
      var hl = new MessageChannel(), vl = hl.port2;
      hl.port1.onmessage = yt, H = function() {
        vl.postMessage(null);
      };
    } else
      H = function() {
        Xl(yt, 0);
      };
    function Ll(b, _) {
      V = Xl(function() {
        b(S.unstable_now());
      }, _);
    }
    S.unstable_IdlePriority = 5, S.unstable_ImmediatePriority = 1, S.unstable_LowPriority = 4, S.unstable_NormalPriority = 3, S.unstable_Profiling = null, S.unstable_UserBlockingPriority = 2, S.unstable_cancelCallback = function(b) {
      b.callback = null;
    }, S.unstable_forceFrameRate = function(b) {
      0 > b || 125 < b ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : Ol = 0 < b ? Math.floor(1e3 / b) : 5;
    }, S.unstable_getCurrentPriorityLevel = function() {
      return dl;
    }, S.unstable_next = function(b) {
      switch (dl) {
        case 1:
        case 2:
        case 3:
          var _ = 3;
          break;
        default:
          _ = dl;
      }
      var Y = dl;
      dl = _;
      try {
        return b();
      } finally {
        dl = Y;
      }
    }, S.unstable_requestPaint = function() {
      ht = !0;
    }, S.unstable_runWithPriority = function(b, _) {
      switch (b) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          b = 3;
      }
      var Y = dl;
      dl = b;
      try {
        return _();
      } finally {
        dl = Y;
      }
    }, S.unstable_scheduleCallback = function(b, _, Y) {
      var ul = S.unstable_now();
      switch (typeof Y == "object" && Y !== null ? (Y = Y.delay, Y = typeof Y == "number" && 0 < Y ? ul + Y : ul) : Y = ul, b) {
        case 1:
          var ol = -1;
          break;
        case 2:
          ol = 250;
          break;
        case 5:
          ol = 1073741823;
          break;
        case 4:
          ol = 1e4;
          break;
        default:
          ol = 5e3;
      }
      return ol = Y + ol, b = {
        id: $++,
        callback: _,
        priorityLevel: b,
        startTime: Y,
        expirationTime: ol,
        sortIndex: -1
      }, Y > ul ? (b.sortIndex = Y, U(T, b), j(O) === null && b === j(T) && (Ml ? (mt(V), V = -1) : Ml = !0, Ll(et, Y - ul))) : (b.sortIndex = ol, U(O, b), Cl || Rl || (Cl = !0, Hl || (Hl = !0, H()))), b;
    }, S.unstable_shouldYield = It, S.unstable_wrapCallback = function(b) {
      var _ = dl;
      return function() {
        var Y = dl;
        dl = _;
        try {
          return b.apply(this, arguments);
        } finally {
          dl = Y;
        }
      };
    };
  })(gf)), gf;
}
var Dd;
function hy() {
  return Dd || (Dd = 1, vf.exports = dy()), vf.exports;
}
var pf = { exports: {} }, G = {};
var Md;
function my() {
  if (Md) return G;
  Md = 1;
  var S = /* @__PURE__ */ Symbol.for("react.transitional.element"), U = /* @__PURE__ */ Symbol.for("react.portal"), j = /* @__PURE__ */ Symbol.for("react.fragment"), h = /* @__PURE__ */ Symbol.for("react.strict_mode"), B = /* @__PURE__ */ Symbol.for("react.profiler"), L = /* @__PURE__ */ Symbol.for("react.consumer"), sl = /* @__PURE__ */ Symbol.for("react.context"), ll = /* @__PURE__ */ Symbol.for("react.forward_ref"), O = /* @__PURE__ */ Symbol.for("react.suspense"), T = /* @__PURE__ */ Symbol.for("react.memo"), $ = /* @__PURE__ */ Symbol.for("react.lazy"), R = /* @__PURE__ */ Symbol.for("react.activity"), dl = Symbol.iterator;
  function Rl(r) {
    return r === null || typeof r != "object" ? null : (r = dl && r[dl] || r["@@iterator"], typeof r == "function" ? r : null);
  }
  var Cl = {
    isMounted: function() {
      return !1;
    },
    enqueueForceUpdate: function() {
    },
    enqueueReplaceState: function() {
    },
    enqueueSetState: function() {
    }
  }, Ml = Object.assign, ht = {};
  function Xl(r, z, x) {
    this.props = r, this.context = z, this.refs = ht, this.updater = x || Cl;
  }
  Xl.prototype.isReactComponent = {}, Xl.prototype.setState = function(r, z) {
    if (typeof r != "object" && typeof r != "function" && r != null)
      throw Error(
        "takes an object of state variables to update or a function which returns an object of state variables."
      );
    this.updater.enqueueSetState(this, r, z, "setState");
  }, Xl.prototype.forceUpdate = function(r) {
    this.updater.enqueueForceUpdate(this, r, "forceUpdate");
  };
  function mt() {
  }
  mt.prototype = Xl.prototype;
  function Tl(r, z, x) {
    this.props = r, this.context = z, this.refs = ht, this.updater = x || Cl;
  }
  var Jl = Tl.prototype = new mt();
  Jl.constructor = Tl, Ml(Jl, Xl.prototype), Jl.isPureReactComponent = !0;
  var et = Array.isArray;
  function Hl() {
  }
  var V = { H: null, A: null, T: null, S: null }, Ol = Object.prototype.hasOwnProperty;
  function kl(r, z, x) {
    var M = x.ref;
    return {
      $$typeof: S,
      type: r,
      key: z,
      ref: M !== void 0 ? M : null,
      props: x
    };
  }
  function It(r, z) {
    return kl(r.type, z, r.props);
  }
  function yt(r) {
    return typeof r == "object" && r !== null && r.$$typeof === S;
  }
  function H(r) {
    var z = { "=": "=0", ":": "=2" };
    return "$" + r.replace(/[=:]/g, function(x) {
      return z[x];
    });
  }
  var hl = /\/+/g;
  function vl(r, z) {
    return typeof r == "object" && r !== null && r.key != null ? H("" + r.key) : z.toString(36);
  }
  function Ll(r) {
    switch (r.status) {
      case "fulfilled":
        return r.value;
      case "rejected":
        throw r.reason;
      default:
        switch (typeof r.status == "string" ? r.then(Hl, Hl) : (r.status = "pending", r.then(
          function(z) {
            r.status === "pending" && (r.status = "fulfilled", r.value = z);
          },
          function(z) {
            r.status === "pending" && (r.status = "rejected", r.reason = z);
          }
        )), r.status) {
          case "fulfilled":
            return r.value;
          case "rejected":
            throw r.reason;
        }
    }
    throw r;
  }
  function b(r, z, x, M, Q) {
    var K = typeof r;
    (K === "undefined" || K === "boolean") && (r = null);
    var el = !1;
    if (r === null) el = !0;
    else
      switch (K) {
        case "bigint":
        case "string":
        case "number":
          el = !0;
          break;
        case "object":
          switch (r.$$typeof) {
            case S:
            case U:
              el = !0;
              break;
            case $:
              return el = r._init, b(
                el(r._payload),
                z,
                x,
                M,
                Q
              );
          }
      }
    if (el)
      return Q = Q(r), el = M === "" ? "." + vl(r, 0) : M, et(Q) ? (x = "", el != null && (x = el.replace(hl, "$&/") + "/"), b(Q, z, x, "", function(Ua) {
        return Ua;
      })) : Q != null && (yt(Q) && (Q = It(
        Q,
        x + (Q.key == null || r && r.key === Q.key ? "" : ("" + Q.key).replace(
          hl,
          "$&/"
        ) + "/") + el
      )), z.push(Q)), 1;
    el = 0;
    var Vl = M === "" ? "." : M + ":";
    if (et(r))
      for (var Sl = 0; Sl < r.length; Sl++)
        M = r[Sl], K = Vl + vl(M, Sl), el += b(
          M,
          z,
          x,
          K,
          Q
        );
    else if (Sl = Rl(r), typeof Sl == "function")
      for (r = Sl.call(r), Sl = 0; !(M = r.next()).done; )
        M = M.value, K = Vl + vl(M, Sl++), el += b(
          M,
          z,
          x,
          K,
          Q
        );
    else if (K === "object") {
      if (typeof r.then == "function")
        return b(
          Ll(r),
          z,
          x,
          M,
          Q
        );
      throw z = String(r), Error(
        "Objects are not valid as a React child (found: " + (z === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : z) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    return el;
  }
  function _(r, z, x) {
    if (r == null) return r;
    var M = [], Q = 0;
    return b(r, M, "", "", function(K) {
      return z.call(x, K, Q++);
    }), M;
  }
  function Y(r) {
    if (r._status === -1) {
      var z = r._result;
      z = z(), z.then(
        function(x) {
          (r._status === 0 || r._status === -1) && (r._status = 1, r._result = x);
        },
        function(x) {
          (r._status === 0 || r._status === -1) && (r._status = 2, r._result = x);
        }
      ), r._status === -1 && (r._status = 0, r._result = z);
    }
    if (r._status === 1) return r._result.default;
    throw r._result;
  }
  var ul = typeof reportError == "function" ? reportError : function(r) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var z = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof r == "object" && r !== null && typeof r.message == "string" ? String(r.message) : String(r),
        error: r
      });
      if (!window.dispatchEvent(z)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", r);
      return;
    }
    console.error(r);
  }, ol = {
    map: _,
    forEach: function(r, z, x) {
      _(
        r,
        function() {
          z.apply(this, arguments);
        },
        x
      );
    },
    count: function(r) {
      var z = 0;
      return _(r, function() {
        z++;
      }), z;
    },
    toArray: function(r) {
      return _(r, function(z) {
        return z;
      }) || [];
    },
    only: function(r) {
      if (!yt(r))
        throw Error(
          "React.Children.only expected to receive a single React element child."
        );
      return r;
    }
  };
  return G.Activity = R, G.Children = ol, G.Component = Xl, G.Fragment = j, G.Profiler = B, G.PureComponent = Tl, G.StrictMode = h, G.Suspense = O, G.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = V, G.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(r) {
      return V.H.useMemoCache(r);
    }
  }, G.cache = function(r) {
    return function() {
      return r.apply(null, arguments);
    };
  }, G.cacheSignal = function() {
    return null;
  }, G.cloneElement = function(r, z, x) {
    if (r == null)
      throw Error(
        "The argument must be a React element, but you passed " + r + "."
      );
    var M = Ml({}, r.props), Q = r.key;
    if (z != null)
      for (K in z.key !== void 0 && (Q = "" + z.key), z)
        !Ol.call(z, K) || K === "key" || K === "__self" || K === "__source" || K === "ref" && z.ref === void 0 || (M[K] = z[K]);
    var K = arguments.length - 2;
    if (K === 1) M.children = x;
    else if (1 < K) {
      for (var el = Array(K), Vl = 0; Vl < K; Vl++)
        el[Vl] = arguments[Vl + 2];
      M.children = el;
    }
    return kl(r.type, Q, M);
  }, G.createContext = function(r) {
    return r = {
      $$typeof: sl,
      _currentValue: r,
      _currentValue2: r,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }, r.Provider = r, r.Consumer = {
      $$typeof: L,
      _context: r
    }, r;
  }, G.createElement = function(r, z, x) {
    var M, Q = {}, K = null;
    if (z != null)
      for (M in z.key !== void 0 && (K = "" + z.key), z)
        Ol.call(z, M) && M !== "key" && M !== "__self" && M !== "__source" && (Q[M] = z[M]);
    var el = arguments.length - 2;
    if (el === 1) Q.children = x;
    else if (1 < el) {
      for (var Vl = Array(el), Sl = 0; Sl < el; Sl++)
        Vl[Sl] = arguments[Sl + 2];
      Q.children = Vl;
    }
    if (r && r.defaultProps)
      for (M in el = r.defaultProps, el)
        Q[M] === void 0 && (Q[M] = el[M]);
    return kl(r, K, Q);
  }, G.createRef = function() {
    return { current: null };
  }, G.forwardRef = function(r) {
    return { $$typeof: ll, render: r };
  }, G.isValidElement = yt, G.lazy = function(r) {
    return {
      $$typeof: $,
      _payload: { _status: -1, _result: r },
      _init: Y
    };
  }, G.memo = function(r, z) {
    return {
      $$typeof: T,
      type: r,
      compare: z === void 0 ? null : z
    };
  }, G.startTransition = function(r) {
    var z = V.T, x = {};
    V.T = x;
    try {
      var M = r(), Q = V.S;
      Q !== null && Q(x, M), typeof M == "object" && M !== null && typeof M.then == "function" && M.then(Hl, ul);
    } catch (K) {
      ul(K);
    } finally {
      z !== null && x.types !== null && (z.types = x.types), V.T = z;
    }
  }, G.unstable_useCacheRefresh = function() {
    return V.H.useCacheRefresh();
  }, G.use = function(r) {
    return V.H.use(r);
  }, G.useActionState = function(r, z, x) {
    return V.H.useActionState(r, z, x);
  }, G.useCallback = function(r, z) {
    return V.H.useCallback(r, z);
  }, G.useContext = function(r) {
    return V.H.useContext(r);
  }, G.useDebugValue = function() {
  }, G.useDeferredValue = function(r, z) {
    return V.H.useDeferredValue(r, z);
  }, G.useEffect = function(r, z) {
    return V.H.useEffect(r, z);
  }, G.useEffectEvent = function(r) {
    return V.H.useEffectEvent(r);
  }, G.useId = function() {
    return V.H.useId();
  }, G.useImperativeHandle = function(r, z, x) {
    return V.H.useImperativeHandle(r, z, x);
  }, G.useInsertionEffect = function(r, z) {
    return V.H.useInsertionEffect(r, z);
  }, G.useLayoutEffect = function(r, z) {
    return V.H.useLayoutEffect(r, z);
  }, G.useMemo = function(r, z) {
    return V.H.useMemo(r, z);
  }, G.useOptimistic = function(r, z) {
    return V.H.useOptimistic(r, z);
  }, G.useReducer = function(r, z, x) {
    return V.H.useReducer(r, z, x);
  }, G.useRef = function(r) {
    return V.H.useRef(r);
  }, G.useState = function(r) {
    return V.H.useState(r);
  }, G.useSyncExternalStore = function(r, z, x) {
    return V.H.useSyncExternalStore(
      r,
      z,
      x
    );
  }, G.useTransition = function() {
    return V.H.useTransition();
  }, G.version = "19.2.7", G;
}
var Nd;
function Tf() {
  return Nd || (Nd = 1, pf.exports = my()), pf.exports;
}
var bf = { exports: {} }, Zl = {};
var Ud;
function yy() {
  if (Ud) return Zl;
  Ud = 1;
  var S = Tf();
  function U(O) {
    var T = "https://react.dev/errors/" + O;
    if (1 < arguments.length) {
      T += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var $ = 2; $ < arguments.length; $++)
        T += "&args[]=" + encodeURIComponent(arguments[$]);
    }
    return "Minified React error #" + O + "; visit " + T + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function j() {
  }
  var h = {
    d: {
      f: j,
      r: function() {
        throw Error(U(522));
      },
      D: j,
      C: j,
      L: j,
      m: j,
      X: j,
      S: j,
      M: j
    },
    p: 0,
    findDOMNode: null
  }, B = /* @__PURE__ */ Symbol.for("react.portal");
  function L(O, T, $) {
    var R = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: B,
      key: R == null ? null : "" + R,
      children: O,
      containerInfo: T,
      implementation: $
    };
  }
  var sl = S.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function ll(O, T) {
    if (O === "font") return "";
    if (typeof T == "string")
      return T === "use-credentials" ? T : "";
  }
  return Zl.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = h, Zl.createPortal = function(O, T) {
    var $ = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!T || T.nodeType !== 1 && T.nodeType !== 9 && T.nodeType !== 11)
      throw Error(U(299));
    return L(O, T, null, $);
  }, Zl.flushSync = function(O) {
    var T = sl.T, $ = h.p;
    try {
      if (sl.T = null, h.p = 2, O) return O();
    } finally {
      sl.T = T, h.p = $, h.d.f();
    }
  }, Zl.preconnect = function(O, T) {
    typeof O == "string" && (T ? (T = T.crossOrigin, T = typeof T == "string" ? T === "use-credentials" ? T : "" : void 0) : T = null, h.d.C(O, T));
  }, Zl.prefetchDNS = function(O) {
    typeof O == "string" && h.d.D(O);
  }, Zl.preinit = function(O, T) {
    if (typeof O == "string" && T && typeof T.as == "string") {
      var $ = T.as, R = ll($, T.crossOrigin), dl = typeof T.integrity == "string" ? T.integrity : void 0, Rl = typeof T.fetchPriority == "string" ? T.fetchPriority : void 0;
      $ === "style" ? h.d.S(
        O,
        typeof T.precedence == "string" ? T.precedence : void 0,
        {
          crossOrigin: R,
          integrity: dl,
          fetchPriority: Rl
        }
      ) : $ === "script" && h.d.X(O, {
        crossOrigin: R,
        integrity: dl,
        fetchPriority: Rl,
        nonce: typeof T.nonce == "string" ? T.nonce : void 0
      });
    }
  }, Zl.preinitModule = function(O, T) {
    if (typeof O == "string")
      if (typeof T == "object" && T !== null) {
        if (T.as == null || T.as === "script") {
          var $ = ll(
            T.as,
            T.crossOrigin
          );
          h.d.M(O, {
            crossOrigin: $,
            integrity: typeof T.integrity == "string" ? T.integrity : void 0,
            nonce: typeof T.nonce == "string" ? T.nonce : void 0
          });
        }
      } else T == null && h.d.M(O);
  }, Zl.preload = function(O, T) {
    if (typeof O == "string" && typeof T == "object" && T !== null && typeof T.as == "string") {
      var $ = T.as, R = ll($, T.crossOrigin);
      h.d.L(O, $, {
        crossOrigin: R,
        integrity: typeof T.integrity == "string" ? T.integrity : void 0,
        nonce: typeof T.nonce == "string" ? T.nonce : void 0,
        type: typeof T.type == "string" ? T.type : void 0,
        fetchPriority: typeof T.fetchPriority == "string" ? T.fetchPriority : void 0,
        referrerPolicy: typeof T.referrerPolicy == "string" ? T.referrerPolicy : void 0,
        imageSrcSet: typeof T.imageSrcSet == "string" ? T.imageSrcSet : void 0,
        imageSizes: typeof T.imageSizes == "string" ? T.imageSizes : void 0,
        media: typeof T.media == "string" ? T.media : void 0
      });
    }
  }, Zl.preloadModule = function(O, T) {
    if (typeof O == "string")
      if (T) {
        var $ = ll(T.as, T.crossOrigin);
        h.d.m(O, {
          as: typeof T.as == "string" && T.as !== "script" ? T.as : void 0,
          crossOrigin: $,
          integrity: typeof T.integrity == "string" ? T.integrity : void 0
        });
      } else h.d.m(O);
  }, Zl.requestFormReset = function(O) {
    h.d.r(O);
  }, Zl.unstable_batchedUpdates = function(O, T) {
    return O(T);
  }, Zl.useFormState = function(O, T, $) {
    return sl.H.useFormState(O, T, $);
  }, Zl.useFormStatus = function() {
    return sl.H.useHostTransitionStatus();
  }, Zl.version = "19.2.7", Zl;
}
var Rd;
function vy() {
  if (Rd) return bf.exports;
  Rd = 1;
  function S() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(S);
      } catch (U) {
        console.error(U);
      }
  }
  return S(), bf.exports = yy(), bf.exports;
}
var Cd;
function gy() {
  if (Cd) return jn;
  Cd = 1;
  var S = hy(), U = Tf(), j = vy();
  function h(l) {
    var t = "https://react.dev/errors/" + l;
    if (1 < arguments.length) {
      t += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var e = 2; e < arguments.length; e++)
        t += "&args[]=" + encodeURIComponent(arguments[e]);
    }
    return "Minified React error #" + l + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function B(l) {
    return !(!l || l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11);
  }
  function L(l) {
    var t = l, e = l;
    if (l.alternate) for (; t.return; ) t = t.return;
    else {
      l = t;
      do
        t = l, (t.flags & 4098) !== 0 && (e = t.return), l = t.return;
      while (l);
    }
    return t.tag === 3 ? e : null;
  }
  function sl(l) {
    if (l.tag === 13) {
      var t = l.memoizedState;
      if (t === null && (l = l.alternate, l !== null && (t = l.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function ll(l) {
    if (l.tag === 31) {
      var t = l.memoizedState;
      if (t === null && (l = l.alternate, l !== null && (t = l.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function O(l) {
    if (L(l) !== l)
      throw Error(h(188));
  }
  function T(l) {
    var t = l.alternate;
    if (!t) {
      if (t = L(l), t === null) throw Error(h(188));
      return t !== l ? null : l;
    }
    for (var e = l, a = t; ; ) {
      var n = e.return;
      if (n === null) break;
      var u = n.alternate;
      if (u === null) {
        if (a = n.return, a !== null) {
          e = a;
          continue;
        }
        break;
      }
      if (n.child === u.child) {
        for (u = n.child; u; ) {
          if (u === e) return O(n), l;
          if (u === a) return O(n), t;
          u = u.sibling;
        }
        throw Error(h(188));
      }
      if (e.return !== a.return) e = n, a = u;
      else {
        for (var i = !1, c = n.child; c; ) {
          if (c === e) {
            i = !0, e = n, a = u;
            break;
          }
          if (c === a) {
            i = !0, a = n, e = u;
            break;
          }
          c = c.sibling;
        }
        if (!i) {
          for (c = u.child; c; ) {
            if (c === e) {
              i = !0, e = u, a = n;
              break;
            }
            if (c === a) {
              i = !0, a = u, e = n;
              break;
            }
            c = c.sibling;
          }
          if (!i) throw Error(h(189));
        }
      }
      if (e.alternate !== a) throw Error(h(190));
    }
    if (e.tag !== 3) throw Error(h(188));
    return e.stateNode.current === e ? l : t;
  }
  function $(l) {
    var t = l.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return l;
    for (l = l.child; l !== null; ) {
      if (t = $(l), t !== null) return t;
      l = l.sibling;
    }
    return null;
  }
  var R = Object.assign, dl = /* @__PURE__ */ Symbol.for("react.element"), Rl = /* @__PURE__ */ Symbol.for("react.transitional.element"), Cl = /* @__PURE__ */ Symbol.for("react.portal"), Ml = /* @__PURE__ */ Symbol.for("react.fragment"), ht = /* @__PURE__ */ Symbol.for("react.strict_mode"), Xl = /* @__PURE__ */ Symbol.for("react.profiler"), mt = /* @__PURE__ */ Symbol.for("react.consumer"), Tl = /* @__PURE__ */ Symbol.for("react.context"), Jl = /* @__PURE__ */ Symbol.for("react.forward_ref"), et = /* @__PURE__ */ Symbol.for("react.suspense"), Hl = /* @__PURE__ */ Symbol.for("react.suspense_list"), V = /* @__PURE__ */ Symbol.for("react.memo"), Ol = /* @__PURE__ */ Symbol.for("react.lazy"), kl = /* @__PURE__ */ Symbol.for("react.activity"), It = /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel"), yt = Symbol.iterator;
  function H(l) {
    return l === null || typeof l != "object" ? null : (l = yt && l[yt] || l["@@iterator"], typeof l == "function" ? l : null);
  }
  var hl = /* @__PURE__ */ Symbol.for("react.client.reference");
  function vl(l) {
    if (l == null) return null;
    if (typeof l == "function")
      return l.$$typeof === hl ? null : l.displayName || l.name || null;
    if (typeof l == "string") return l;
    switch (l) {
      case Ml:
        return "Fragment";
      case Xl:
        return "Profiler";
      case ht:
        return "StrictMode";
      case et:
        return "Suspense";
      case Hl:
        return "SuspenseList";
      case kl:
        return "Activity";
    }
    if (typeof l == "object")
      switch (l.$$typeof) {
        case Cl:
          return "Portal";
        case Tl:
          return l.displayName || "Context";
        case mt:
          return (l._context.displayName || "Context") + ".Consumer";
        case Jl:
          var t = l.render;
          return l = l.displayName, l || (l = t.displayName || t.name || "", l = l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef"), l;
        case V:
          return t = l.displayName || null, t !== null ? t : vl(l.type) || "Memo";
        case Ol:
          t = l._payload, l = l._init;
          try {
            return vl(l(t));
          } catch {
          }
      }
    return null;
  }
  var Ll = Array.isArray, b = U.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, _ = j.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Y = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, ul = [], ol = -1;
  function r(l) {
    return { current: l };
  }
  function z(l) {
    0 > ol || (l.current = ul[ol], ul[ol] = null, ol--);
  }
  function x(l, t) {
    ol++, ul[ol] = l.current, l.current = t;
  }
  var M = r(null), Q = r(null), K = r(null), el = r(null);
  function Vl(l, t) {
    switch (x(K, t), x(Q, l), x(M, null), t.nodeType) {
      case 9:
      case 11:
        l = (l = t.documentElement) && (l = l.namespaceURI) ? Wr(l) : 0;
        break;
      default:
        if (l = t.tagName, t = t.namespaceURI)
          t = Wr(t), l = $r(t, l);
        else
          switch (l) {
            case "svg":
              l = 1;
              break;
            case "math":
              l = 2;
              break;
            default:
              l = 0;
          }
    }
    z(M), x(M, l);
  }
  function Sl() {
    z(M), z(Q), z(K);
  }
  function Ua(l) {
    l.memoizedState !== null && x(el, l);
    var t = M.current, e = $r(t, l.type);
    t !== e && (x(Q, l), x(M, e));
  }
  function On(l) {
    Q.current === l && (z(M), z(Q)), el.current === l && (z(el), An._currentValue = Y);
  }
  var Wu, zf;
  function _e(l) {
    if (Wu === void 0)
      try {
        throw Error();
      } catch (e) {
        var t = e.stack.trim().match(/\n( *(at )?)/);
        Wu = t && t[1] || "", zf = -1 < e.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < e.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + Wu + l + zf;
  }
  var $u = !1;
  function Fu(l, t) {
    if (!l || $u) return "";
    $u = !0;
    var e = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var a = {
        DetermineComponentFrameRoot: function() {
          try {
            if (t) {
              var A = function() {
                throw Error();
              };
              if (Object.defineProperty(A.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(A, []);
                } catch (g) {
                  var v = g;
                }
                Reflect.construct(l, [], A);
              } else {
                try {
                  A.call();
                } catch (g) {
                  v = g;
                }
                l.call(A.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (g) {
                v = g;
              }
              (A = l()) && typeof A.catch == "function" && A.catch(function() {
              });
            }
          } catch (g) {
            if (g && v && typeof g.stack == "string")
              return [g.stack, v.stack];
          }
          return [null, null];
        }
      };
      a.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var n = Object.getOwnPropertyDescriptor(
        a.DetermineComponentFrameRoot,
        "name"
      );
      n && n.configurable && Object.defineProperty(
        a.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var u = a.DetermineComponentFrameRoot(), i = u[0], c = u[1];
      if (i && c) {
        var s = i.split(`
`), y = c.split(`
`);
        for (n = a = 0; a < s.length && !s[a].includes("DetermineComponentFrameRoot"); )
          a++;
        for (; n < y.length && !y[n].includes(
          "DetermineComponentFrameRoot"
        ); )
          n++;
        if (a === s.length || n === y.length)
          for (a = s.length - 1, n = y.length - 1; 1 <= a && 0 <= n && s[a] !== y[n]; )
            n--;
        for (; 1 <= a && 0 <= n; a--, n--)
          if (s[a] !== y[n]) {
            if (a !== 1 || n !== 1)
              do
                if (a--, n--, 0 > n || s[a] !== y[n]) {
                  var p = `
` + s[a].replace(" at new ", " at ");
                  return l.displayName && p.includes("<anonymous>") && (p = p.replace("<anonymous>", l.displayName)), p;
                }
              while (1 <= a && 0 <= n);
            break;
          }
      }
    } finally {
      $u = !1, Error.prepareStackTrace = e;
    }
    return (e = l ? l.displayName || l.name : "") ? _e(e) : "";
  }
  function Xd(l, t) {
    switch (l.tag) {
      case 26:
      case 27:
      case 5:
        return _e(l.type);
      case 16:
        return _e("Lazy");
      case 13:
        return l.child !== t && t !== null ? _e("Suspense Fallback") : _e("Suspense");
      case 19:
        return _e("SuspenseList");
      case 0:
      case 15:
        return Fu(l.type, !1);
      case 11:
        return Fu(l.type.render, !1);
      case 1:
        return Fu(l.type, !0);
      case 31:
        return _e("Activity");
      default:
        return "";
    }
  }
  function _f(l) {
    try {
      var t = "", e = null;
      do
        t += Xd(l, e), e = l, l = l.return;
      while (l);
      return t;
    } catch (a) {
      return `
Error generating stack: ` + a.message + `
` + a.stack;
    }
  }
  var Iu = Object.prototype.hasOwnProperty, Pu = S.unstable_scheduleCallback, li = S.unstable_cancelCallback, Zd = S.unstable_shouldYield, Ld = S.unstable_requestPaint, at = S.unstable_now, Vd = S.unstable_getCurrentPriorityLevel, xf = S.unstable_ImmediatePriority, jf = S.unstable_UserBlockingPriority, Dn = S.unstable_NormalPriority, Kd = S.unstable_LowPriority, Of = S.unstable_IdlePriority, wd = S.log, Jd = S.unstable_setDisableYieldValue, Ra = null, nt = null;
  function Pt(l) {
    if (typeof wd == "function" && Jd(l), nt && typeof nt.setStrictMode == "function")
      try {
        nt.setStrictMode(Ra, l);
      } catch {
      }
  }
  var ut = Math.clz32 ? Math.clz32 : $d, kd = Math.log, Wd = Math.LN2;
  function $d(l) {
    return l >>>= 0, l === 0 ? 32 : 31 - (kd(l) / Wd | 0) | 0;
  }
  var Mn = 256, Nn = 262144, Un = 4194304;
  function xe(l) {
    var t = l & 42;
    if (t !== 0) return t;
    switch (l & -l) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return l & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return l & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return l & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return l;
    }
  }
  function Rn(l, t, e) {
    var a = l.pendingLanes;
    if (a === 0) return 0;
    var n = 0, u = l.suspendedLanes, i = l.pingedLanes;
    l = l.warmLanes;
    var c = a & 134217727;
    return c !== 0 ? (a = c & ~u, a !== 0 ? n = xe(a) : (i &= c, i !== 0 ? n = xe(i) : e || (e = c & ~l, e !== 0 && (n = xe(e))))) : (c = a & ~u, c !== 0 ? n = xe(c) : i !== 0 ? n = xe(i) : e || (e = a & ~l, e !== 0 && (n = xe(e)))), n === 0 ? 0 : t !== 0 && t !== n && (t & u) === 0 && (u = n & -n, e = t & -t, u >= e || u === 32 && (e & 4194048) !== 0) ? t : n;
  }
  function Ca(l, t) {
    return (l.pendingLanes & ~(l.suspendedLanes & ~l.pingedLanes) & t) === 0;
  }
  function Fd(l, t) {
    switch (l) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return t + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Df() {
    var l = Un;
    return Un <<= 1, (Un & 62914560) === 0 && (Un = 4194304), l;
  }
  function ti(l) {
    for (var t = [], e = 0; 31 > e; e++) t.push(l);
    return t;
  }
  function Ha(l, t) {
    l.pendingLanes |= t, t !== 268435456 && (l.suspendedLanes = 0, l.pingedLanes = 0, l.warmLanes = 0);
  }
  function Id(l, t, e, a, n, u) {
    var i = l.pendingLanes;
    l.pendingLanes = e, l.suspendedLanes = 0, l.pingedLanes = 0, l.warmLanes = 0, l.expiredLanes &= e, l.entangledLanes &= e, l.errorRecoveryDisabledLanes &= e, l.shellSuspendCounter = 0;
    var c = l.entanglements, s = l.expirationTimes, y = l.hiddenUpdates;
    for (e = i & ~e; 0 < e; ) {
      var p = 31 - ut(e), A = 1 << p;
      c[p] = 0, s[p] = -1;
      var v = y[p];
      if (v !== null)
        for (y[p] = null, p = 0; p < v.length; p++) {
          var g = v[p];
          g !== null && (g.lane &= -536870913);
        }
      e &= ~A;
    }
    a !== 0 && Mf(l, a, 0), u !== 0 && n === 0 && l.tag !== 0 && (l.suspendedLanes |= u & ~(i & ~t));
  }
  function Mf(l, t, e) {
    l.pendingLanes |= t, l.suspendedLanes &= ~t;
    var a = 31 - ut(t);
    l.entangledLanes |= t, l.entanglements[a] = l.entanglements[a] | 1073741824 | e & 261930;
  }
  function Nf(l, t) {
    var e = l.entangledLanes |= t;
    for (l = l.entanglements; e; ) {
      var a = 31 - ut(e), n = 1 << a;
      n & t | l[a] & t && (l[a] |= t), e &= ~n;
    }
  }
  function Uf(l, t) {
    var e = t & -t;
    return e = (e & 42) !== 0 ? 1 : ei(e), (e & (l.suspendedLanes | t)) !== 0 ? 0 : e;
  }
  function ei(l) {
    switch (l) {
      case 2:
        l = 1;
        break;
      case 8:
        l = 4;
        break;
      case 32:
        l = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        l = 128;
        break;
      case 268435456:
        l = 134217728;
        break;
      default:
        l = 0;
    }
    return l;
  }
  function ai(l) {
    return l &= -l, 2 < l ? 8 < l ? (l & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function Rf() {
    var l = _.p;
    return l !== 0 ? l : (l = window.event, l === void 0 ? 32 : bd(l.type));
  }
  function Cf(l, t) {
    var e = _.p;
    try {
      return _.p = l, t();
    } finally {
      _.p = e;
    }
  }
  var le = Math.random().toString(36).slice(2), ql = "__reactFiber$" + le, Wl = "__reactProps$" + le, we = "__reactContainer$" + le, ni = "__reactEvents$" + le, Pd = "__reactListeners$" + le, lh = "__reactHandles$" + le, Hf = "__reactResources$" + le, qa = "__reactMarker$" + le;
  function ui(l) {
    delete l[ql], delete l[Wl], delete l[ni], delete l[Pd], delete l[lh];
  }
  function Je(l) {
    var t = l[ql];
    if (t) return t;
    for (var e = l.parentNode; e; ) {
      if (t = e[we] || e[ql]) {
        if (e = t.alternate, t.child !== null || e !== null && e.child !== null)
          for (l = ad(l); l !== null; ) {
            if (e = l[ql]) return e;
            l = ad(l);
          }
        return t;
      }
      l = e, e = l.parentNode;
    }
    return null;
  }
  function ke(l) {
    if (l = l[ql] || l[we]) {
      var t = l.tag;
      if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3)
        return l;
    }
    return null;
  }
  function Ba(l) {
    var t = l.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return l.stateNode;
    throw Error(h(33));
  }
  function We(l) {
    var t = l[Hf];
    return t || (t = l[Hf] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), t;
  }
  function Nl(l) {
    l[qa] = !0;
  }
  var qf = /* @__PURE__ */ new Set(), Bf = {};
  function je(l, t) {
    $e(l, t), $e(l + "Capture", t);
  }
  function $e(l, t) {
    for (Bf[l] = t, l = 0; l < t.length; l++)
      qf.add(t[l]);
  }
  var th = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), Yf = {}, Gf = {};
  function eh(l) {
    return Iu.call(Gf, l) ? !0 : Iu.call(Yf, l) ? !1 : th.test(l) ? Gf[l] = !0 : (Yf[l] = !0, !1);
  }
  function Cn(l, t, e) {
    if (eh(t))
      if (e === null) l.removeAttribute(t);
      else {
        switch (typeof e) {
          case "undefined":
          case "function":
          case "symbol":
            l.removeAttribute(t);
            return;
          case "boolean":
            var a = t.toLowerCase().slice(0, 5);
            if (a !== "data-" && a !== "aria-") {
              l.removeAttribute(t);
              return;
            }
        }
        l.setAttribute(t, "" + e);
      }
  }
  function Hn(l, t, e) {
    if (e === null) l.removeAttribute(t);
    else {
      switch (typeof e) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          l.removeAttribute(t);
          return;
      }
      l.setAttribute(t, "" + e);
    }
  }
  function Ct(l, t, e, a) {
    if (a === null) l.removeAttribute(e);
    else {
      switch (typeof a) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          l.removeAttribute(e);
          return;
      }
      l.setAttributeNS(t, e, "" + a);
    }
  }
  function vt(l) {
    switch (typeof l) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return l;
      case "object":
        return l;
      default:
        return "";
    }
  }
  function Qf(l) {
    var t = l.type;
    return (l = l.nodeName) && l.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
  }
  function ah(l, t, e) {
    var a = Object.getOwnPropertyDescriptor(
      l.constructor.prototype,
      t
    );
    if (!l.hasOwnProperty(t) && typeof a < "u" && typeof a.get == "function" && typeof a.set == "function") {
      var n = a.get, u = a.set;
      return Object.defineProperty(l, t, {
        configurable: !0,
        get: function() {
          return n.call(this);
        },
        set: function(i) {
          e = "" + i, u.call(this, i);
        }
      }), Object.defineProperty(l, t, {
        enumerable: a.enumerable
      }), {
        getValue: function() {
          return e;
        },
        setValue: function(i) {
          e = "" + i;
        },
        stopTracking: function() {
          l._valueTracker = null, delete l[t];
        }
      };
    }
  }
  function ii(l) {
    if (!l._valueTracker) {
      var t = Qf(l) ? "checked" : "value";
      l._valueTracker = ah(
        l,
        t,
        "" + l[t]
      );
    }
  }
  function Xf(l) {
    if (!l) return !1;
    var t = l._valueTracker;
    if (!t) return !0;
    var e = t.getValue(), a = "";
    return l && (a = Qf(l) ? l.checked ? "true" : "false" : l.value), l = a, l !== e ? (t.setValue(l), !0) : !1;
  }
  function qn(l) {
    if (l = l || (typeof document < "u" ? document : void 0), typeof l > "u") return null;
    try {
      return l.activeElement || l.body;
    } catch {
      return l.body;
    }
  }
  var nh = /[\n"\\]/g;
  function gt(l) {
    return l.replace(
      nh,
      function(t) {
        return "\\" + t.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function ci(l, t, e, a, n, u, i, c) {
    l.name = "", i != null && typeof i != "function" && typeof i != "symbol" && typeof i != "boolean" ? l.type = i : l.removeAttribute("type"), t != null ? i === "number" ? (t === 0 && l.value === "" || l.value != t) && (l.value = "" + vt(t)) : l.value !== "" + vt(t) && (l.value = "" + vt(t)) : i !== "submit" && i !== "reset" || l.removeAttribute("value"), t != null ? fi(l, i, vt(t)) : e != null ? fi(l, i, vt(e)) : a != null && l.removeAttribute("value"), n == null && u != null && (l.defaultChecked = !!u), n != null && (l.checked = n && typeof n != "function" && typeof n != "symbol"), c != null && typeof c != "function" && typeof c != "symbol" && typeof c != "boolean" ? l.name = "" + vt(c) : l.removeAttribute("name");
  }
  function Zf(l, t, e, a, n, u, i, c) {
    if (u != null && typeof u != "function" && typeof u != "symbol" && typeof u != "boolean" && (l.type = u), t != null || e != null) {
      if (!(u !== "submit" && u !== "reset" || t != null)) {
        ii(l);
        return;
      }
      e = e != null ? "" + vt(e) : "", t = t != null ? "" + vt(t) : e, c || t === l.value || (l.value = t), l.defaultValue = t;
    }
    a = a ?? n, a = typeof a != "function" && typeof a != "symbol" && !!a, l.checked = c ? l.checked : !!a, l.defaultChecked = !!a, i != null && typeof i != "function" && typeof i != "symbol" && typeof i != "boolean" && (l.name = i), ii(l);
  }
  function fi(l, t, e) {
    t === "number" && qn(l.ownerDocument) === l || l.defaultValue === "" + e || (l.defaultValue = "" + e);
  }
  function Fe(l, t, e, a) {
    if (l = l.options, t) {
      t = {};
      for (var n = 0; n < e.length; n++)
        t["$" + e[n]] = !0;
      for (e = 0; e < l.length; e++)
        n = t.hasOwnProperty("$" + l[e].value), l[e].selected !== n && (l[e].selected = n), n && a && (l[e].defaultSelected = !0);
    } else {
      for (e = "" + vt(e), t = null, n = 0; n < l.length; n++) {
        if (l[n].value === e) {
          l[n].selected = !0, a && (l[n].defaultSelected = !0);
          return;
        }
        t !== null || l[n].disabled || (t = l[n]);
      }
      t !== null && (t.selected = !0);
    }
  }
  function Lf(l, t, e) {
    if (t != null && (t = "" + vt(t), t !== l.value && (l.value = t), e == null)) {
      l.defaultValue !== t && (l.defaultValue = t);
      return;
    }
    l.defaultValue = e != null ? "" + vt(e) : "";
  }
  function Vf(l, t, e, a) {
    if (t == null) {
      if (a != null) {
        if (e != null) throw Error(h(92));
        if (Ll(a)) {
          if (1 < a.length) throw Error(h(93));
          a = a[0];
        }
        e = a;
      }
      e == null && (e = ""), t = e;
    }
    e = vt(t), l.defaultValue = e, a = l.textContent, a === e && a !== "" && a !== null && (l.value = a), ii(l);
  }
  function Ie(l, t) {
    if (t) {
      var e = l.firstChild;
      if (e && e === l.lastChild && e.nodeType === 3) {
        e.nodeValue = t;
        return;
      }
    }
    l.textContent = t;
  }
  var uh = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function Kf(l, t, e) {
    var a = t.indexOf("--") === 0;
    e == null || typeof e == "boolean" || e === "" ? a ? l.setProperty(t, "") : t === "float" ? l.cssFloat = "" : l[t] = "" : a ? l.setProperty(t, e) : typeof e != "number" || e === 0 || uh.has(t) ? t === "float" ? l.cssFloat = e : l[t] = ("" + e).trim() : l[t] = e + "px";
  }
  function wf(l, t, e) {
    if (t != null && typeof t != "object")
      throw Error(h(62));
    if (l = l.style, e != null) {
      for (var a in e)
        !e.hasOwnProperty(a) || t != null && t.hasOwnProperty(a) || (a.indexOf("--") === 0 ? l.setProperty(a, "") : a === "float" ? l.cssFloat = "" : l[a] = "");
      for (var n in t)
        a = t[n], t.hasOwnProperty(n) && e[n] !== a && Kf(l, n, a);
    } else
      for (var u in t)
        t.hasOwnProperty(u) && Kf(l, u, t[u]);
  }
  function si(l) {
    if (l.indexOf("-") === -1) return !1;
    switch (l) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var ih = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), ch = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Bn(l) {
    return ch.test("" + l) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : l;
  }
  function Ht() {
  }
  var oi = null;
  function ri(l) {
    return l = l.target || l.srcElement || window, l.correspondingUseElement && (l = l.correspondingUseElement), l.nodeType === 3 ? l.parentNode : l;
  }
  var Pe = null, la = null;
  function Jf(l) {
    var t = ke(l);
    if (t && (l = t.stateNode)) {
      var e = l[Wl] || null;
      l: switch (l = t.stateNode, t.type) {
        case "input":
          if (ci(
            l,
            e.value,
            e.defaultValue,
            e.defaultValue,
            e.checked,
            e.defaultChecked,
            e.type,
            e.name
          ), t = e.name, e.type === "radio" && t != null) {
            for (e = l; e.parentNode; ) e = e.parentNode;
            for (e = e.querySelectorAll(
              'input[name="' + gt(
                "" + t
              ) + '"][type="radio"]'
            ), t = 0; t < e.length; t++) {
              var a = e[t];
              if (a !== l && a.form === l.form) {
                var n = a[Wl] || null;
                if (!n) throw Error(h(90));
                ci(
                  a,
                  n.value,
                  n.defaultValue,
                  n.defaultValue,
                  n.checked,
                  n.defaultChecked,
                  n.type,
                  n.name
                );
              }
            }
            for (t = 0; t < e.length; t++)
              a = e[t], a.form === l.form && Xf(a);
          }
          break l;
        case "textarea":
          Lf(l, e.value, e.defaultValue);
          break l;
        case "select":
          t = e.value, t != null && Fe(l, !!e.multiple, t, !1);
      }
    }
  }
  var di = !1;
  function kf(l, t, e) {
    if (di) return l(t, e);
    di = !0;
    try {
      var a = l(t);
      return a;
    } finally {
      if (di = !1, (Pe !== null || la !== null) && (zu(), Pe && (t = Pe, l = la, la = Pe = null, Jf(t), l)))
        for (t = 0; t < l.length; t++) Jf(l[t]);
    }
  }
  function Ya(l, t) {
    var e = l.stateNode;
    if (e === null) return null;
    var a = e[Wl] || null;
    if (a === null) return null;
    e = a[t];
    l: switch (t) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (a = !a.disabled) || (l = l.type, a = !(l === "button" || l === "input" || l === "select" || l === "textarea")), l = !a;
        break l;
      default:
        l = !1;
    }
    if (l) return null;
    if (e && typeof e != "function")
      throw Error(
        h(231, t, typeof e)
      );
    return e;
  }
  var qt = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), hi = !1;
  if (qt)
    try {
      var Ga = {};
      Object.defineProperty(Ga, "passive", {
        get: function() {
          hi = !0;
        }
      }), window.addEventListener("test", Ga, Ga), window.removeEventListener("test", Ga, Ga);
    } catch {
      hi = !1;
    }
  var te = null, mi = null, Yn = null;
  function Wf() {
    if (Yn) return Yn;
    var l, t = mi, e = t.length, a, n = "value" in te ? te.value : te.textContent, u = n.length;
    for (l = 0; l < e && t[l] === n[l]; l++) ;
    var i = e - l;
    for (a = 1; a <= i && t[e - a] === n[u - a]; a++) ;
    return Yn = n.slice(l, 1 < a ? 1 - a : void 0);
  }
  function Gn(l) {
    var t = l.keyCode;
    return "charCode" in l ? (l = l.charCode, l === 0 && t === 13 && (l = 13)) : l = t, l === 10 && (l = 13), 32 <= l || l === 13 ? l : 0;
  }
  function Qn() {
    return !0;
  }
  function $f() {
    return !1;
  }
  function $l(l) {
    function t(e, a, n, u, i) {
      this._reactName = e, this._targetInst = n, this.type = a, this.nativeEvent = u, this.target = i, this.currentTarget = null;
      for (var c in l)
        l.hasOwnProperty(c) && (e = l[c], this[c] = e ? e(u) : u[c]);
      return this.isDefaultPrevented = (u.defaultPrevented != null ? u.defaultPrevented : u.returnValue === !1) ? Qn : $f, this.isPropagationStopped = $f, this;
    }
    return R(t.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var e = this.nativeEvent;
        e && (e.preventDefault ? e.preventDefault() : typeof e.returnValue != "unknown" && (e.returnValue = !1), this.isDefaultPrevented = Qn);
      },
      stopPropagation: function() {
        var e = this.nativeEvent;
        e && (e.stopPropagation ? e.stopPropagation() : typeof e.cancelBubble != "unknown" && (e.cancelBubble = !0), this.isPropagationStopped = Qn);
      },
      persist: function() {
      },
      isPersistent: Qn
    }), t;
  }
  var Oe = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(l) {
      return l.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, Xn = $l(Oe), Qa = R({}, Oe, { view: 0, detail: 0 }), fh = $l(Qa), yi, vi, Xa, Zn = R({}, Qa, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: pi,
    button: 0,
    buttons: 0,
    relatedTarget: function(l) {
      return l.relatedTarget === void 0 ? l.fromElement === l.srcElement ? l.toElement : l.fromElement : l.relatedTarget;
    },
    movementX: function(l) {
      return "movementX" in l ? l.movementX : (l !== Xa && (Xa && l.type === "mousemove" ? (yi = l.screenX - Xa.screenX, vi = l.screenY - Xa.screenY) : vi = yi = 0, Xa = l), yi);
    },
    movementY: function(l) {
      return "movementY" in l ? l.movementY : vi;
    }
  }), Ff = $l(Zn), sh = R({}, Zn, { dataTransfer: 0 }), oh = $l(sh), rh = R({}, Qa, { relatedTarget: 0 }), gi = $l(rh), dh = R({}, Oe, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), hh = $l(dh), mh = R({}, Oe, {
    clipboardData: function(l) {
      return "clipboardData" in l ? l.clipboardData : window.clipboardData;
    }
  }), yh = $l(mh), vh = R({}, Oe, { data: 0 }), If = $l(vh), gh = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, ph = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, bh = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function Sh(l) {
    var t = this.nativeEvent;
    return t.getModifierState ? t.getModifierState(l) : (l = bh[l]) ? !!t[l] : !1;
  }
  function pi() {
    return Sh;
  }
  var Eh = R({}, Qa, {
    key: function(l) {
      if (l.key) {
        var t = gh[l.key] || l.key;
        if (t !== "Unidentified") return t;
      }
      return l.type === "keypress" ? (l = Gn(l), l === 13 ? "Enter" : String.fromCharCode(l)) : l.type === "keydown" || l.type === "keyup" ? ph[l.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: pi,
    charCode: function(l) {
      return l.type === "keypress" ? Gn(l) : 0;
    },
    keyCode: function(l) {
      return l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    },
    which: function(l) {
      return l.type === "keypress" ? Gn(l) : l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    }
  }), Ah = $l(Eh), Th = R({}, Zn, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), Pf = $l(Th), zh = R({}, Qa, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: pi
  }), _h = $l(zh), xh = R({}, Oe, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), jh = $l(xh), Oh = R({}, Zn, {
    deltaX: function(l) {
      return "deltaX" in l ? l.deltaX : "wheelDeltaX" in l ? -l.wheelDeltaX : 0;
    },
    deltaY: function(l) {
      return "deltaY" in l ? l.deltaY : "wheelDeltaY" in l ? -l.wheelDeltaY : "wheelDelta" in l ? -l.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Dh = $l(Oh), Mh = R({}, Oe, {
    newState: 0,
    oldState: 0
  }), Nh = $l(Mh), Uh = [9, 13, 27, 32], bi = qt && "CompositionEvent" in window, Za = null;
  qt && "documentMode" in document && (Za = document.documentMode);
  var Rh = qt && "TextEvent" in window && !Za, ls = qt && (!bi || Za && 8 < Za && 11 >= Za), ts = " ", es = !1;
  function as(l, t) {
    switch (l) {
      case "keyup":
        return Uh.indexOf(t.keyCode) !== -1;
      case "keydown":
        return t.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function ns(l) {
    return l = l.detail, typeof l == "object" && "data" in l ? l.data : null;
  }
  var ta = !1;
  function Ch(l, t) {
    switch (l) {
      case "compositionend":
        return ns(t);
      case "keypress":
        return t.which !== 32 ? null : (es = !0, ts);
      case "textInput":
        return l = t.data, l === ts && es ? null : l;
      default:
        return null;
    }
  }
  function Hh(l, t) {
    if (ta)
      return l === "compositionend" || !bi && as(l, t) ? (l = Wf(), Yn = mi = te = null, ta = !1, l) : null;
    switch (l) {
      case "paste":
        return null;
      case "keypress":
        if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
          if (t.char && 1 < t.char.length)
            return t.char;
          if (t.which) return String.fromCharCode(t.which);
        }
        return null;
      case "compositionend":
        return ls && t.locale !== "ko" ? null : t.data;
      default:
        return null;
    }
  }
  var qh = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function us(l) {
    var t = l && l.nodeName && l.nodeName.toLowerCase();
    return t === "input" ? !!qh[l.type] : t === "textarea";
  }
  function is(l, t, e, a) {
    Pe ? la ? la.push(a) : la = [a] : Pe = a, t = Nu(t, "onChange"), 0 < t.length && (e = new Xn(
      "onChange",
      "change",
      null,
      e,
      a
    ), l.push({ event: e, listeners: t }));
  }
  var La = null, Va = null;
  function Bh(l) {
    Lr(l, 0);
  }
  function Ln(l) {
    var t = Ba(l);
    if (Xf(t)) return l;
  }
  function cs(l, t) {
    if (l === "change") return t;
  }
  var fs = !1;
  if (qt) {
    var Si;
    if (qt) {
      var Ei = "oninput" in document;
      if (!Ei) {
        var ss = document.createElement("div");
        ss.setAttribute("oninput", "return;"), Ei = typeof ss.oninput == "function";
      }
      Si = Ei;
    } else Si = !1;
    fs = Si && (!document.documentMode || 9 < document.documentMode);
  }
  function os() {
    La && (La.detachEvent("onpropertychange", rs), Va = La = null);
  }
  function rs(l) {
    if (l.propertyName === "value" && Ln(Va)) {
      var t = [];
      is(
        t,
        Va,
        l,
        ri(l)
      ), kf(Bh, t);
    }
  }
  function Yh(l, t, e) {
    l === "focusin" ? (os(), La = t, Va = e, La.attachEvent("onpropertychange", rs)) : l === "focusout" && os();
  }
  function Gh(l) {
    if (l === "selectionchange" || l === "keyup" || l === "keydown")
      return Ln(Va);
  }
  function Qh(l, t) {
    if (l === "click") return Ln(t);
  }
  function Xh(l, t) {
    if (l === "input" || l === "change")
      return Ln(t);
  }
  function Zh(l, t) {
    return l === t && (l !== 0 || 1 / l === 1 / t) || l !== l && t !== t;
  }
  var it = typeof Object.is == "function" ? Object.is : Zh;
  function Ka(l, t) {
    if (it(l, t)) return !0;
    if (typeof l != "object" || l === null || typeof t != "object" || t === null)
      return !1;
    var e = Object.keys(l), a = Object.keys(t);
    if (e.length !== a.length) return !1;
    for (a = 0; a < e.length; a++) {
      var n = e[a];
      if (!Iu.call(t, n) || !it(l[n], t[n]))
        return !1;
    }
    return !0;
  }
  function ds(l) {
    for (; l && l.firstChild; ) l = l.firstChild;
    return l;
  }
  function hs(l, t) {
    var e = ds(l);
    l = 0;
    for (var a; e; ) {
      if (e.nodeType === 3) {
        if (a = l + e.textContent.length, l <= t && a >= t)
          return { node: e, offset: t - l };
        l = a;
      }
      l: {
        for (; e; ) {
          if (e.nextSibling) {
            e = e.nextSibling;
            break l;
          }
          e = e.parentNode;
        }
        e = void 0;
      }
      e = ds(e);
    }
  }
  function ms(l, t) {
    return l && t ? l === t ? !0 : l && l.nodeType === 3 ? !1 : t && t.nodeType === 3 ? ms(l, t.parentNode) : "contains" in l ? l.contains(t) : l.compareDocumentPosition ? !!(l.compareDocumentPosition(t) & 16) : !1 : !1;
  }
  function ys(l) {
    l = l != null && l.ownerDocument != null && l.ownerDocument.defaultView != null ? l.ownerDocument.defaultView : window;
    for (var t = qn(l.document); t instanceof l.HTMLIFrameElement; ) {
      try {
        var e = typeof t.contentWindow.location.href == "string";
      } catch {
        e = !1;
      }
      if (e) l = t.contentWindow;
      else break;
      t = qn(l.document);
    }
    return t;
  }
  function Ai(l) {
    var t = l && l.nodeName && l.nodeName.toLowerCase();
    return t && (t === "input" && (l.type === "text" || l.type === "search" || l.type === "tel" || l.type === "url" || l.type === "password") || t === "textarea" || l.contentEditable === "true");
  }
  var Lh = qt && "documentMode" in document && 11 >= document.documentMode, ea = null, Ti = null, wa = null, zi = !1;
  function vs(l, t, e) {
    var a = e.window === e ? e.document : e.nodeType === 9 ? e : e.ownerDocument;
    zi || ea == null || ea !== qn(a) || (a = ea, "selectionStart" in a && Ai(a) ? a = { start: a.selectionStart, end: a.selectionEnd } : (a = (a.ownerDocument && a.ownerDocument.defaultView || window).getSelection(), a = {
      anchorNode: a.anchorNode,
      anchorOffset: a.anchorOffset,
      focusNode: a.focusNode,
      focusOffset: a.focusOffset
    }), wa && Ka(wa, a) || (wa = a, a = Nu(Ti, "onSelect"), 0 < a.length && (t = new Xn(
      "onSelect",
      "select",
      null,
      t,
      e
    ), l.push({ event: t, listeners: a }), t.target = ea)));
  }
  function De(l, t) {
    var e = {};
    return e[l.toLowerCase()] = t.toLowerCase(), e["Webkit" + l] = "webkit" + t, e["Moz" + l] = "moz" + t, e;
  }
  var aa = {
    animationend: De("Animation", "AnimationEnd"),
    animationiteration: De("Animation", "AnimationIteration"),
    animationstart: De("Animation", "AnimationStart"),
    transitionrun: De("Transition", "TransitionRun"),
    transitionstart: De("Transition", "TransitionStart"),
    transitioncancel: De("Transition", "TransitionCancel"),
    transitionend: De("Transition", "TransitionEnd")
  }, _i = {}, gs = {};
  qt && (gs = document.createElement("div").style, "AnimationEvent" in window || (delete aa.animationend.animation, delete aa.animationiteration.animation, delete aa.animationstart.animation), "TransitionEvent" in window || delete aa.transitionend.transition);
  function Me(l) {
    if (_i[l]) return _i[l];
    if (!aa[l]) return l;
    var t = aa[l], e;
    for (e in t)
      if (t.hasOwnProperty(e) && e in gs)
        return _i[l] = t[e];
    return l;
  }
  var ps = Me("animationend"), bs = Me("animationiteration"), Ss = Me("animationstart"), Vh = Me("transitionrun"), Kh = Me("transitionstart"), wh = Me("transitioncancel"), Es = Me("transitionend"), As = /* @__PURE__ */ new Map(), xi = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  xi.push("scrollEnd");
  function xt(l, t) {
    As.set(l, t), je(t, [l]);
  }
  var Vn = typeof reportError == "function" ? reportError : function(l) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var t = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof l == "object" && l !== null && typeof l.message == "string" ? String(l.message) : String(l),
        error: l
      });
      if (!window.dispatchEvent(t)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", l);
      return;
    }
    console.error(l);
  }, pt = [], na = 0, ji = 0;
  function Kn() {
    for (var l = na, t = ji = na = 0; t < l; ) {
      var e = pt[t];
      pt[t++] = null;
      var a = pt[t];
      pt[t++] = null;
      var n = pt[t];
      pt[t++] = null;
      var u = pt[t];
      if (pt[t++] = null, a !== null && n !== null) {
        var i = a.pending;
        i === null ? n.next = n : (n.next = i.next, i.next = n), a.pending = n;
      }
      u !== 0 && Ts(e, n, u);
    }
  }
  function wn(l, t, e, a) {
    pt[na++] = l, pt[na++] = t, pt[na++] = e, pt[na++] = a, ji |= a, l.lanes |= a, l = l.alternate, l !== null && (l.lanes |= a);
  }
  function Oi(l, t, e, a) {
    return wn(l, t, e, a), Jn(l);
  }
  function Ne(l, t) {
    return wn(l, null, null, t), Jn(l);
  }
  function Ts(l, t, e) {
    l.lanes |= e;
    var a = l.alternate;
    a !== null && (a.lanes |= e);
    for (var n = !1, u = l.return; u !== null; )
      u.childLanes |= e, a = u.alternate, a !== null && (a.childLanes |= e), u.tag === 22 && (l = u.stateNode, l === null || l._visibility & 1 || (n = !0)), l = u, u = u.return;
    return l.tag === 3 ? (u = l.stateNode, n && t !== null && (n = 31 - ut(e), l = u.hiddenUpdates, a = l[n], a === null ? l[n] = [t] : a.push(t), t.lane = e | 536870912), u) : null;
  }
  function Jn(l) {
    if (50 < yn)
      throw yn = 0, Bc = null, Error(h(185));
    for (var t = l.return; t !== null; )
      l = t, t = l.return;
    return l.tag === 3 ? l.stateNode : null;
  }
  var ua = {};
  function Jh(l, t, e, a) {
    this.tag = l, this.key = e, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = a, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function ct(l, t, e, a) {
    return new Jh(l, t, e, a);
  }
  function Di(l) {
    return l = l.prototype, !(!l || !l.isReactComponent);
  }
  function Bt(l, t) {
    var e = l.alternate;
    return e === null ? (e = ct(
      l.tag,
      t,
      l.key,
      l.mode
    ), e.elementType = l.elementType, e.type = l.type, e.stateNode = l.stateNode, e.alternate = l, l.alternate = e) : (e.pendingProps = t, e.type = l.type, e.flags = 0, e.subtreeFlags = 0, e.deletions = null), e.flags = l.flags & 65011712, e.childLanes = l.childLanes, e.lanes = l.lanes, e.child = l.child, e.memoizedProps = l.memoizedProps, e.memoizedState = l.memoizedState, e.updateQueue = l.updateQueue, t = l.dependencies, e.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }, e.sibling = l.sibling, e.index = l.index, e.ref = l.ref, e.refCleanup = l.refCleanup, e;
  }
  function zs(l, t) {
    l.flags &= 65011714;
    var e = l.alternate;
    return e === null ? (l.childLanes = 0, l.lanes = t, l.child = null, l.subtreeFlags = 0, l.memoizedProps = null, l.memoizedState = null, l.updateQueue = null, l.dependencies = null, l.stateNode = null) : (l.childLanes = e.childLanes, l.lanes = e.lanes, l.child = e.child, l.subtreeFlags = 0, l.deletions = null, l.memoizedProps = e.memoizedProps, l.memoizedState = e.memoizedState, l.updateQueue = e.updateQueue, l.type = e.type, t = e.dependencies, l.dependencies = t === null ? null : {
      lanes: t.lanes,
      firstContext: t.firstContext
    }), l;
  }
  function kn(l, t, e, a, n, u) {
    var i = 0;
    if (a = l, typeof l == "function") Di(l) && (i = 1);
    else if (typeof l == "string")
      i = Im(
        l,
        e,
        M.current
      ) ? 26 : l === "html" || l === "head" || l === "body" ? 27 : 5;
    else
      l: switch (l) {
        case kl:
          return l = ct(31, e, t, n), l.elementType = kl, l.lanes = u, l;
        case Ml:
          return Ue(e.children, n, u, t);
        case ht:
          i = 8, n |= 24;
          break;
        case Xl:
          return l = ct(12, e, t, n | 2), l.elementType = Xl, l.lanes = u, l;
        case et:
          return l = ct(13, e, t, n), l.elementType = et, l.lanes = u, l;
        case Hl:
          return l = ct(19, e, t, n), l.elementType = Hl, l.lanes = u, l;
        default:
          if (typeof l == "object" && l !== null)
            switch (l.$$typeof) {
              case Tl:
                i = 10;
                break l;
              case mt:
                i = 9;
                break l;
              case Jl:
                i = 11;
                break l;
              case V:
                i = 14;
                break l;
              case Ol:
                i = 16, a = null;
                break l;
            }
          i = 29, e = Error(
            h(130, l === null ? "null" : typeof l, "")
          ), a = null;
      }
    return t = ct(i, e, t, n), t.elementType = l, t.type = a, t.lanes = u, t;
  }
  function Ue(l, t, e, a) {
    return l = ct(7, l, a, t), l.lanes = e, l;
  }
  function Mi(l, t, e) {
    return l = ct(6, l, null, t), l.lanes = e, l;
  }
  function _s(l) {
    var t = ct(18, null, null, 0);
    return t.stateNode = l, t;
  }
  function Ni(l, t, e) {
    return t = ct(
      4,
      l.children !== null ? l.children : [],
      l.key,
      t
    ), t.lanes = e, t.stateNode = {
      containerInfo: l.containerInfo,
      pendingChildren: null,
      implementation: l.implementation
    }, t;
  }
  var xs = /* @__PURE__ */ new WeakMap();
  function bt(l, t) {
    if (typeof l == "object" && l !== null) {
      var e = xs.get(l);
      return e !== void 0 ? e : (t = {
        value: l,
        source: t,
        stack: _f(t)
      }, xs.set(l, t), t);
    }
    return {
      value: l,
      source: t,
      stack: _f(t)
    };
  }
  var ia = [], ca = 0, Wn = null, Ja = 0, St = [], Et = 0, ee = null, Mt = 1, Nt = "";
  function Yt(l, t) {
    ia[ca++] = Ja, ia[ca++] = Wn, Wn = l, Ja = t;
  }
  function js(l, t, e) {
    St[Et++] = Mt, St[Et++] = Nt, St[Et++] = ee, ee = l;
    var a = Mt;
    l = Nt;
    var n = 32 - ut(a) - 1;
    a &= ~(1 << n), e += 1;
    var u = 32 - ut(t) + n;
    if (30 < u) {
      var i = n - n % 5;
      u = (a & (1 << i) - 1).toString(32), a >>= i, n -= i, Mt = 1 << 32 - ut(t) + n | e << n | a, Nt = u + l;
    } else
      Mt = 1 << u | e << n | a, Nt = l;
  }
  function Ui(l) {
    l.return !== null && (Yt(l, 1), js(l, 1, 0));
  }
  function Ri(l) {
    for (; l === Wn; )
      Wn = ia[--ca], ia[ca] = null, Ja = ia[--ca], ia[ca] = null;
    for (; l === ee; )
      ee = St[--Et], St[Et] = null, Nt = St[--Et], St[Et] = null, Mt = St[--Et], St[Et] = null;
  }
  function Os(l, t) {
    St[Et++] = Mt, St[Et++] = Nt, St[Et++] = ee, Mt = t.id, Nt = t.overflow, ee = l;
  }
  var Bl = null, ml = null, F = !1, ae = null, At = !1, Ci = Error(h(519));
  function ne(l) {
    var t = Error(
      h(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw ka(bt(t, l)), Ci;
  }
  function Ds(l) {
    var t = l.stateNode, e = l.type, a = l.memoizedProps;
    switch (t[ql] = l, t[Wl] = a, e) {
      case "dialog":
        J("cancel", t), J("close", t);
        break;
      case "iframe":
      case "object":
      case "embed":
        J("load", t);
        break;
      case "video":
      case "audio":
        for (e = 0; e < gn.length; e++)
          J(gn[e], t);
        break;
      case "source":
        J("error", t);
        break;
      case "img":
      case "image":
      case "link":
        J("error", t), J("load", t);
        break;
      case "details":
        J("toggle", t);
        break;
      case "input":
        J("invalid", t), Zf(
          t,
          a.value,
          a.defaultValue,
          a.checked,
          a.defaultChecked,
          a.type,
          a.name,
          !0
        );
        break;
      case "select":
        J("invalid", t);
        break;
      case "textarea":
        J("invalid", t), Vf(t, a.value, a.defaultValue, a.children);
    }
    e = a.children, typeof e != "string" && typeof e != "number" && typeof e != "bigint" || t.textContent === "" + e || a.suppressHydrationWarning === !0 || Jr(t.textContent, e) ? (a.popover != null && (J("beforetoggle", t), J("toggle", t)), a.onScroll != null && J("scroll", t), a.onScrollEnd != null && J("scrollend", t), a.onClick != null && (t.onclick = Ht), t = !0) : t = !1, t || ne(l, !0);
  }
  function Ms(l) {
    for (Bl = l.return; Bl; )
      switch (Bl.tag) {
        case 5:
        case 31:
        case 13:
          At = !1;
          return;
        case 27:
        case 3:
          At = !0;
          return;
        default:
          Bl = Bl.return;
      }
  }
  function fa(l) {
    if (l !== Bl) return !1;
    if (!F) return Ms(l), F = !0, !1;
    var t = l.tag, e;
    if ((e = t !== 3 && t !== 27) && ((e = t === 5) && (e = l.type, e = !(e !== "form" && e !== "button") || Ic(l.type, l.memoizedProps)), e = !e), e && ml && ne(l), Ms(l), t === 13) {
      if (l = l.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(h(317));
      ml = ed(l);
    } else if (t === 31) {
      if (l = l.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(h(317));
      ml = ed(l);
    } else
      t === 27 ? (t = ml, pe(l.type) ? (l = af, af = null, ml = l) : ml = t) : ml = Bl ? zt(l.stateNode.nextSibling) : null;
    return !0;
  }
  function Re() {
    ml = Bl = null, F = !1;
  }
  function Hi() {
    var l = ae;
    return l !== null && (lt === null ? lt = l : lt.push.apply(
      lt,
      l
    ), ae = null), l;
  }
  function ka(l) {
    ae === null ? ae = [l] : ae.push(l);
  }
  var qi = r(null), Ce = null, Gt = null;
  function ue(l, t, e) {
    x(qi, t._currentValue), t._currentValue = e;
  }
  function Qt(l) {
    l._currentValue = qi.current, z(qi);
  }
  function Bi(l, t, e) {
    for (; l !== null; ) {
      var a = l.alternate;
      if ((l.childLanes & t) !== t ? (l.childLanes |= t, a !== null && (a.childLanes |= t)) : a !== null && (a.childLanes & t) !== t && (a.childLanes |= t), l === e) break;
      l = l.return;
    }
  }
  function Yi(l, t, e, a) {
    var n = l.child;
    for (n !== null && (n.return = l); n !== null; ) {
      var u = n.dependencies;
      if (u !== null) {
        var i = n.child;
        u = u.firstContext;
        l: for (; u !== null; ) {
          var c = u;
          u = n;
          for (var s = 0; s < t.length; s++)
            if (c.context === t[s]) {
              u.lanes |= e, c = u.alternate, c !== null && (c.lanes |= e), Bi(
                u.return,
                e,
                l
              ), a || (i = null);
              break l;
            }
          u = c.next;
        }
      } else if (n.tag === 18) {
        if (i = n.return, i === null) throw Error(h(341));
        i.lanes |= e, u = i.alternate, u !== null && (u.lanes |= e), Bi(i, e, l), i = null;
      } else i = n.child;
      if (i !== null) i.return = n;
      else
        for (i = n; i !== null; ) {
          if (i === l) {
            i = null;
            break;
          }
          if (n = i.sibling, n !== null) {
            n.return = i.return, i = n;
            break;
          }
          i = i.return;
        }
      n = i;
    }
  }
  function sa(l, t, e, a) {
    l = null;
    for (var n = t, u = !1; n !== null; ) {
      if (!u) {
        if ((n.flags & 524288) !== 0) u = !0;
        else if ((n.flags & 262144) !== 0) break;
      }
      if (n.tag === 10) {
        var i = n.alternate;
        if (i === null) throw Error(h(387));
        if (i = i.memoizedProps, i !== null) {
          var c = n.type;
          it(n.pendingProps.value, i.value) || (l !== null ? l.push(c) : l = [c]);
        }
      } else if (n === el.current) {
        if (i = n.alternate, i === null) throw Error(h(387));
        i.memoizedState.memoizedState !== n.memoizedState.memoizedState && (l !== null ? l.push(An) : l = [An]);
      }
      n = n.return;
    }
    l !== null && Yi(
      t,
      l,
      e,
      a
    ), t.flags |= 262144;
  }
  function $n(l) {
    for (l = l.firstContext; l !== null; ) {
      if (!it(
        l.context._currentValue,
        l.memoizedValue
      ))
        return !0;
      l = l.next;
    }
    return !1;
  }
  function He(l) {
    Ce = l, Gt = null, l = l.dependencies, l !== null && (l.firstContext = null);
  }
  function Yl(l) {
    return Ns(Ce, l);
  }
  function Fn(l, t) {
    return Ce === null && He(l), Ns(l, t);
  }
  function Ns(l, t) {
    var e = t._currentValue;
    if (t = { context: t, memoizedValue: e, next: null }, Gt === null) {
      if (l === null) throw Error(h(308));
      Gt = t, l.dependencies = { lanes: 0, firstContext: t }, l.flags |= 524288;
    } else Gt = Gt.next = t;
    return e;
  }
  var kh = typeof AbortController < "u" ? AbortController : function() {
    var l = [], t = this.signal = {
      aborted: !1,
      addEventListener: function(e, a) {
        l.push(a);
      }
    };
    this.abort = function() {
      t.aborted = !0, l.forEach(function(e) {
        return e();
      });
    };
  }, Wh = S.unstable_scheduleCallback, $h = S.unstable_NormalPriority, zl = {
    $$typeof: Tl,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function Gi() {
    return {
      controller: new kh(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function Wa(l) {
    l.refCount--, l.refCount === 0 && Wh($h, function() {
      l.controller.abort();
    });
  }
  var $a = null, Qi = 0, oa = 0, ra = null;
  function Fh(l, t) {
    if ($a === null) {
      var e = $a = [];
      Qi = 0, oa = Lc(), ra = {
        status: "pending",
        value: void 0,
        then: function(a) {
          e.push(a);
        }
      };
    }
    return Qi++, t.then(Us, Us), t;
  }
  function Us() {
    if (--Qi === 0 && $a !== null) {
      ra !== null && (ra.status = "fulfilled");
      var l = $a;
      $a = null, oa = 0, ra = null;
      for (var t = 0; t < l.length; t++) (0, l[t])();
    }
  }
  function Ih(l, t) {
    var e = [], a = {
      status: "pending",
      value: null,
      reason: null,
      then: function(n) {
        e.push(n);
      }
    };
    return l.then(
      function() {
        a.status = "fulfilled", a.value = t;
        for (var n = 0; n < e.length; n++) (0, e[n])(t);
      },
      function(n) {
        for (a.status = "rejected", a.reason = n, n = 0; n < e.length; n++)
          (0, e[n])(void 0);
      }
    ), a;
  }
  var Rs = b.S;
  b.S = function(l, t) {
    gr = at(), typeof t == "object" && t !== null && typeof t.then == "function" && Fh(l, t), Rs !== null && Rs(l, t);
  };
  var qe = r(null);
  function Xi() {
    var l = qe.current;
    return l !== null ? l : rl.pooledCache;
  }
  function In(l, t) {
    t === null ? x(qe, qe.current) : x(qe, t.pool);
  }
  function Cs() {
    var l = Xi();
    return l === null ? null : { parent: zl._currentValue, pool: l };
  }
  var da = Error(h(460)), Zi = Error(h(474)), Pn = Error(h(542)), lu = { then: function() {
  } };
  function Hs(l) {
    return l = l.status, l === "fulfilled" || l === "rejected";
  }
  function qs(l, t, e) {
    switch (e = l[e], e === void 0 ? l.push(t) : e !== t && (t.then(Ht, Ht), t = e), t.status) {
      case "fulfilled":
        return t.value;
      case "rejected":
        throw l = t.reason, Ys(l), l;
      default:
        if (typeof t.status == "string") t.then(Ht, Ht);
        else {
          if (l = rl, l !== null && 100 < l.shellSuspendCounter)
            throw Error(h(482));
          l = t, l.status = "pending", l.then(
            function(a) {
              if (t.status === "pending") {
                var n = t;
                n.status = "fulfilled", n.value = a;
              }
            },
            function(a) {
              if (t.status === "pending") {
                var n = t;
                n.status = "rejected", n.reason = a;
              }
            }
          );
        }
        switch (t.status) {
          case "fulfilled":
            return t.value;
          case "rejected":
            throw l = t.reason, Ys(l), l;
        }
        throw Ye = t, da;
    }
  }
  function Be(l) {
    try {
      var t = l._init;
      return t(l._payload);
    } catch (e) {
      throw e !== null && typeof e == "object" && typeof e.then == "function" ? (Ye = e, da) : e;
    }
  }
  var Ye = null;
  function Bs() {
    if (Ye === null) throw Error(h(459));
    var l = Ye;
    return Ye = null, l;
  }
  function Ys(l) {
    if (l === da || l === Pn)
      throw Error(h(483));
  }
  var ha = null, Fa = 0;
  function tu(l) {
    var t = Fa;
    return Fa += 1, ha === null && (ha = []), qs(ha, l, t);
  }
  function Ia(l, t) {
    t = t.props.ref, l.ref = t !== void 0 ? t : null;
  }
  function eu(l, t) {
    throw t.$$typeof === dl ? Error(h(525)) : (l = Object.prototype.toString.call(t), Error(
      h(
        31,
        l === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : l
      )
    ));
  }
  function Gs(l) {
    function t(d, o) {
      if (l) {
        var m = d.deletions;
        m === null ? (d.deletions = [o], d.flags |= 16) : m.push(o);
      }
    }
    function e(d, o) {
      if (!l) return null;
      for (; o !== null; )
        t(d, o), o = o.sibling;
      return null;
    }
    function a(d) {
      for (var o = /* @__PURE__ */ new Map(); d !== null; )
        d.key !== null ? o.set(d.key, d) : o.set(d.index, d), d = d.sibling;
      return o;
    }
    function n(d, o) {
      return d = Bt(d, o), d.index = 0, d.sibling = null, d;
    }
    function u(d, o, m) {
      return d.index = m, l ? (m = d.alternate, m !== null ? (m = m.index, m < o ? (d.flags |= 67108866, o) : m) : (d.flags |= 67108866, o)) : (d.flags |= 1048576, o);
    }
    function i(d) {
      return l && d.alternate === null && (d.flags |= 67108866), d;
    }
    function c(d, o, m, E) {
      return o === null || o.tag !== 6 ? (o = Mi(m, d.mode, E), o.return = d, o) : (o = n(o, m), o.return = d, o);
    }
    function s(d, o, m, E) {
      var C = m.type;
      return C === Ml ? p(
        d,
        o,
        m.props.children,
        E,
        m.key
      ) : o !== null && (o.elementType === C || typeof C == "object" && C !== null && C.$$typeof === Ol && Be(C) === o.type) ? (o = n(o, m.props), Ia(o, m), o.return = d, o) : (o = kn(
        m.type,
        m.key,
        m.props,
        null,
        d.mode,
        E
      ), Ia(o, m), o.return = d, o);
    }
    function y(d, o, m, E) {
      return o === null || o.tag !== 4 || o.stateNode.containerInfo !== m.containerInfo || o.stateNode.implementation !== m.implementation ? (o = Ni(m, d.mode, E), o.return = d, o) : (o = n(o, m.children || []), o.return = d, o);
    }
    function p(d, o, m, E, C) {
      return o === null || o.tag !== 7 ? (o = Ue(
        m,
        d.mode,
        E,
        C
      ), o.return = d, o) : (o = n(o, m), o.return = d, o);
    }
    function A(d, o, m) {
      if (typeof o == "string" && o !== "" || typeof o == "number" || typeof o == "bigint")
        return o = Mi(
          "" + o,
          d.mode,
          m
        ), o.return = d, o;
      if (typeof o == "object" && o !== null) {
        switch (o.$$typeof) {
          case Rl:
            return m = kn(
              o.type,
              o.key,
              o.props,
              null,
              d.mode,
              m
            ), Ia(m, o), m.return = d, m;
          case Cl:
            return o = Ni(
              o,
              d.mode,
              m
            ), o.return = d, o;
          case Ol:
            return o = Be(o), A(d, o, m);
        }
        if (Ll(o) || H(o))
          return o = Ue(
            o,
            d.mode,
            m,
            null
          ), o.return = d, o;
        if (typeof o.then == "function")
          return A(d, tu(o), m);
        if (o.$$typeof === Tl)
          return A(
            d,
            Fn(d, o),
            m
          );
        eu(d, o);
      }
      return null;
    }
    function v(d, o, m, E) {
      var C = o !== null ? o.key : null;
      if (typeof m == "string" && m !== "" || typeof m == "number" || typeof m == "bigint")
        return C !== null ? null : c(d, o, "" + m, E);
      if (typeof m == "object" && m !== null) {
        switch (m.$$typeof) {
          case Rl:
            return m.key === C ? s(d, o, m, E) : null;
          case Cl:
            return m.key === C ? y(d, o, m, E) : null;
          case Ol:
            return m = Be(m), v(d, o, m, E);
        }
        if (Ll(m) || H(m))
          return C !== null ? null : p(d, o, m, E, null);
        if (typeof m.then == "function")
          return v(
            d,
            o,
            tu(m),
            E
          );
        if (m.$$typeof === Tl)
          return v(
            d,
            o,
            Fn(d, m),
            E
          );
        eu(d, m);
      }
      return null;
    }
    function g(d, o, m, E, C) {
      if (typeof E == "string" && E !== "" || typeof E == "number" || typeof E == "bigint")
        return d = d.get(m) || null, c(o, d, "" + E, C);
      if (typeof E == "object" && E !== null) {
        switch (E.$$typeof) {
          case Rl:
            return d = d.get(
              E.key === null ? m : E.key
            ) || null, s(o, d, E, C);
          case Cl:
            return d = d.get(
              E.key === null ? m : E.key
            ) || null, y(o, d, E, C);
          case Ol:
            return E = Be(E), g(
              d,
              o,
              m,
              E,
              C
            );
        }
        if (Ll(E) || H(E))
          return d = d.get(m) || null, p(o, d, E, C, null);
        if (typeof E.then == "function")
          return g(
            d,
            o,
            m,
            tu(E),
            C
          );
        if (E.$$typeof === Tl)
          return g(
            d,
            o,
            m,
            Fn(o, E),
            C
          );
        eu(o, E);
      }
      return null;
    }
    function D(d, o, m, E) {
      for (var C = null, I = null, N = o, Z = o = 0, W = null; N !== null && Z < m.length; Z++) {
        N.index > Z ? (W = N, N = null) : W = N.sibling;
        var P = v(
          d,
          N,
          m[Z],
          E
        );
        if (P === null) {
          N === null && (N = W);
          break;
        }
        l && N && P.alternate === null && t(d, N), o = u(P, o, Z), I === null ? C = P : I.sibling = P, I = P, N = W;
      }
      if (Z === m.length)
        return e(d, N), F && Yt(d, Z), C;
      if (N === null) {
        for (; Z < m.length; Z++)
          N = A(d, m[Z], E), N !== null && (o = u(
            N,
            o,
            Z
          ), I === null ? C = N : I.sibling = N, I = N);
        return F && Yt(d, Z), C;
      }
      for (N = a(N); Z < m.length; Z++)
        W = g(
          N,
          d,
          Z,
          m[Z],
          E
        ), W !== null && (l && W.alternate !== null && N.delete(
          W.key === null ? Z : W.key
        ), o = u(
          W,
          o,
          Z
        ), I === null ? C = W : I.sibling = W, I = W);
      return l && N.forEach(function(Te) {
        return t(d, Te);
      }), F && Yt(d, Z), C;
    }
    function q(d, o, m, E) {
      if (m == null) throw Error(h(151));
      for (var C = null, I = null, N = o, Z = o = 0, W = null, P = m.next(); N !== null && !P.done; Z++, P = m.next()) {
        N.index > Z ? (W = N, N = null) : W = N.sibling;
        var Te = v(d, N, P.value, E);
        if (Te === null) {
          N === null && (N = W);
          break;
        }
        l && N && Te.alternate === null && t(d, N), o = u(Te, o, Z), I === null ? C = Te : I.sibling = Te, I = Te, N = W;
      }
      if (P.done)
        return e(d, N), F && Yt(d, Z), C;
      if (N === null) {
        for (; !P.done; Z++, P = m.next())
          P = A(d, P.value, E), P !== null && (o = u(P, o, Z), I === null ? C = P : I.sibling = P, I = P);
        return F && Yt(d, Z), C;
      }
      for (N = a(N); !P.done; Z++, P = m.next())
        P = g(N, d, Z, P.value, E), P !== null && (l && P.alternate !== null && N.delete(P.key === null ? Z : P.key), o = u(P, o, Z), I === null ? C = P : I.sibling = P, I = P);
      return l && N.forEach(function(sy) {
        return t(d, sy);
      }), F && Yt(d, Z), C;
    }
    function fl(d, o, m, E) {
      if (typeof m == "object" && m !== null && m.type === Ml && m.key === null && (m = m.props.children), typeof m == "object" && m !== null) {
        switch (m.$$typeof) {
          case Rl:
            l: {
              for (var C = m.key; o !== null; ) {
                if (o.key === C) {
                  if (C = m.type, C === Ml) {
                    if (o.tag === 7) {
                      e(
                        d,
                        o.sibling
                      ), E = n(
                        o,
                        m.props.children
                      ), E.return = d, d = E;
                      break l;
                    }
                  } else if (o.elementType === C || typeof C == "object" && C !== null && C.$$typeof === Ol && Be(C) === o.type) {
                    e(
                      d,
                      o.sibling
                    ), E = n(o, m.props), Ia(E, m), E.return = d, d = E;
                    break l;
                  }
                  e(d, o);
                  break;
                } else t(d, o);
                o = o.sibling;
              }
              m.type === Ml ? (E = Ue(
                m.props.children,
                d.mode,
                E,
                m.key
              ), E.return = d, d = E) : (E = kn(
                m.type,
                m.key,
                m.props,
                null,
                d.mode,
                E
              ), Ia(E, m), E.return = d, d = E);
            }
            return i(d);
          case Cl:
            l: {
              for (C = m.key; o !== null; ) {
                if (o.key === C)
                  if (o.tag === 4 && o.stateNode.containerInfo === m.containerInfo && o.stateNode.implementation === m.implementation) {
                    e(
                      d,
                      o.sibling
                    ), E = n(o, m.children || []), E.return = d, d = E;
                    break l;
                  } else {
                    e(d, o);
                    break;
                  }
                else t(d, o);
                o = o.sibling;
              }
              E = Ni(m, d.mode, E), E.return = d, d = E;
            }
            return i(d);
          case Ol:
            return m = Be(m), fl(
              d,
              o,
              m,
              E
            );
        }
        if (Ll(m))
          return D(
            d,
            o,
            m,
            E
          );
        if (H(m)) {
          if (C = H(m), typeof C != "function") throw Error(h(150));
          return m = C.call(m), q(
            d,
            o,
            m,
            E
          );
        }
        if (typeof m.then == "function")
          return fl(
            d,
            o,
            tu(m),
            E
          );
        if (m.$$typeof === Tl)
          return fl(
            d,
            o,
            Fn(d, m),
            E
          );
        eu(d, m);
      }
      return typeof m == "string" && m !== "" || typeof m == "number" || typeof m == "bigint" ? (m = "" + m, o !== null && o.tag === 6 ? (e(d, o.sibling), E = n(o, m), E.return = d, d = E) : (e(d, o), E = Mi(m, d.mode, E), E.return = d, d = E), i(d)) : e(d, o);
    }
    return function(d, o, m, E) {
      try {
        Fa = 0;
        var C = fl(
          d,
          o,
          m,
          E
        );
        return ha = null, C;
      } catch (N) {
        if (N === da || N === Pn) throw N;
        var I = ct(29, N, null, d.mode);
        return I.lanes = E, I.return = d, I;
      }
    };
  }
  var Ge = Gs(!0), Qs = Gs(!1), ie = !1;
  function Li(l) {
    l.updateQueue = {
      baseState: l.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function Vi(l, t) {
    l = l.updateQueue, t.updateQueue === l && (t.updateQueue = {
      baseState: l.baseState,
      firstBaseUpdate: l.firstBaseUpdate,
      lastBaseUpdate: l.lastBaseUpdate,
      shared: l.shared,
      callbacks: null
    });
  }
  function ce(l) {
    return { lane: l, tag: 0, payload: null, callback: null, next: null };
  }
  function fe(l, t, e) {
    var a = l.updateQueue;
    if (a === null) return null;
    if (a = a.shared, (tl & 2) !== 0) {
      var n = a.pending;
      return n === null ? t.next = t : (t.next = n.next, n.next = t), a.pending = t, t = Jn(l), Ts(l, null, e), t;
    }
    return wn(l, a, t, e), Jn(l);
  }
  function Pa(l, t, e) {
    if (t = t.updateQueue, t !== null && (t = t.shared, (e & 4194048) !== 0)) {
      var a = t.lanes;
      a &= l.pendingLanes, e |= a, t.lanes = e, Nf(l, e);
    }
  }
  function Ki(l, t) {
    var e = l.updateQueue, a = l.alternate;
    if (a !== null && (a = a.updateQueue, e === a)) {
      var n = null, u = null;
      if (e = e.firstBaseUpdate, e !== null) {
        do {
          var i = {
            lane: e.lane,
            tag: e.tag,
            payload: e.payload,
            callback: null,
            next: null
          };
          u === null ? n = u = i : u = u.next = i, e = e.next;
        } while (e !== null);
        u === null ? n = u = t : u = u.next = t;
      } else n = u = t;
      e = {
        baseState: a.baseState,
        firstBaseUpdate: n,
        lastBaseUpdate: u,
        shared: a.shared,
        callbacks: a.callbacks
      }, l.updateQueue = e;
      return;
    }
    l = e.lastBaseUpdate, l === null ? e.firstBaseUpdate = t : l.next = t, e.lastBaseUpdate = t;
  }
  var wi = !1;
  function ln() {
    if (wi) {
      var l = ra;
      if (l !== null) throw l;
    }
  }
  function tn(l, t, e, a) {
    wi = !1;
    var n = l.updateQueue;
    ie = !1;
    var u = n.firstBaseUpdate, i = n.lastBaseUpdate, c = n.shared.pending;
    if (c !== null) {
      n.shared.pending = null;
      var s = c, y = s.next;
      s.next = null, i === null ? u = y : i.next = y, i = s;
      var p = l.alternate;
      p !== null && (p = p.updateQueue, c = p.lastBaseUpdate, c !== i && (c === null ? p.firstBaseUpdate = y : c.next = y, p.lastBaseUpdate = s));
    }
    if (u !== null) {
      var A = n.baseState;
      i = 0, p = y = s = null, c = u;
      do {
        var v = c.lane & -536870913, g = v !== c.lane;
        if (g ? (k & v) === v : (a & v) === v) {
          v !== 0 && v === oa && (wi = !0), p !== null && (p = p.next = {
            lane: 0,
            tag: c.tag,
            payload: c.payload,
            callback: null,
            next: null
          });
          l: {
            var D = l, q = c;
            v = t;
            var fl = e;
            switch (q.tag) {
              case 1:
                if (D = q.payload, typeof D == "function") {
                  A = D.call(fl, A, v);
                  break l;
                }
                A = D;
                break l;
              case 3:
                D.flags = D.flags & -65537 | 128;
              case 0:
                if (D = q.payload, v = typeof D == "function" ? D.call(fl, A, v) : D, v == null) break l;
                A = R({}, A, v);
                break l;
              case 2:
                ie = !0;
            }
          }
          v = c.callback, v !== null && (l.flags |= 64, g && (l.flags |= 8192), g = n.callbacks, g === null ? n.callbacks = [v] : g.push(v));
        } else
          g = {
            lane: v,
            tag: c.tag,
            payload: c.payload,
            callback: c.callback,
            next: null
          }, p === null ? (y = p = g, s = A) : p = p.next = g, i |= v;
        if (c = c.next, c === null) {
          if (c = n.shared.pending, c === null)
            break;
          g = c, c = g.next, g.next = null, n.lastBaseUpdate = g, n.shared.pending = null;
        }
      } while (!0);
      p === null && (s = A), n.baseState = s, n.firstBaseUpdate = y, n.lastBaseUpdate = p, u === null && (n.shared.lanes = 0), he |= i, l.lanes = i, l.memoizedState = A;
    }
  }
  function Xs(l, t) {
    if (typeof l != "function")
      throw Error(h(191, l));
    l.call(t);
  }
  function Zs(l, t) {
    var e = l.callbacks;
    if (e !== null)
      for (l.callbacks = null, l = 0; l < e.length; l++)
        Xs(e[l], t);
  }
  var ma = r(null), au = r(0);
  function Ls(l, t) {
    l = Wt, x(au, l), x(ma, t), Wt = l | t.baseLanes;
  }
  function Ji() {
    x(au, Wt), x(ma, ma.current);
  }
  function ki() {
    Wt = au.current, z(ma), z(au);
  }
  var ft = r(null), Tt = null;
  function se(l) {
    var t = l.alternate;
    x(El, El.current & 1), x(ft, l), Tt === null && (t === null || ma.current !== null || t.memoizedState !== null) && (Tt = l);
  }
  function Wi(l) {
    x(El, El.current), x(ft, l), Tt === null && (Tt = l);
  }
  function Vs(l) {
    l.tag === 22 ? (x(El, El.current), x(ft, l), Tt === null && (Tt = l)) : oe();
  }
  function oe() {
    x(El, El.current), x(ft, ft.current);
  }
  function st(l) {
    z(ft), Tt === l && (Tt = null), z(El);
  }
  var El = r(0);
  function nu(l) {
    for (var t = l; t !== null; ) {
      if (t.tag === 13) {
        var e = t.memoizedState;
        if (e !== null && (e = e.dehydrated, e === null || tf(e) || ef(e)))
          return t;
      } else if (t.tag === 19 && (t.memoizedProps.revealOrder === "forwards" || t.memoizedProps.revealOrder === "backwards" || t.memoizedProps.revealOrder === "unstable_legacy-backwards" || t.memoizedProps.revealOrder === "together")) {
        if ((t.flags & 128) !== 0) return t;
      } else if (t.child !== null) {
        t.child.return = t, t = t.child;
        continue;
      }
      if (t === l) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === l) return null;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
    return null;
  }
  var Xt = 0, X = null, il = null, _l = null, uu = !1, ya = !1, Qe = !1, iu = 0, en = 0, va = null, Ph = 0;
  function pl() {
    throw Error(h(321));
  }
  function $i(l, t) {
    if (t === null) return !1;
    for (var e = 0; e < t.length && e < l.length; e++)
      if (!it(l[e], t[e])) return !1;
    return !0;
  }
  function Fi(l, t, e, a, n, u) {
    return Xt = u, X = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, b.H = l === null || l.memoizedState === null ? Oo : dc, Qe = !1, u = e(a, n), Qe = !1, ya && (u = ws(
      t,
      e,
      a,
      n
    )), Ks(l), u;
  }
  function Ks(l) {
    b.H = un;
    var t = il !== null && il.next !== null;
    if (Xt = 0, _l = il = X = null, uu = !1, en = 0, va = null, t) throw Error(h(300));
    l === null || xl || (l = l.dependencies, l !== null && $n(l) && (xl = !0));
  }
  function ws(l, t, e, a) {
    X = l;
    var n = 0;
    do {
      if (ya && (va = null), en = 0, ya = !1, 25 <= n) throw Error(h(301));
      if (n += 1, _l = il = null, l.updateQueue != null) {
        var u = l.updateQueue;
        u.lastEffect = null, u.events = null, u.stores = null, u.memoCache != null && (u.memoCache.index = 0);
      }
      b.H = Do, u = t(e, a);
    } while (ya);
    return u;
  }
  function lm() {
    var l = b.H, t = l.useState()[0];
    return t = typeof t.then == "function" ? an(t) : t, l = l.useState()[0], (il !== null ? il.memoizedState : null) !== l && (X.flags |= 1024), t;
  }
  function Ii() {
    var l = iu !== 0;
    return iu = 0, l;
  }
  function Pi(l, t, e) {
    t.updateQueue = l.updateQueue, t.flags &= -2053, l.lanes &= ~e;
  }
  function lc(l) {
    if (uu) {
      for (l = l.memoizedState; l !== null; ) {
        var t = l.queue;
        t !== null && (t.pending = null), l = l.next;
      }
      uu = !1;
    }
    Xt = 0, _l = il = X = null, ya = !1, en = iu = 0, va = null;
  }
  function Kl() {
    var l = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return _l === null ? X.memoizedState = _l = l : _l = _l.next = l, _l;
  }
  function Al() {
    if (il === null) {
      var l = X.alternate;
      l = l !== null ? l.memoizedState : null;
    } else l = il.next;
    var t = _l === null ? X.memoizedState : _l.next;
    if (t !== null)
      _l = t, il = l;
    else {
      if (l === null)
        throw X.alternate === null ? Error(h(467)) : Error(h(310));
      il = l, l = {
        memoizedState: il.memoizedState,
        baseState: il.baseState,
        baseQueue: il.baseQueue,
        queue: il.queue,
        next: null
      }, _l === null ? X.memoizedState = _l = l : _l = _l.next = l;
    }
    return _l;
  }
  function cu() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function an(l) {
    var t = en;
    return en += 1, va === null && (va = []), l = qs(va, l, t), t = X, (_l === null ? t.memoizedState : _l.next) === null && (t = t.alternate, b.H = t === null || t.memoizedState === null ? Oo : dc), l;
  }
  function fu(l) {
    if (l !== null && typeof l == "object") {
      if (typeof l.then == "function") return an(l);
      if (l.$$typeof === Tl) return Yl(l);
    }
    throw Error(h(438, String(l)));
  }
  function tc(l) {
    var t = null, e = X.updateQueue;
    if (e !== null && (t = e.memoCache), t == null) {
      var a = X.alternate;
      a !== null && (a = a.updateQueue, a !== null && (a = a.memoCache, a != null && (t = {
        data: a.data.map(function(n) {
          return n.slice();
        }),
        index: 0
      })));
    }
    if (t == null && (t = { data: [], index: 0 }), e === null && (e = cu(), X.updateQueue = e), e.memoCache = t, e = t.data[t.index], e === void 0)
      for (e = t.data[t.index] = Array(l), a = 0; a < l; a++)
        e[a] = It;
    return t.index++, e;
  }
  function Zt(l, t) {
    return typeof t == "function" ? t(l) : t;
  }
  function su(l) {
    var t = Al();
    return ec(t, il, l);
  }
  function ec(l, t, e) {
    var a = l.queue;
    if (a === null) throw Error(h(311));
    a.lastRenderedReducer = e;
    var n = l.baseQueue, u = a.pending;
    if (u !== null) {
      if (n !== null) {
        var i = n.next;
        n.next = u.next, u.next = i;
      }
      t.baseQueue = n = u, a.pending = null;
    }
    if (u = l.baseState, n === null) l.memoizedState = u;
    else {
      t = n.next;
      var c = i = null, s = null, y = t, p = !1;
      do {
        var A = y.lane & -536870913;
        if (A !== y.lane ? (k & A) === A : (Xt & A) === A) {
          var v = y.revertLane;
          if (v === 0)
            s !== null && (s = s.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: y.action,
              hasEagerState: y.hasEagerState,
              eagerState: y.eagerState,
              next: null
            }), A === oa && (p = !0);
          else if ((Xt & v) === v) {
            y = y.next, v === oa && (p = !0);
            continue;
          } else
            A = {
              lane: 0,
              revertLane: y.revertLane,
              gesture: null,
              action: y.action,
              hasEagerState: y.hasEagerState,
              eagerState: y.eagerState,
              next: null
            }, s === null ? (c = s = A, i = u) : s = s.next = A, X.lanes |= v, he |= v;
          A = y.action, Qe && e(u, A), u = y.hasEagerState ? y.eagerState : e(u, A);
        } else
          v = {
            lane: A,
            revertLane: y.revertLane,
            gesture: y.gesture,
            action: y.action,
            hasEagerState: y.hasEagerState,
            eagerState: y.eagerState,
            next: null
          }, s === null ? (c = s = v, i = u) : s = s.next = v, X.lanes |= A, he |= A;
        y = y.next;
      } while (y !== null && y !== t);
      if (s === null ? i = u : s.next = c, !it(u, l.memoizedState) && (xl = !0, p && (e = ra, e !== null)))
        throw e;
      l.memoizedState = u, l.baseState = i, l.baseQueue = s, a.lastRenderedState = u;
    }
    return n === null && (a.lanes = 0), [l.memoizedState, a.dispatch];
  }
  function ac(l) {
    var t = Al(), e = t.queue;
    if (e === null) throw Error(h(311));
    e.lastRenderedReducer = l;
    var a = e.dispatch, n = e.pending, u = t.memoizedState;
    if (n !== null) {
      e.pending = null;
      var i = n = n.next;
      do
        u = l(u, i.action), i = i.next;
      while (i !== n);
      it(u, t.memoizedState) || (xl = !0), t.memoizedState = u, t.baseQueue === null && (t.baseState = u), e.lastRenderedState = u;
    }
    return [u, a];
  }
  function Js(l, t, e) {
    var a = X, n = Al(), u = F;
    if (u) {
      if (e === void 0) throw Error(h(407));
      e = e();
    } else e = t();
    var i = !it(
      (il || n).memoizedState,
      e
    );
    if (i && (n.memoizedState = e, xl = !0), n = n.queue, ic($s.bind(null, a, n, l), [
      l
    ]), n.getSnapshot !== t || i || _l !== null && _l.memoizedState.tag & 1) {
      if (a.flags |= 2048, ga(
        9,
        { destroy: void 0 },
        Ws.bind(
          null,
          a,
          n,
          e,
          t
        ),
        null
      ), rl === null) throw Error(h(349));
      u || (Xt & 127) !== 0 || ks(a, t, e);
    }
    return e;
  }
  function ks(l, t, e) {
    l.flags |= 16384, l = { getSnapshot: t, value: e }, t = X.updateQueue, t === null ? (t = cu(), X.updateQueue = t, t.stores = [l]) : (e = t.stores, e === null ? t.stores = [l] : e.push(l));
  }
  function Ws(l, t, e, a) {
    t.value = e, t.getSnapshot = a, Fs(t) && Is(l);
  }
  function $s(l, t, e) {
    return e(function() {
      Fs(t) && Is(l);
    });
  }
  function Fs(l) {
    var t = l.getSnapshot;
    l = l.value;
    try {
      var e = t();
      return !it(l, e);
    } catch {
      return !0;
    }
  }
  function Is(l) {
    var t = Ne(l, 2);
    t !== null && tt(t, l, 2);
  }
  function nc(l) {
    var t = Kl();
    if (typeof l == "function") {
      var e = l;
      if (l = e(), Qe) {
        Pt(!0);
        try {
          e();
        } finally {
          Pt(!1);
        }
      }
    }
    return t.memoizedState = t.baseState = l, t.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Zt,
      lastRenderedState: l
    }, t;
  }
  function Ps(l, t, e, a) {
    return l.baseState = e, ec(
      l,
      il,
      typeof a == "function" ? a : Zt
    );
  }
  function tm(l, t, e, a, n) {
    if (du(l)) throw Error(h(485));
    if (l = t.action, l !== null) {
      var u = {
        payload: n,
        action: l,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(i) {
          u.listeners.push(i);
        }
      };
      b.T !== null ? e(!0) : u.isTransition = !1, a(u), e = t.pending, e === null ? (u.next = t.pending = u, lo(t, u)) : (u.next = e.next, t.pending = e.next = u);
    }
  }
  function lo(l, t) {
    var e = t.action, a = t.payload, n = l.state;
    if (t.isTransition) {
      var u = b.T, i = {};
      b.T = i;
      try {
        var c = e(n, a), s = b.S;
        s !== null && s(i, c), to(l, t, c);
      } catch (y) {
        uc(l, t, y);
      } finally {
        u !== null && i.types !== null && (u.types = i.types), b.T = u;
      }
    } else
      try {
        u = e(n, a), to(l, t, u);
      } catch (y) {
        uc(l, t, y);
      }
  }
  function to(l, t, e) {
    e !== null && typeof e == "object" && typeof e.then == "function" ? e.then(
      function(a) {
        eo(l, t, a);
      },
      function(a) {
        return uc(l, t, a);
      }
    ) : eo(l, t, e);
  }
  function eo(l, t, e) {
    t.status = "fulfilled", t.value = e, ao(t), l.state = e, t = l.pending, t !== null && (e = t.next, e === t ? l.pending = null : (e = e.next, t.next = e, lo(l, e)));
  }
  function uc(l, t, e) {
    var a = l.pending;
    if (l.pending = null, a !== null) {
      a = a.next;
      do
        t.status = "rejected", t.reason = e, ao(t), t = t.next;
      while (t !== a);
    }
    l.action = null;
  }
  function ao(l) {
    l = l.listeners;
    for (var t = 0; t < l.length; t++) (0, l[t])();
  }
  function no(l, t) {
    return t;
  }
  function uo(l, t) {
    if (F) {
      var e = rl.formState;
      if (e !== null) {
        l: {
          var a = X;
          if (F) {
            if (ml) {
              t: {
                for (var n = ml, u = At; n.nodeType !== 8; ) {
                  if (!u) {
                    n = null;
                    break t;
                  }
                  if (n = zt(
                    n.nextSibling
                  ), n === null) {
                    n = null;
                    break t;
                  }
                }
                u = n.data, n = u === "F!" || u === "F" ? n : null;
              }
              if (n) {
                ml = zt(
                  n.nextSibling
                ), a = n.data === "F!";
                break l;
              }
            }
            ne(a);
          }
          a = !1;
        }
        a && (t = e[0]);
      }
    }
    return e = Kl(), e.memoizedState = e.baseState = t, a = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: no,
      lastRenderedState: t
    }, e.queue = a, e = _o.bind(
      null,
      X,
      a
    ), a.dispatch = e, a = nc(!1), u = rc.bind(
      null,
      X,
      !1,
      a.queue
    ), a = Kl(), n = {
      state: t,
      dispatch: null,
      action: l,
      pending: null
    }, a.queue = n, e = tm.bind(
      null,
      X,
      n,
      u,
      e
    ), n.dispatch = e, a.memoizedState = l, [t, e, !1];
  }
  function io(l) {
    var t = Al();
    return co(t, il, l);
  }
  function co(l, t, e) {
    if (t = ec(
      l,
      t,
      no
    )[0], l = su(Zt)[0], typeof t == "object" && t !== null && typeof t.then == "function")
      try {
        var a = an(t);
      } catch (i) {
        throw i === da ? Pn : i;
      }
    else a = t;
    t = Al();
    var n = t.queue, u = n.dispatch;
    return e !== t.memoizedState && (X.flags |= 2048, ga(
      9,
      { destroy: void 0 },
      em.bind(null, n, e),
      null
    )), [a, u, l];
  }
  function em(l, t) {
    l.action = t;
  }
  function fo(l) {
    var t = Al(), e = il;
    if (e !== null)
      return co(t, e, l);
    Al(), t = t.memoizedState, e = Al();
    var a = e.queue.dispatch;
    return e.memoizedState = l, [t, a, !1];
  }
  function ga(l, t, e, a) {
    return l = { tag: l, create: e, deps: a, inst: t, next: null }, t = X.updateQueue, t === null && (t = cu(), X.updateQueue = t), e = t.lastEffect, e === null ? t.lastEffect = l.next = l : (a = e.next, e.next = l, l.next = a, t.lastEffect = l), l;
  }
  function so() {
    return Al().memoizedState;
  }
  function ou(l, t, e, a) {
    var n = Kl();
    X.flags |= l, n.memoizedState = ga(
      1 | t,
      { destroy: void 0 },
      e,
      a === void 0 ? null : a
    );
  }
  function ru(l, t, e, a) {
    var n = Al();
    a = a === void 0 ? null : a;
    var u = n.memoizedState.inst;
    il !== null && a !== null && $i(a, il.memoizedState.deps) ? n.memoizedState = ga(t, u, e, a) : (X.flags |= l, n.memoizedState = ga(
      1 | t,
      u,
      e,
      a
    ));
  }
  function oo(l, t) {
    ou(8390656, 8, l, t);
  }
  function ic(l, t) {
    ru(2048, 8, l, t);
  }
  function am(l) {
    X.flags |= 4;
    var t = X.updateQueue;
    if (t === null)
      t = cu(), X.updateQueue = t, t.events = [l];
    else {
      var e = t.events;
      e === null ? t.events = [l] : e.push(l);
    }
  }
  function ro(l) {
    var t = Al().memoizedState;
    return am({ ref: t, nextImpl: l }), function() {
      if ((tl & 2) !== 0) throw Error(h(440));
      return t.impl.apply(void 0, arguments);
    };
  }
  function ho(l, t) {
    return ru(4, 2, l, t);
  }
  function mo(l, t) {
    return ru(4, 4, l, t);
  }
  function yo(l, t) {
    if (typeof t == "function") {
      l = l();
      var e = t(l);
      return function() {
        typeof e == "function" ? e() : t(null);
      };
    }
    if (t != null)
      return l = l(), t.current = l, function() {
        t.current = null;
      };
  }
  function vo(l, t, e) {
    e = e != null ? e.concat([l]) : null, ru(4, 4, yo.bind(null, t, l), e);
  }
  function cc() {
  }
  function go(l, t) {
    var e = Al();
    t = t === void 0 ? null : t;
    var a = e.memoizedState;
    return t !== null && $i(t, a[1]) ? a[0] : (e.memoizedState = [l, t], l);
  }
  function po(l, t) {
    var e = Al();
    t = t === void 0 ? null : t;
    var a = e.memoizedState;
    if (t !== null && $i(t, a[1]))
      return a[0];
    if (a = l(), Qe) {
      Pt(!0);
      try {
        l();
      } finally {
        Pt(!1);
      }
    }
    return e.memoizedState = [a, t], a;
  }
  function fc(l, t, e) {
    return e === void 0 || (Xt & 1073741824) !== 0 && (k & 261930) === 0 ? l.memoizedState = t : (l.memoizedState = e, l = br(), X.lanes |= l, he |= l, e);
  }
  function bo(l, t, e, a) {
    return it(e, t) ? e : ma.current !== null ? (l = fc(l, e, a), it(l, t) || (xl = !0), l) : (Xt & 42) === 0 || (Xt & 1073741824) !== 0 && (k & 261930) === 0 ? (xl = !0, l.memoizedState = e) : (l = br(), X.lanes |= l, he |= l, t);
  }
  function So(l, t, e, a, n) {
    var u = _.p;
    _.p = u !== 0 && 8 > u ? u : 8;
    var i = b.T, c = {};
    b.T = c, rc(l, !1, t, e);
    try {
      var s = n(), y = b.S;
      if (y !== null && y(c, s), s !== null && typeof s == "object" && typeof s.then == "function") {
        var p = Ih(
          s,
          a
        );
        nn(
          l,
          t,
          p,
          dt(l)
        );
      } else
        nn(
          l,
          t,
          a,
          dt(l)
        );
    } catch (A) {
      nn(
        l,
        t,
        { then: function() {
        }, status: "rejected", reason: A },
        dt()
      );
    } finally {
      _.p = u, i !== null && c.types !== null && (i.types = c.types), b.T = i;
    }
  }
  function nm() {
  }
  function sc(l, t, e, a) {
    if (l.tag !== 5) throw Error(h(476));
    var n = Eo(l).queue;
    So(
      l,
      n,
      t,
      Y,
      e === null ? nm : function() {
        return Ao(l), e(a);
      }
    );
  }
  function Eo(l) {
    var t = l.memoizedState;
    if (t !== null) return t;
    t = {
      memoizedState: Y,
      baseState: Y,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Zt,
        lastRenderedState: Y
      },
      next: null
    };
    var e = {};
    return t.next = {
      memoizedState: e,
      baseState: e,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Zt,
        lastRenderedState: e
      },
      next: null
    }, l.memoizedState = t, l = l.alternate, l !== null && (l.memoizedState = t), t;
  }
  function Ao(l) {
    var t = Eo(l);
    t.next === null && (t = l.alternate.memoizedState), nn(
      l,
      t.next.queue,
      {},
      dt()
    );
  }
  function oc() {
    return Yl(An);
  }
  function To() {
    return Al().memoizedState;
  }
  function zo() {
    return Al().memoizedState;
  }
  function um(l) {
    for (var t = l.return; t !== null; ) {
      switch (t.tag) {
        case 24:
        case 3:
          var e = dt();
          l = ce(e);
          var a = fe(t, l, e);
          a !== null && (tt(a, t, e), Pa(a, t, e)), t = { cache: Gi() }, l.payload = t;
          return;
      }
      t = t.return;
    }
  }
  function im(l, t, e) {
    var a = dt();
    e = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: e,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, du(l) ? xo(t, e) : (e = Oi(l, t, e, a), e !== null && (tt(e, l, a), jo(e, t, a)));
  }
  function _o(l, t, e) {
    var a = dt();
    nn(l, t, e, a);
  }
  function nn(l, t, e, a) {
    var n = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: e,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (du(l)) xo(t, n);
    else {
      var u = l.alternate;
      if (l.lanes === 0 && (u === null || u.lanes === 0) && (u = t.lastRenderedReducer, u !== null))
        try {
          var i = t.lastRenderedState, c = u(i, e);
          if (n.hasEagerState = !0, n.eagerState = c, it(c, i))
            return wn(l, t, n, 0), rl === null && Kn(), !1;
        } catch {
        }
      if (e = Oi(l, t, n, a), e !== null)
        return tt(e, l, a), jo(e, t, a), !0;
    }
    return !1;
  }
  function rc(l, t, e, a) {
    if (a = {
      lane: 2,
      revertLane: Lc(),
      gesture: null,
      action: a,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, du(l)) {
      if (t) throw Error(h(479));
    } else
      t = Oi(
        l,
        e,
        a,
        2
      ), t !== null && tt(t, l, 2);
  }
  function du(l) {
    var t = l.alternate;
    return l === X || t !== null && t === X;
  }
  function xo(l, t) {
    ya = uu = !0;
    var e = l.pending;
    e === null ? t.next = t : (t.next = e.next, e.next = t), l.pending = t;
  }
  function jo(l, t, e) {
    if ((e & 4194048) !== 0) {
      var a = t.lanes;
      a &= l.pendingLanes, e |= a, t.lanes = e, Nf(l, e);
    }
  }
  var un = {
    readContext: Yl,
    use: fu,
    useCallback: pl,
    useContext: pl,
    useEffect: pl,
    useImperativeHandle: pl,
    useLayoutEffect: pl,
    useInsertionEffect: pl,
    useMemo: pl,
    useReducer: pl,
    useRef: pl,
    useState: pl,
    useDebugValue: pl,
    useDeferredValue: pl,
    useTransition: pl,
    useSyncExternalStore: pl,
    useId: pl,
    useHostTransitionStatus: pl,
    useFormState: pl,
    useActionState: pl,
    useOptimistic: pl,
    useMemoCache: pl,
    useCacheRefresh: pl
  };
  un.useEffectEvent = pl;
  var Oo = {
    readContext: Yl,
    use: fu,
    useCallback: function(l, t) {
      return Kl().memoizedState = [
        l,
        t === void 0 ? null : t
      ], l;
    },
    useContext: Yl,
    useEffect: oo,
    useImperativeHandle: function(l, t, e) {
      e = e != null ? e.concat([l]) : null, ou(
        4194308,
        4,
        yo.bind(null, t, l),
        e
      );
    },
    useLayoutEffect: function(l, t) {
      return ou(4194308, 4, l, t);
    },
    useInsertionEffect: function(l, t) {
      ou(4, 2, l, t);
    },
    useMemo: function(l, t) {
      var e = Kl();
      t = t === void 0 ? null : t;
      var a = l();
      if (Qe) {
        Pt(!0);
        try {
          l();
        } finally {
          Pt(!1);
        }
      }
      return e.memoizedState = [a, t], a;
    },
    useReducer: function(l, t, e) {
      var a = Kl();
      if (e !== void 0) {
        var n = e(t);
        if (Qe) {
          Pt(!0);
          try {
            e(t);
          } finally {
            Pt(!1);
          }
        }
      } else n = t;
      return a.memoizedState = a.baseState = n, l = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: l,
        lastRenderedState: n
      }, a.queue = l, l = l.dispatch = im.bind(
        null,
        X,
        l
      ), [a.memoizedState, l];
    },
    useRef: function(l) {
      var t = Kl();
      return l = { current: l }, t.memoizedState = l;
    },
    useState: function(l) {
      l = nc(l);
      var t = l.queue, e = _o.bind(null, X, t);
      return t.dispatch = e, [l.memoizedState, e];
    },
    useDebugValue: cc,
    useDeferredValue: function(l, t) {
      var e = Kl();
      return fc(e, l, t);
    },
    useTransition: function() {
      var l = nc(!1);
      return l = So.bind(
        null,
        X,
        l.queue,
        !0,
        !1
      ), Kl().memoizedState = l, [!1, l];
    },
    useSyncExternalStore: function(l, t, e) {
      var a = X, n = Kl();
      if (F) {
        if (e === void 0)
          throw Error(h(407));
        e = e();
      } else {
        if (e = t(), rl === null)
          throw Error(h(349));
        (k & 127) !== 0 || ks(a, t, e);
      }
      n.memoizedState = e;
      var u = { value: e, getSnapshot: t };
      return n.queue = u, oo($s.bind(null, a, u, l), [
        l
      ]), a.flags |= 2048, ga(
        9,
        { destroy: void 0 },
        Ws.bind(
          null,
          a,
          u,
          e,
          t
        ),
        null
      ), e;
    },
    useId: function() {
      var l = Kl(), t = rl.identifierPrefix;
      if (F) {
        var e = Nt, a = Mt;
        e = (a & ~(1 << 32 - ut(a) - 1)).toString(32) + e, t = "_" + t + "R_" + e, e = iu++, 0 < e && (t += "H" + e.toString(32)), t += "_";
      } else
        e = Ph++, t = "_" + t + "r_" + e.toString(32) + "_";
      return l.memoizedState = t;
    },
    useHostTransitionStatus: oc,
    useFormState: uo,
    useActionState: uo,
    useOptimistic: function(l) {
      var t = Kl();
      t.memoizedState = t.baseState = l;
      var e = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return t.queue = e, t = rc.bind(
        null,
        X,
        !0,
        e
      ), e.dispatch = t, [l, t];
    },
    useMemoCache: tc,
    useCacheRefresh: function() {
      return Kl().memoizedState = um.bind(
        null,
        X
      );
    },
    useEffectEvent: function(l) {
      var t = Kl(), e = { impl: l };
      return t.memoizedState = e, function() {
        if ((tl & 2) !== 0)
          throw Error(h(440));
        return e.impl.apply(void 0, arguments);
      };
    }
  }, dc = {
    readContext: Yl,
    use: fu,
    useCallback: go,
    useContext: Yl,
    useEffect: ic,
    useImperativeHandle: vo,
    useInsertionEffect: ho,
    useLayoutEffect: mo,
    useMemo: po,
    useReducer: su,
    useRef: so,
    useState: function() {
      return su(Zt);
    },
    useDebugValue: cc,
    useDeferredValue: function(l, t) {
      var e = Al();
      return bo(
        e,
        il.memoizedState,
        l,
        t
      );
    },
    useTransition: function() {
      var l = su(Zt)[0], t = Al().memoizedState;
      return [
        typeof l == "boolean" ? l : an(l),
        t
      ];
    },
    useSyncExternalStore: Js,
    useId: To,
    useHostTransitionStatus: oc,
    useFormState: io,
    useActionState: io,
    useOptimistic: function(l, t) {
      var e = Al();
      return Ps(e, il, l, t);
    },
    useMemoCache: tc,
    useCacheRefresh: zo
  };
  dc.useEffectEvent = ro;
  var Do = {
    readContext: Yl,
    use: fu,
    useCallback: go,
    useContext: Yl,
    useEffect: ic,
    useImperativeHandle: vo,
    useInsertionEffect: ho,
    useLayoutEffect: mo,
    useMemo: po,
    useReducer: ac,
    useRef: so,
    useState: function() {
      return ac(Zt);
    },
    useDebugValue: cc,
    useDeferredValue: function(l, t) {
      var e = Al();
      return il === null ? fc(e, l, t) : bo(
        e,
        il.memoizedState,
        l,
        t
      );
    },
    useTransition: function() {
      var l = ac(Zt)[0], t = Al().memoizedState;
      return [
        typeof l == "boolean" ? l : an(l),
        t
      ];
    },
    useSyncExternalStore: Js,
    useId: To,
    useHostTransitionStatus: oc,
    useFormState: fo,
    useActionState: fo,
    useOptimistic: function(l, t) {
      var e = Al();
      return il !== null ? Ps(e, il, l, t) : (e.baseState = l, [l, e.queue.dispatch]);
    },
    useMemoCache: tc,
    useCacheRefresh: zo
  };
  Do.useEffectEvent = ro;
  function hc(l, t, e, a) {
    t = l.memoizedState, e = e(a, t), e = e == null ? t : R({}, t, e), l.memoizedState = e, l.lanes === 0 && (l.updateQueue.baseState = e);
  }
  var mc = {
    enqueueSetState: function(l, t, e) {
      l = l._reactInternals;
      var a = dt(), n = ce(a);
      n.payload = t, e != null && (n.callback = e), t = fe(l, n, a), t !== null && (tt(t, l, a), Pa(t, l, a));
    },
    enqueueReplaceState: function(l, t, e) {
      l = l._reactInternals;
      var a = dt(), n = ce(a);
      n.tag = 1, n.payload = t, e != null && (n.callback = e), t = fe(l, n, a), t !== null && (tt(t, l, a), Pa(t, l, a));
    },
    enqueueForceUpdate: function(l, t) {
      l = l._reactInternals;
      var e = dt(), a = ce(e);
      a.tag = 2, t != null && (a.callback = t), t = fe(l, a, e), t !== null && (tt(t, l, e), Pa(t, l, e));
    }
  };
  function Mo(l, t, e, a, n, u, i) {
    return l = l.stateNode, typeof l.shouldComponentUpdate == "function" ? l.shouldComponentUpdate(a, u, i) : t.prototype && t.prototype.isPureReactComponent ? !Ka(e, a) || !Ka(n, u) : !0;
  }
  function No(l, t, e, a) {
    l = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(e, a), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(e, a), t.state !== l && mc.enqueueReplaceState(t, t.state, null);
  }
  function Xe(l, t) {
    var e = t;
    if ("ref" in t) {
      e = {};
      for (var a in t)
        a !== "ref" && (e[a] = t[a]);
    }
    if (l = l.defaultProps) {
      e === t && (e = R({}, e));
      for (var n in l)
        e[n] === void 0 && (e[n] = l[n]);
    }
    return e;
  }
  function Uo(l) {
    Vn(l);
  }
  function Ro(l) {
    console.error(l);
  }
  function Co(l) {
    Vn(l);
  }
  function hu(l, t) {
    try {
      var e = l.onUncaughtError;
      e(t.value, { componentStack: t.stack });
    } catch (a) {
      setTimeout(function() {
        throw a;
      });
    }
  }
  function Ho(l, t, e) {
    try {
      var a = l.onCaughtError;
      a(e.value, {
        componentStack: e.stack,
        errorBoundary: t.tag === 1 ? t.stateNode : null
      });
    } catch (n) {
      setTimeout(function() {
        throw n;
      });
    }
  }
  function yc(l, t, e) {
    return e = ce(e), e.tag = 3, e.payload = { element: null }, e.callback = function() {
      hu(l, t);
    }, e;
  }
  function qo(l) {
    return l = ce(l), l.tag = 3, l;
  }
  function Bo(l, t, e, a) {
    var n = e.type.getDerivedStateFromError;
    if (typeof n == "function") {
      var u = a.value;
      l.payload = function() {
        return n(u);
      }, l.callback = function() {
        Ho(t, e, a);
      };
    }
    var i = e.stateNode;
    i !== null && typeof i.componentDidCatch == "function" && (l.callback = function() {
      Ho(t, e, a), typeof n != "function" && (me === null ? me = /* @__PURE__ */ new Set([this]) : me.add(this));
      var c = a.stack;
      this.componentDidCatch(a.value, {
        componentStack: c !== null ? c : ""
      });
    });
  }
  function cm(l, t, e, a, n) {
    if (e.flags |= 32768, a !== null && typeof a == "object" && typeof a.then == "function") {
      if (t = e.alternate, t !== null && sa(
        t,
        e,
        n,
        !0
      ), e = ft.current, e !== null) {
        switch (e.tag) {
          case 31:
          case 13:
            return Tt === null ? _u() : e.alternate === null && bl === 0 && (bl = 3), e.flags &= -257, e.flags |= 65536, e.lanes = n, a === lu ? e.flags |= 16384 : (t = e.updateQueue, t === null ? e.updateQueue = /* @__PURE__ */ new Set([a]) : t.add(a), Qc(l, a, n)), !1;
          case 22:
            return e.flags |= 65536, a === lu ? e.flags |= 16384 : (t = e.updateQueue, t === null ? (t = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([a])
            }, e.updateQueue = t) : (e = t.retryQueue, e === null ? t.retryQueue = /* @__PURE__ */ new Set([a]) : e.add(a)), Qc(l, a, n)), !1;
        }
        throw Error(h(435, e.tag));
      }
      return Qc(l, a, n), _u(), !1;
    }
    if (F)
      return t = ft.current, t !== null ? ((t.flags & 65536) === 0 && (t.flags |= 256), t.flags |= 65536, t.lanes = n, a !== Ci && (l = Error(h(422), { cause: a }), ka(bt(l, e)))) : (a !== Ci && (t = Error(h(423), {
        cause: a
      }), ka(
        bt(t, e)
      )), l = l.current.alternate, l.flags |= 65536, n &= -n, l.lanes |= n, a = bt(a, e), n = yc(
        l.stateNode,
        a,
        n
      ), Ki(l, n), bl !== 4 && (bl = 2)), !1;
    var u = Error(h(520), { cause: a });
    if (u = bt(u, e), mn === null ? mn = [u] : mn.push(u), bl !== 4 && (bl = 2), t === null) return !0;
    a = bt(a, e), e = t;
    do {
      switch (e.tag) {
        case 3:
          return e.flags |= 65536, l = n & -n, e.lanes |= l, l = yc(e.stateNode, a, l), Ki(e, l), !1;
        case 1:
          if (t = e.type, u = e.stateNode, (e.flags & 128) === 0 && (typeof t.getDerivedStateFromError == "function" || u !== null && typeof u.componentDidCatch == "function" && (me === null || !me.has(u))))
            return e.flags |= 65536, n &= -n, e.lanes |= n, n = qo(n), Bo(
              n,
              l,
              e,
              a
            ), Ki(e, n), !1;
      }
      e = e.return;
    } while (e !== null);
    return !1;
  }
  var vc = Error(h(461)), xl = !1;
  function Gl(l, t, e, a) {
    t.child = l === null ? Qs(t, null, e, a) : Ge(
      t,
      l.child,
      e,
      a
    );
  }
  function Yo(l, t, e, a, n) {
    e = e.render;
    var u = t.ref;
    if ("ref" in a) {
      var i = {};
      for (var c in a)
        c !== "ref" && (i[c] = a[c]);
    } else i = a;
    return He(t), a = Fi(
      l,
      t,
      e,
      i,
      u,
      n
    ), c = Ii(), l !== null && !xl ? (Pi(l, t, n), Lt(l, t, n)) : (F && c && Ui(t), t.flags |= 1, Gl(l, t, a, n), t.child);
  }
  function Go(l, t, e, a, n) {
    if (l === null) {
      var u = e.type;
      return typeof u == "function" && !Di(u) && u.defaultProps === void 0 && e.compare === null ? (t.tag = 15, t.type = u, Qo(
        l,
        t,
        u,
        a,
        n
      )) : (l = kn(
        e.type,
        null,
        a,
        t,
        t.mode,
        n
      ), l.ref = t.ref, l.return = t, t.child = l);
    }
    if (u = l.child, !zc(l, n)) {
      var i = u.memoizedProps;
      if (e = e.compare, e = e !== null ? e : Ka, e(i, a) && l.ref === t.ref)
        return Lt(l, t, n);
    }
    return t.flags |= 1, l = Bt(u, a), l.ref = t.ref, l.return = t, t.child = l;
  }
  function Qo(l, t, e, a, n) {
    if (l !== null) {
      var u = l.memoizedProps;
      if (Ka(u, a) && l.ref === t.ref)
        if (xl = !1, t.pendingProps = a = u, zc(l, n))
          (l.flags & 131072) !== 0 && (xl = !0);
        else
          return t.lanes = l.lanes, Lt(l, t, n);
    }
    return gc(
      l,
      t,
      e,
      a,
      n
    );
  }
  function Xo(l, t, e, a) {
    var n = a.children, u = l !== null ? l.memoizedState : null;
    if (l === null && t.stateNode === null && (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), a.mode === "hidden") {
      if ((t.flags & 128) !== 0) {
        if (u = u !== null ? u.baseLanes | e : e, l !== null) {
          for (a = t.child = l.child, n = 0; a !== null; )
            n = n | a.lanes | a.childLanes, a = a.sibling;
          a = n & ~u;
        } else a = 0, t.child = null;
        return Zo(
          l,
          t,
          u,
          e,
          a
        );
      }
      if ((e & 536870912) !== 0)
        t.memoizedState = { baseLanes: 0, cachePool: null }, l !== null && In(
          t,
          u !== null ? u.cachePool : null
        ), u !== null ? Ls(t, u) : Ji(), Vs(t);
      else
        return a = t.lanes = 536870912, Zo(
          l,
          t,
          u !== null ? u.baseLanes | e : e,
          e,
          a
        );
    } else
      u !== null ? (In(t, u.cachePool), Ls(t, u), oe(), t.memoizedState = null) : (l !== null && In(t, null), Ji(), oe());
    return Gl(l, t, n, e), t.child;
  }
  function cn(l, t) {
    return l !== null && l.tag === 22 || t.stateNode !== null || (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), t.sibling;
  }
  function Zo(l, t, e, a, n) {
    var u = Xi();
    return u = u === null ? null : { parent: zl._currentValue, pool: u }, t.memoizedState = {
      baseLanes: e,
      cachePool: u
    }, l !== null && In(t, null), Ji(), Vs(t), l !== null && sa(l, t, a, !0), t.childLanes = n, null;
  }
  function mu(l, t) {
    return t = vu(
      { mode: t.mode, children: t.children },
      l.mode
    ), t.ref = l.ref, l.child = t, t.return = l, t;
  }
  function Lo(l, t, e) {
    return Ge(t, l.child, null, e), l = mu(t, t.pendingProps), l.flags |= 2, st(t), t.memoizedState = null, l;
  }
  function fm(l, t, e) {
    var a = t.pendingProps, n = (t.flags & 128) !== 0;
    if (t.flags &= -129, l === null) {
      if (F) {
        if (a.mode === "hidden")
          return l = mu(t, a), t.lanes = 536870912, cn(null, l);
        if (Wi(t), (l = ml) ? (l = td(
          l,
          At
        ), l = l !== null && l.data === "&" ? l : null, l !== null && (t.memoizedState = {
          dehydrated: l,
          treeContext: ee !== null ? { id: Mt, overflow: Nt } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, e = _s(l), e.return = t, t.child = e, Bl = t, ml = null)) : l = null, l === null) throw ne(t);
        return t.lanes = 536870912, null;
      }
      return mu(t, a);
    }
    var u = l.memoizedState;
    if (u !== null) {
      var i = u.dehydrated;
      if (Wi(t), n)
        if (t.flags & 256)
          t.flags &= -257, t = Lo(
            l,
            t,
            e
          );
        else if (t.memoizedState !== null)
          t.child = l.child, t.flags |= 128, t = null;
        else throw Error(h(558));
      else if (xl || sa(l, t, e, !1), n = (e & l.childLanes) !== 0, xl || n) {
        if (a = rl, a !== null && (i = Uf(a, e), i !== 0 && i !== u.retryLane))
          throw u.retryLane = i, Ne(l, i), tt(a, l, i), vc;
        _u(), t = Lo(
          l,
          t,
          e
        );
      } else
        l = u.treeContext, ml = zt(i.nextSibling), Bl = t, F = !0, ae = null, At = !1, l !== null && Os(t, l), t = mu(t, a), t.flags |= 4096;
      return t;
    }
    return l = Bt(l.child, {
      mode: a.mode,
      children: a.children
    }), l.ref = t.ref, t.child = l, l.return = t, l;
  }
  function yu(l, t) {
    var e = t.ref;
    if (e === null)
      l !== null && l.ref !== null && (t.flags |= 4194816);
    else {
      if (typeof e != "function" && typeof e != "object")
        throw Error(h(284));
      (l === null || l.ref !== e) && (t.flags |= 4194816);
    }
  }
  function gc(l, t, e, a, n) {
    return He(t), e = Fi(
      l,
      t,
      e,
      a,
      void 0,
      n
    ), a = Ii(), l !== null && !xl ? (Pi(l, t, n), Lt(l, t, n)) : (F && a && Ui(t), t.flags |= 1, Gl(l, t, e, n), t.child);
  }
  function Vo(l, t, e, a, n, u) {
    return He(t), t.updateQueue = null, e = ws(
      t,
      a,
      e,
      n
    ), Ks(l), a = Ii(), l !== null && !xl ? (Pi(l, t, u), Lt(l, t, u)) : (F && a && Ui(t), t.flags |= 1, Gl(l, t, e, u), t.child);
  }
  function Ko(l, t, e, a, n) {
    if (He(t), t.stateNode === null) {
      var u = ua, i = e.contextType;
      typeof i == "object" && i !== null && (u = Yl(i)), u = new e(a, u), t.memoizedState = u.state !== null && u.state !== void 0 ? u.state : null, u.updater = mc, t.stateNode = u, u._reactInternals = t, u = t.stateNode, u.props = a, u.state = t.memoizedState, u.refs = {}, Li(t), i = e.contextType, u.context = typeof i == "object" && i !== null ? Yl(i) : ua, u.state = t.memoizedState, i = e.getDerivedStateFromProps, typeof i == "function" && (hc(
        t,
        e,
        i,
        a
      ), u.state = t.memoizedState), typeof e.getDerivedStateFromProps == "function" || typeof u.getSnapshotBeforeUpdate == "function" || typeof u.UNSAFE_componentWillMount != "function" && typeof u.componentWillMount != "function" || (i = u.state, typeof u.componentWillMount == "function" && u.componentWillMount(), typeof u.UNSAFE_componentWillMount == "function" && u.UNSAFE_componentWillMount(), i !== u.state && mc.enqueueReplaceState(u, u.state, null), tn(t, a, u, n), ln(), u.state = t.memoizedState), typeof u.componentDidMount == "function" && (t.flags |= 4194308), a = !0;
    } else if (l === null) {
      u = t.stateNode;
      var c = t.memoizedProps, s = Xe(e, c);
      u.props = s;
      var y = u.context, p = e.contextType;
      i = ua, typeof p == "object" && p !== null && (i = Yl(p));
      var A = e.getDerivedStateFromProps;
      p = typeof A == "function" || typeof u.getSnapshotBeforeUpdate == "function", c = t.pendingProps !== c, p || typeof u.UNSAFE_componentWillReceiveProps != "function" && typeof u.componentWillReceiveProps != "function" || (c || y !== i) && No(
        t,
        u,
        a,
        i
      ), ie = !1;
      var v = t.memoizedState;
      u.state = v, tn(t, a, u, n), ln(), y = t.memoizedState, c || v !== y || ie ? (typeof A == "function" && (hc(
        t,
        e,
        A,
        a
      ), y = t.memoizedState), (s = ie || Mo(
        t,
        e,
        s,
        a,
        v,
        y,
        i
      )) ? (p || typeof u.UNSAFE_componentWillMount != "function" && typeof u.componentWillMount != "function" || (typeof u.componentWillMount == "function" && u.componentWillMount(), typeof u.UNSAFE_componentWillMount == "function" && u.UNSAFE_componentWillMount()), typeof u.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof u.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = a, t.memoizedState = y), u.props = a, u.state = y, u.context = i, a = s) : (typeof u.componentDidMount == "function" && (t.flags |= 4194308), a = !1);
    } else {
      u = t.stateNode, Vi(l, t), i = t.memoizedProps, p = Xe(e, i), u.props = p, A = t.pendingProps, v = u.context, y = e.contextType, s = ua, typeof y == "object" && y !== null && (s = Yl(y)), c = e.getDerivedStateFromProps, (y = typeof c == "function" || typeof u.getSnapshotBeforeUpdate == "function") || typeof u.UNSAFE_componentWillReceiveProps != "function" && typeof u.componentWillReceiveProps != "function" || (i !== A || v !== s) && No(
        t,
        u,
        a,
        s
      ), ie = !1, v = t.memoizedState, u.state = v, tn(t, a, u, n), ln();
      var g = t.memoizedState;
      i !== A || v !== g || ie || l !== null && l.dependencies !== null && $n(l.dependencies) ? (typeof c == "function" && (hc(
        t,
        e,
        c,
        a
      ), g = t.memoizedState), (p = ie || Mo(
        t,
        e,
        p,
        a,
        v,
        g,
        s
      ) || l !== null && l.dependencies !== null && $n(l.dependencies)) ? (y || typeof u.UNSAFE_componentWillUpdate != "function" && typeof u.componentWillUpdate != "function" || (typeof u.componentWillUpdate == "function" && u.componentWillUpdate(a, g, s), typeof u.UNSAFE_componentWillUpdate == "function" && u.UNSAFE_componentWillUpdate(
        a,
        g,
        s
      )), typeof u.componentDidUpdate == "function" && (t.flags |= 4), typeof u.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof u.componentDidUpdate != "function" || i === l.memoizedProps && v === l.memoizedState || (t.flags |= 4), typeof u.getSnapshotBeforeUpdate != "function" || i === l.memoizedProps && v === l.memoizedState || (t.flags |= 1024), t.memoizedProps = a, t.memoizedState = g), u.props = a, u.state = g, u.context = s, a = p) : (typeof u.componentDidUpdate != "function" || i === l.memoizedProps && v === l.memoizedState || (t.flags |= 4), typeof u.getSnapshotBeforeUpdate != "function" || i === l.memoizedProps && v === l.memoizedState || (t.flags |= 1024), a = !1);
    }
    return u = a, yu(l, t), a = (t.flags & 128) !== 0, u || a ? (u = t.stateNode, e = a && typeof e.getDerivedStateFromError != "function" ? null : u.render(), t.flags |= 1, l !== null && a ? (t.child = Ge(
      t,
      l.child,
      null,
      n
    ), t.child = Ge(
      t,
      null,
      e,
      n
    )) : Gl(l, t, e, n), t.memoizedState = u.state, l = t.child) : l = Lt(
      l,
      t,
      n
    ), l;
  }
  function wo(l, t, e, a) {
    return Re(), t.flags |= 256, Gl(l, t, e, a), t.child;
  }
  var pc = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function bc(l) {
    return { baseLanes: l, cachePool: Cs() };
  }
  function Sc(l, t, e) {
    return l = l !== null ? l.childLanes & ~e : 0, t && (l |= rt), l;
  }
  function Jo(l, t, e) {
    var a = t.pendingProps, n = !1, u = (t.flags & 128) !== 0, i;
    if ((i = u) || (i = l !== null && l.memoizedState === null ? !1 : (El.current & 2) !== 0), i && (n = !0, t.flags &= -129), i = (t.flags & 32) !== 0, t.flags &= -33, l === null) {
      if (F) {
        if (n ? se(t) : oe(), (l = ml) ? (l = td(
          l,
          At
        ), l = l !== null && l.data !== "&" ? l : null, l !== null && (t.memoizedState = {
          dehydrated: l,
          treeContext: ee !== null ? { id: Mt, overflow: Nt } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, e = _s(l), e.return = t, t.child = e, Bl = t, ml = null)) : l = null, l === null) throw ne(t);
        return ef(l) ? t.lanes = 32 : t.lanes = 536870912, null;
      }
      var c = a.children;
      return a = a.fallback, n ? (oe(), n = t.mode, c = vu(
        { mode: "hidden", children: c },
        n
      ), a = Ue(
        a,
        n,
        e,
        null
      ), c.return = t, a.return = t, c.sibling = a, t.child = c, a = t.child, a.memoizedState = bc(e), a.childLanes = Sc(
        l,
        i,
        e
      ), t.memoizedState = pc, cn(null, a)) : (se(t), Ec(t, c));
    }
    var s = l.memoizedState;
    if (s !== null && (c = s.dehydrated, c !== null)) {
      if (u)
        t.flags & 256 ? (se(t), t.flags &= -257, t = Ac(
          l,
          t,
          e
        )) : t.memoizedState !== null ? (oe(), t.child = l.child, t.flags |= 128, t = null) : (oe(), c = a.fallback, n = t.mode, a = vu(
          { mode: "visible", children: a.children },
          n
        ), c = Ue(
          c,
          n,
          e,
          null
        ), c.flags |= 2, a.return = t, c.return = t, a.sibling = c, t.child = a, Ge(
          t,
          l.child,
          null,
          e
        ), a = t.child, a.memoizedState = bc(e), a.childLanes = Sc(
          l,
          i,
          e
        ), t.memoizedState = pc, t = cn(null, a));
      else if (se(t), ef(c)) {
        if (i = c.nextSibling && c.nextSibling.dataset, i) var y = i.dgst;
        i = y, a = Error(h(419)), a.stack = "", a.digest = i, ka({ value: a, source: null, stack: null }), t = Ac(
          l,
          t,
          e
        );
      } else if (xl || sa(l, t, e, !1), i = (e & l.childLanes) !== 0, xl || i) {
        if (i = rl, i !== null && (a = Uf(i, e), a !== 0 && a !== s.retryLane))
          throw s.retryLane = a, Ne(l, a), tt(i, l, a), vc;
        tf(c) || _u(), t = Ac(
          l,
          t,
          e
        );
      } else
        tf(c) ? (t.flags |= 192, t.child = l.child, t = null) : (l = s.treeContext, ml = zt(
          c.nextSibling
        ), Bl = t, F = !0, ae = null, At = !1, l !== null && Os(t, l), t = Ec(
          t,
          a.children
        ), t.flags |= 4096);
      return t;
    }
    return n ? (oe(), c = a.fallback, n = t.mode, s = l.child, y = s.sibling, a = Bt(s, {
      mode: "hidden",
      children: a.children
    }), a.subtreeFlags = s.subtreeFlags & 65011712, y !== null ? c = Bt(
      y,
      c
    ) : (c = Ue(
      c,
      n,
      e,
      null
    ), c.flags |= 2), c.return = t, a.return = t, a.sibling = c, t.child = a, cn(null, a), a = t.child, c = l.child.memoizedState, c === null ? c = bc(e) : (n = c.cachePool, n !== null ? (s = zl._currentValue, n = n.parent !== s ? { parent: s, pool: s } : n) : n = Cs(), c = {
      baseLanes: c.baseLanes | e,
      cachePool: n
    }), a.memoizedState = c, a.childLanes = Sc(
      l,
      i,
      e
    ), t.memoizedState = pc, cn(l.child, a)) : (se(t), e = l.child, l = e.sibling, e = Bt(e, {
      mode: "visible",
      children: a.children
    }), e.return = t, e.sibling = null, l !== null && (i = t.deletions, i === null ? (t.deletions = [l], t.flags |= 16) : i.push(l)), t.child = e, t.memoizedState = null, e);
  }
  function Ec(l, t) {
    return t = vu(
      { mode: "visible", children: t },
      l.mode
    ), t.return = l, l.child = t;
  }
  function vu(l, t) {
    return l = ct(22, l, null, t), l.lanes = 0, l;
  }
  function Ac(l, t, e) {
    return Ge(t, l.child, null, e), l = Ec(
      t,
      t.pendingProps.children
    ), l.flags |= 2, t.memoizedState = null, l;
  }
  function ko(l, t, e) {
    l.lanes |= t;
    var a = l.alternate;
    a !== null && (a.lanes |= t), Bi(l.return, t, e);
  }
  function Tc(l, t, e, a, n, u) {
    var i = l.memoizedState;
    i === null ? l.memoizedState = {
      isBackwards: t,
      rendering: null,
      renderingStartTime: 0,
      last: a,
      tail: e,
      tailMode: n,
      treeForkCount: u
    } : (i.isBackwards = t, i.rendering = null, i.renderingStartTime = 0, i.last = a, i.tail = e, i.tailMode = n, i.treeForkCount = u);
  }
  function Wo(l, t, e) {
    var a = t.pendingProps, n = a.revealOrder, u = a.tail;
    a = a.children;
    var i = El.current, c = (i & 2) !== 0;
    if (c ? (i = i & 1 | 2, t.flags |= 128) : i &= 1, x(El, i), Gl(l, t, a, e), a = F ? Ja : 0, !c && l !== null && (l.flags & 128) !== 0)
      l: for (l = t.child; l !== null; ) {
        if (l.tag === 13)
          l.memoizedState !== null && ko(l, e, t);
        else if (l.tag === 19)
          ko(l, e, t);
        else if (l.child !== null) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === t) break l;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === t)
            break l;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
    switch (n) {
      case "forwards":
        for (e = t.child, n = null; e !== null; )
          l = e.alternate, l !== null && nu(l) === null && (n = e), e = e.sibling;
        e = n, e === null ? (n = t.child, t.child = null) : (n = e.sibling, e.sibling = null), Tc(
          t,
          !1,
          n,
          e,
          u,
          a
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (e = null, n = t.child, t.child = null; n !== null; ) {
          if (l = n.alternate, l !== null && nu(l) === null) {
            t.child = n;
            break;
          }
          l = n.sibling, n.sibling = e, e = n, n = l;
        }
        Tc(
          t,
          !0,
          e,
          null,
          u,
          a
        );
        break;
      case "together":
        Tc(
          t,
          !1,
          null,
          null,
          void 0,
          a
        );
        break;
      default:
        t.memoizedState = null;
    }
    return t.child;
  }
  function Lt(l, t, e) {
    if (l !== null && (t.dependencies = l.dependencies), he |= t.lanes, (e & t.childLanes) === 0)
      if (l !== null) {
        if (sa(
          l,
          t,
          e,
          !1
        ), (e & t.childLanes) === 0)
          return null;
      } else return null;
    if (l !== null && t.child !== l.child)
      throw Error(h(153));
    if (t.child !== null) {
      for (l = t.child, e = Bt(l, l.pendingProps), t.child = e, e.return = t; l.sibling !== null; )
        l = l.sibling, e = e.sibling = Bt(l, l.pendingProps), e.return = t;
      e.sibling = null;
    }
    return t.child;
  }
  function zc(l, t) {
    return (l.lanes & t) !== 0 ? !0 : (l = l.dependencies, !!(l !== null && $n(l)));
  }
  function sm(l, t, e) {
    switch (t.tag) {
      case 3:
        Vl(t, t.stateNode.containerInfo), ue(t, zl, l.memoizedState.cache), Re();
        break;
      case 27:
      case 5:
        Ua(t);
        break;
      case 4:
        Vl(t, t.stateNode.containerInfo);
        break;
      case 10:
        ue(
          t,
          t.type,
          t.memoizedProps.value
        );
        break;
      case 31:
        if (t.memoizedState !== null)
          return t.flags |= 128, Wi(t), null;
        break;
      case 13:
        var a = t.memoizedState;
        if (a !== null)
          return a.dehydrated !== null ? (se(t), t.flags |= 128, null) : (e & t.child.childLanes) !== 0 ? Jo(l, t, e) : (se(t), l = Lt(
            l,
            t,
            e
          ), l !== null ? l.sibling : null);
        se(t);
        break;
      case 19:
        var n = (l.flags & 128) !== 0;
        if (a = (e & t.childLanes) !== 0, a || (sa(
          l,
          t,
          e,
          !1
        ), a = (e & t.childLanes) !== 0), n) {
          if (a)
            return Wo(
              l,
              t,
              e
            );
          t.flags |= 128;
        }
        if (n = t.memoizedState, n !== null && (n.rendering = null, n.tail = null, n.lastEffect = null), x(El, El.current), a) break;
        return null;
      case 22:
        return t.lanes = 0, Xo(
          l,
          t,
          e,
          t.pendingProps
        );
      case 24:
        ue(t, zl, l.memoizedState.cache);
    }
    return Lt(l, t, e);
  }
  function $o(l, t, e) {
    if (l !== null)
      if (l.memoizedProps !== t.pendingProps)
        xl = !0;
      else {
        if (!zc(l, e) && (t.flags & 128) === 0)
          return xl = !1, sm(
            l,
            t,
            e
          );
        xl = (l.flags & 131072) !== 0;
      }
    else
      xl = !1, F && (t.flags & 1048576) !== 0 && js(t, Ja, t.index);
    switch (t.lanes = 0, t.tag) {
      case 16:
        l: {
          var a = t.pendingProps;
          if (l = Be(t.elementType), t.type = l, typeof l == "function")
            Di(l) ? (a = Xe(l, a), t.tag = 1, t = Ko(
              null,
              t,
              l,
              a,
              e
            )) : (t.tag = 0, t = gc(
              null,
              t,
              l,
              a,
              e
            ));
          else {
            if (l != null) {
              var n = l.$$typeof;
              if (n === Jl) {
                t.tag = 11, t = Yo(
                  null,
                  t,
                  l,
                  a,
                  e
                );
                break l;
              } else if (n === V) {
                t.tag = 14, t = Go(
                  null,
                  t,
                  l,
                  a,
                  e
                );
                break l;
              }
            }
            throw t = vl(l) || l, Error(h(306, t, ""));
          }
        }
        return t;
      case 0:
        return gc(
          l,
          t,
          t.type,
          t.pendingProps,
          e
        );
      case 1:
        return a = t.type, n = Xe(
          a,
          t.pendingProps
        ), Ko(
          l,
          t,
          a,
          n,
          e
        );
      case 3:
        l: {
          if (Vl(
            t,
            t.stateNode.containerInfo
          ), l === null) throw Error(h(387));
          a = t.pendingProps;
          var u = t.memoizedState;
          n = u.element, Vi(l, t), tn(t, a, null, e);
          var i = t.memoizedState;
          if (a = i.cache, ue(t, zl, a), a !== u.cache && Yi(
            t,
            [zl],
            e,
            !0
          ), ln(), a = i.element, u.isDehydrated)
            if (u = {
              element: a,
              isDehydrated: !1,
              cache: i.cache
            }, t.updateQueue.baseState = u, t.memoizedState = u, t.flags & 256) {
              t = wo(
                l,
                t,
                a,
                e
              );
              break l;
            } else if (a !== n) {
              n = bt(
                Error(h(424)),
                t
              ), ka(n), t = wo(
                l,
                t,
                a,
                e
              );
              break l;
            } else
              for (l = t.stateNode.containerInfo, l.nodeType === 9 ? l = l.body : l = l.nodeName === "HTML" ? l.ownerDocument.body : l, ml = zt(l.firstChild), Bl = t, F = !0, ae = null, At = !0, e = Qs(
                t,
                null,
                a,
                e
              ), t.child = e; e; )
                e.flags = e.flags & -3 | 4096, e = e.sibling;
          else {
            if (Re(), a === n) {
              t = Lt(
                l,
                t,
                e
              );
              break l;
            }
            Gl(l, t, a, e);
          }
          t = t.child;
        }
        return t;
      case 26:
        return yu(l, t), l === null ? (e = cd(
          t.type,
          null,
          t.pendingProps,
          null
        )) ? t.memoizedState = e : F || (e = t.type, l = t.pendingProps, a = Uu(
          K.current
        ).createElement(e), a[ql] = t, a[Wl] = l, Ql(a, e, l), Nl(a), t.stateNode = a) : t.memoizedState = cd(
          t.type,
          l.memoizedProps,
          t.pendingProps,
          l.memoizedState
        ), null;
      case 27:
        return Ua(t), l === null && F && (a = t.stateNode = nd(
          t.type,
          t.pendingProps,
          K.current
        ), Bl = t, At = !0, n = ml, pe(t.type) ? (af = n, ml = zt(a.firstChild)) : ml = n), Gl(
          l,
          t,
          t.pendingProps.children,
          e
        ), yu(l, t), l === null && (t.flags |= 4194304), t.child;
      case 5:
        return l === null && F && ((n = a = ml) && (a = Gm(
          a,
          t.type,
          t.pendingProps,
          At
        ), a !== null ? (t.stateNode = a, Bl = t, ml = zt(a.firstChild), At = !1, n = !0) : n = !1), n || ne(t)), Ua(t), n = t.type, u = t.pendingProps, i = l !== null ? l.memoizedProps : null, a = u.children, Ic(n, u) ? a = null : i !== null && Ic(n, i) && (t.flags |= 32), t.memoizedState !== null && (n = Fi(
          l,
          t,
          lm,
          null,
          null,
          e
        ), An._currentValue = n), yu(l, t), Gl(l, t, a, e), t.child;
      case 6:
        return l === null && F && ((l = e = ml) && (e = Qm(
          e,
          t.pendingProps,
          At
        ), e !== null ? (t.stateNode = e, Bl = t, ml = null, l = !0) : l = !1), l || ne(t)), null;
      case 13:
        return Jo(l, t, e);
      case 4:
        return Vl(
          t,
          t.stateNode.containerInfo
        ), a = t.pendingProps, l === null ? t.child = Ge(
          t,
          null,
          a,
          e
        ) : Gl(l, t, a, e), t.child;
      case 11:
        return Yo(
          l,
          t,
          t.type,
          t.pendingProps,
          e
        );
      case 7:
        return Gl(
          l,
          t,
          t.pendingProps,
          e
        ), t.child;
      case 8:
        return Gl(
          l,
          t,
          t.pendingProps.children,
          e
        ), t.child;
      case 12:
        return Gl(
          l,
          t,
          t.pendingProps.children,
          e
        ), t.child;
      case 10:
        return a = t.pendingProps, ue(t, t.type, a.value), Gl(l, t, a.children, e), t.child;
      case 9:
        return n = t.type._context, a = t.pendingProps.children, He(t), n = Yl(n), a = a(n), t.flags |= 1, Gl(l, t, a, e), t.child;
      case 14:
        return Go(
          l,
          t,
          t.type,
          t.pendingProps,
          e
        );
      case 15:
        return Qo(
          l,
          t,
          t.type,
          t.pendingProps,
          e
        );
      case 19:
        return Wo(l, t, e);
      case 31:
        return fm(l, t, e);
      case 22:
        return Xo(
          l,
          t,
          e,
          t.pendingProps
        );
      case 24:
        return He(t), a = Yl(zl), l === null ? (n = Xi(), n === null && (n = rl, u = Gi(), n.pooledCache = u, u.refCount++, u !== null && (n.pooledCacheLanes |= e), n = u), t.memoizedState = { parent: a, cache: n }, Li(t), ue(t, zl, n)) : ((l.lanes & e) !== 0 && (Vi(l, t), tn(t, null, null, e), ln()), n = l.memoizedState, u = t.memoizedState, n.parent !== a ? (n = { parent: a, cache: a }, t.memoizedState = n, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = n), ue(t, zl, a)) : (a = u.cache, ue(t, zl, a), a !== n.cache && Yi(
          t,
          [zl],
          e,
          !0
        ))), Gl(
          l,
          t,
          t.pendingProps.children,
          e
        ), t.child;
      case 29:
        throw t.pendingProps;
    }
    throw Error(h(156, t.tag));
  }
  function Vt(l) {
    l.flags |= 4;
  }
  function _c(l, t, e, a, n) {
    if ((t = (l.mode & 32) !== 0) && (t = !1), t) {
      if (l.flags |= 16777216, (n & 335544128) === n)
        if (l.stateNode.complete) l.flags |= 8192;
        else if (Tr()) l.flags |= 8192;
        else
          throw Ye = lu, Zi;
    } else l.flags &= -16777217;
  }
  function Fo(l, t) {
    if (t.type !== "stylesheet" || (t.state.loading & 4) !== 0)
      l.flags &= -16777217;
    else if (l.flags |= 16777216, !dd(t))
      if (Tr()) l.flags |= 8192;
      else
        throw Ye = lu, Zi;
  }
  function gu(l, t) {
    t !== null && (l.flags |= 4), l.flags & 16384 && (t = l.tag !== 22 ? Df() : 536870912, l.lanes |= t, Ea |= t);
  }
  function fn(l, t) {
    if (!F)
      switch (l.tailMode) {
        case "hidden":
          t = l.tail;
          for (var e = null; t !== null; )
            t.alternate !== null && (e = t), t = t.sibling;
          e === null ? l.tail = null : e.sibling = null;
          break;
        case "collapsed":
          e = l.tail;
          for (var a = null; e !== null; )
            e.alternate !== null && (a = e), e = e.sibling;
          a === null ? t || l.tail === null ? l.tail = null : l.tail.sibling = null : a.sibling = null;
      }
  }
  function yl(l) {
    var t = l.alternate !== null && l.alternate.child === l.child, e = 0, a = 0;
    if (t)
      for (var n = l.child; n !== null; )
        e |= n.lanes | n.childLanes, a |= n.subtreeFlags & 65011712, a |= n.flags & 65011712, n.return = l, n = n.sibling;
    else
      for (n = l.child; n !== null; )
        e |= n.lanes | n.childLanes, a |= n.subtreeFlags, a |= n.flags, n.return = l, n = n.sibling;
    return l.subtreeFlags |= a, l.childLanes = e, t;
  }
  function om(l, t, e) {
    var a = t.pendingProps;
    switch (Ri(t), t.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return yl(t), null;
      case 1:
        return yl(t), null;
      case 3:
        return e = t.stateNode, a = null, l !== null && (a = l.memoizedState.cache), t.memoizedState.cache !== a && (t.flags |= 2048), Qt(zl), Sl(), e.pendingContext && (e.context = e.pendingContext, e.pendingContext = null), (l === null || l.child === null) && (fa(t) ? Vt(t) : l === null || l.memoizedState.isDehydrated && (t.flags & 256) === 0 || (t.flags |= 1024, Hi())), yl(t), null;
      case 26:
        var n = t.type, u = t.memoizedState;
        return l === null ? (Vt(t), u !== null ? (yl(t), Fo(t, u)) : (yl(t), _c(
          t,
          n,
          null,
          a,
          e
        ))) : u ? u !== l.memoizedState ? (Vt(t), yl(t), Fo(t, u)) : (yl(t), t.flags &= -16777217) : (l = l.memoizedProps, l !== a && Vt(t), yl(t), _c(
          t,
          n,
          l,
          a,
          e
        )), null;
      case 27:
        if (On(t), e = K.current, n = t.type, l !== null && t.stateNode != null)
          l.memoizedProps !== a && Vt(t);
        else {
          if (!a) {
            if (t.stateNode === null)
              throw Error(h(166));
            return yl(t), null;
          }
          l = M.current, fa(t) ? Ds(t) : (l = nd(n, a, e), t.stateNode = l, Vt(t));
        }
        return yl(t), null;
      case 5:
        if (On(t), n = t.type, l !== null && t.stateNode != null)
          l.memoizedProps !== a && Vt(t);
        else {
          if (!a) {
            if (t.stateNode === null)
              throw Error(h(166));
            return yl(t), null;
          }
          if (u = M.current, fa(t))
            Ds(t);
          else {
            var i = Uu(
              K.current
            );
            switch (u) {
              case 1:
                u = i.createElementNS(
                  "http://www.w3.org/2000/svg",
                  n
                );
                break;
              case 2:
                u = i.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  n
                );
                break;
              default:
                switch (n) {
                  case "svg":
                    u = i.createElementNS(
                      "http://www.w3.org/2000/svg",
                      n
                    );
                    break;
                  case "math":
                    u = i.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      n
                    );
                    break;
                  case "script":
                    u = i.createElement("div"), u.innerHTML = "<script><\/script>", u = u.removeChild(
                      u.firstChild
                    );
                    break;
                  case "select":
                    u = typeof a.is == "string" ? i.createElement("select", {
                      is: a.is
                    }) : i.createElement("select"), a.multiple ? u.multiple = !0 : a.size && (u.size = a.size);
                    break;
                  default:
                    u = typeof a.is == "string" ? i.createElement(n, { is: a.is }) : i.createElement(n);
                }
            }
            u[ql] = t, u[Wl] = a;
            l: for (i = t.child; i !== null; ) {
              if (i.tag === 5 || i.tag === 6)
                u.appendChild(i.stateNode);
              else if (i.tag !== 4 && i.tag !== 27 && i.child !== null) {
                i.child.return = i, i = i.child;
                continue;
              }
              if (i === t) break l;
              for (; i.sibling === null; ) {
                if (i.return === null || i.return === t)
                  break l;
                i = i.return;
              }
              i.sibling.return = i.return, i = i.sibling;
            }
            t.stateNode = u;
            l: switch (Ql(u, n, a), n) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                a = !!a.autoFocus;
                break l;
              case "img":
                a = !0;
                break l;
              default:
                a = !1;
            }
            a && Vt(t);
          }
        }
        return yl(t), _c(
          t,
          t.type,
          l === null ? null : l.memoizedProps,
          t.pendingProps,
          e
        ), null;
      case 6:
        if (l && t.stateNode != null)
          l.memoizedProps !== a && Vt(t);
        else {
          if (typeof a != "string" && t.stateNode === null)
            throw Error(h(166));
          if (l = K.current, fa(t)) {
            if (l = t.stateNode, e = t.memoizedProps, a = null, n = Bl, n !== null)
              switch (n.tag) {
                case 27:
                case 5:
                  a = n.memoizedProps;
              }
            l[ql] = t, l = !!(l.nodeValue === e || a !== null && a.suppressHydrationWarning === !0 || Jr(l.nodeValue, e)), l || ne(t, !0);
          } else
            l = Uu(l).createTextNode(
              a
            ), l[ql] = t, t.stateNode = l;
        }
        return yl(t), null;
      case 31:
        if (e = t.memoizedState, l === null || l.memoizedState !== null) {
          if (a = fa(t), e !== null) {
            if (l === null) {
              if (!a) throw Error(h(318));
              if (l = t.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(h(557));
              l[ql] = t;
            } else
              Re(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4;
            yl(t), l = !1;
          } else
            e = Hi(), l !== null && l.memoizedState !== null && (l.memoizedState.hydrationErrors = e), l = !0;
          if (!l)
            return t.flags & 256 ? (st(t), t) : (st(t), null);
          if ((t.flags & 128) !== 0)
            throw Error(h(558));
        }
        return yl(t), null;
      case 13:
        if (a = t.memoizedState, l === null || l.memoizedState !== null && l.memoizedState.dehydrated !== null) {
          if (n = fa(t), a !== null && a.dehydrated !== null) {
            if (l === null) {
              if (!n) throw Error(h(318));
              if (n = t.memoizedState, n = n !== null ? n.dehydrated : null, !n) throw Error(h(317));
              n[ql] = t;
            } else
              Re(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4;
            yl(t), n = !1;
          } else
            n = Hi(), l !== null && l.memoizedState !== null && (l.memoizedState.hydrationErrors = n), n = !0;
          if (!n)
            return t.flags & 256 ? (st(t), t) : (st(t), null);
        }
        return st(t), (t.flags & 128) !== 0 ? (t.lanes = e, t) : (e = a !== null, l = l !== null && l.memoizedState !== null, e && (a = t.child, n = null, a.alternate !== null && a.alternate.memoizedState !== null && a.alternate.memoizedState.cachePool !== null && (n = a.alternate.memoizedState.cachePool.pool), u = null, a.memoizedState !== null && a.memoizedState.cachePool !== null && (u = a.memoizedState.cachePool.pool), u !== n && (a.flags |= 2048)), e !== l && e && (t.child.flags |= 8192), gu(t, t.updateQueue), yl(t), null);
      case 4:
        return Sl(), l === null && Jc(t.stateNode.containerInfo), yl(t), null;
      case 10:
        return Qt(t.type), yl(t), null;
      case 19:
        if (z(El), a = t.memoizedState, a === null) return yl(t), null;
        if (n = (t.flags & 128) !== 0, u = a.rendering, u === null)
          if (n) fn(a, !1);
          else {
            if (bl !== 0 || l !== null && (l.flags & 128) !== 0)
              for (l = t.child; l !== null; ) {
                if (u = nu(l), u !== null) {
                  for (t.flags |= 128, fn(a, !1), l = u.updateQueue, t.updateQueue = l, gu(t, l), t.subtreeFlags = 0, l = e, e = t.child; e !== null; )
                    zs(e, l), e = e.sibling;
                  return x(
                    El,
                    El.current & 1 | 2
                  ), F && Yt(t, a.treeForkCount), t.child;
                }
                l = l.sibling;
              }
            a.tail !== null && at() > Au && (t.flags |= 128, n = !0, fn(a, !1), t.lanes = 4194304);
          }
        else {
          if (!n)
            if (l = nu(u), l !== null) {
              if (t.flags |= 128, n = !0, l = l.updateQueue, t.updateQueue = l, gu(t, l), fn(a, !0), a.tail === null && a.tailMode === "hidden" && !u.alternate && !F)
                return yl(t), null;
            } else
              2 * at() - a.renderingStartTime > Au && e !== 536870912 && (t.flags |= 128, n = !0, fn(a, !1), t.lanes = 4194304);
          a.isBackwards ? (u.sibling = t.child, t.child = u) : (l = a.last, l !== null ? l.sibling = u : t.child = u, a.last = u);
        }
        return a.tail !== null ? (l = a.tail, a.rendering = l, a.tail = l.sibling, a.renderingStartTime = at(), l.sibling = null, e = El.current, x(
          El,
          n ? e & 1 | 2 : e & 1
        ), F && Yt(t, a.treeForkCount), l) : (yl(t), null);
      case 22:
      case 23:
        return st(t), ki(), a = t.memoizedState !== null, l !== null ? l.memoizedState !== null !== a && (t.flags |= 8192) : a && (t.flags |= 8192), a ? (e & 536870912) !== 0 && (t.flags & 128) === 0 && (yl(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : yl(t), e = t.updateQueue, e !== null && gu(t, e.retryQueue), e = null, l !== null && l.memoizedState !== null && l.memoizedState.cachePool !== null && (e = l.memoizedState.cachePool.pool), a = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (a = t.memoizedState.cachePool.pool), a !== e && (t.flags |= 2048), l !== null && z(qe), null;
      case 24:
        return e = null, l !== null && (e = l.memoizedState.cache), t.memoizedState.cache !== e && (t.flags |= 2048), Qt(zl), yl(t), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(h(156, t.tag));
  }
  function rm(l, t) {
    switch (Ri(t), t.tag) {
      case 1:
        return l = t.flags, l & 65536 ? (t.flags = l & -65537 | 128, t) : null;
      case 3:
        return Qt(zl), Sl(), l = t.flags, (l & 65536) !== 0 && (l & 128) === 0 ? (t.flags = l & -65537 | 128, t) : null;
      case 26:
      case 27:
      case 5:
        return On(t), null;
      case 31:
        if (t.memoizedState !== null) {
          if (st(t), t.alternate === null)
            throw Error(h(340));
          Re();
        }
        return l = t.flags, l & 65536 ? (t.flags = l & -65537 | 128, t) : null;
      case 13:
        if (st(t), l = t.memoizedState, l !== null && l.dehydrated !== null) {
          if (t.alternate === null)
            throw Error(h(340));
          Re();
        }
        return l = t.flags, l & 65536 ? (t.flags = l & -65537 | 128, t) : null;
      case 19:
        return z(El), null;
      case 4:
        return Sl(), null;
      case 10:
        return Qt(t.type), null;
      case 22:
      case 23:
        return st(t), ki(), l !== null && z(qe), l = t.flags, l & 65536 ? (t.flags = l & -65537 | 128, t) : null;
      case 24:
        return Qt(zl), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function Io(l, t) {
    switch (Ri(t), t.tag) {
      case 3:
        Qt(zl), Sl();
        break;
      case 26:
      case 27:
      case 5:
        On(t);
        break;
      case 4:
        Sl();
        break;
      case 31:
        t.memoizedState !== null && st(t);
        break;
      case 13:
        st(t);
        break;
      case 19:
        z(El);
        break;
      case 10:
        Qt(t.type);
        break;
      case 22:
      case 23:
        st(t), ki(), l !== null && z(qe);
        break;
      case 24:
        Qt(zl);
    }
  }
  function sn(l, t) {
    try {
      var e = t.updateQueue, a = e !== null ? e.lastEffect : null;
      if (a !== null) {
        var n = a.next;
        e = n;
        do {
          if ((e.tag & l) === l) {
            a = void 0;
            var u = e.create, i = e.inst;
            a = u(), i.destroy = a;
          }
          e = e.next;
        } while (e !== n);
      }
    } catch (c) {
      nl(t, t.return, c);
    }
  }
  function re(l, t, e) {
    try {
      var a = t.updateQueue, n = a !== null ? a.lastEffect : null;
      if (n !== null) {
        var u = n.next;
        a = u;
        do {
          if ((a.tag & l) === l) {
            var i = a.inst, c = i.destroy;
            if (c !== void 0) {
              i.destroy = void 0, n = t;
              var s = e, y = c;
              try {
                y();
              } catch (p) {
                nl(
                  n,
                  s,
                  p
                );
              }
            }
          }
          a = a.next;
        } while (a !== u);
      }
    } catch (p) {
      nl(t, t.return, p);
    }
  }
  function Po(l) {
    var t = l.updateQueue;
    if (t !== null) {
      var e = l.stateNode;
      try {
        Zs(t, e);
      } catch (a) {
        nl(l, l.return, a);
      }
    }
  }
  function lr(l, t, e) {
    e.props = Xe(
      l.type,
      l.memoizedProps
    ), e.state = l.memoizedState;
    try {
      e.componentWillUnmount();
    } catch (a) {
      nl(l, t, a);
    }
  }
  function on(l, t) {
    try {
      var e = l.ref;
      if (e !== null) {
        switch (l.tag) {
          case 26:
          case 27:
          case 5:
            var a = l.stateNode;
            break;
          case 30:
            a = l.stateNode;
            break;
          default:
            a = l.stateNode;
        }
        typeof e == "function" ? l.refCleanup = e(a) : e.current = a;
      }
    } catch (n) {
      nl(l, t, n);
    }
  }
  function Ut(l, t) {
    var e = l.ref, a = l.refCleanup;
    if (e !== null)
      if (typeof a == "function")
        try {
          a();
        } catch (n) {
          nl(l, t, n);
        } finally {
          l.refCleanup = null, l = l.alternate, l != null && (l.refCleanup = null);
        }
      else if (typeof e == "function")
        try {
          e(null);
        } catch (n) {
          nl(l, t, n);
        }
      else e.current = null;
  }
  function tr(l) {
    var t = l.type, e = l.memoizedProps, a = l.stateNode;
    try {
      l: switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          e.autoFocus && a.focus();
          break l;
        case "img":
          e.src ? a.src = e.src : e.srcSet && (a.srcset = e.srcSet);
      }
    } catch (n) {
      nl(l, l.return, n);
    }
  }
  function xc(l, t, e) {
    try {
      var a = l.stateNode;
      Rm(a, l.type, e, t), a[Wl] = t;
    } catch (n) {
      nl(l, l.return, n);
    }
  }
  function er(l) {
    return l.tag === 5 || l.tag === 3 || l.tag === 26 || l.tag === 27 && pe(l.type) || l.tag === 4;
  }
  function jc(l) {
    l: for (; ; ) {
      for (; l.sibling === null; ) {
        if (l.return === null || er(l.return)) return null;
        l = l.return;
      }
      for (l.sibling.return = l.return, l = l.sibling; l.tag !== 5 && l.tag !== 6 && l.tag !== 18; ) {
        if (l.tag === 27 && pe(l.type) || l.flags & 2 || l.child === null || l.tag === 4) continue l;
        l.child.return = l, l = l.child;
      }
      if (!(l.flags & 2)) return l.stateNode;
    }
  }
  function Oc(l, t, e) {
    var a = l.tag;
    if (a === 5 || a === 6)
      l = l.stateNode, t ? (e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e).insertBefore(l, t) : (t = e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e, t.appendChild(l), e = e._reactRootContainer, e != null || t.onclick !== null || (t.onclick = Ht));
    else if (a !== 4 && (a === 27 && pe(l.type) && (e = l.stateNode, t = null), l = l.child, l !== null))
      for (Oc(l, t, e), l = l.sibling; l !== null; )
        Oc(l, t, e), l = l.sibling;
  }
  function pu(l, t, e) {
    var a = l.tag;
    if (a === 5 || a === 6)
      l = l.stateNode, t ? e.insertBefore(l, t) : e.appendChild(l);
    else if (a !== 4 && (a === 27 && pe(l.type) && (e = l.stateNode), l = l.child, l !== null))
      for (pu(l, t, e), l = l.sibling; l !== null; )
        pu(l, t, e), l = l.sibling;
  }
  function ar(l) {
    var t = l.stateNode, e = l.memoizedProps;
    try {
      for (var a = l.type, n = t.attributes; n.length; )
        t.removeAttributeNode(n[0]);
      Ql(t, a, e), t[ql] = l, t[Wl] = e;
    } catch (u) {
      nl(l, l.return, u);
    }
  }
  var Kt = !1, jl = !1, Dc = !1, nr = typeof WeakSet == "function" ? WeakSet : Set, Ul = null;
  function dm(l, t) {
    if (l = l.containerInfo, $c = Gu, l = ys(l), Ai(l)) {
      if ("selectionStart" in l)
        var e = {
          start: l.selectionStart,
          end: l.selectionEnd
        };
      else
        l: {
          e = (e = l.ownerDocument) && e.defaultView || window;
          var a = e.getSelection && e.getSelection();
          if (a && a.rangeCount !== 0) {
            e = a.anchorNode;
            var n = a.anchorOffset, u = a.focusNode;
            a = a.focusOffset;
            try {
              e.nodeType, u.nodeType;
            } catch {
              e = null;
              break l;
            }
            var i = 0, c = -1, s = -1, y = 0, p = 0, A = l, v = null;
            t: for (; ; ) {
              for (var g; A !== e || n !== 0 && A.nodeType !== 3 || (c = i + n), A !== u || a !== 0 && A.nodeType !== 3 || (s = i + a), A.nodeType === 3 && (i += A.nodeValue.length), (g = A.firstChild) !== null; )
                v = A, A = g;
              for (; ; ) {
                if (A === l) break t;
                if (v === e && ++y === n && (c = i), v === u && ++p === a && (s = i), (g = A.nextSibling) !== null) break;
                A = v, v = A.parentNode;
              }
              A = g;
            }
            e = c === -1 || s === -1 ? null : { start: c, end: s };
          } else e = null;
        }
      e = e || { start: 0, end: 0 };
    } else e = null;
    for (Fc = { focusedElem: l, selectionRange: e }, Gu = !1, Ul = t; Ul !== null; )
      if (t = Ul, l = t.child, (t.subtreeFlags & 1028) !== 0 && l !== null)
        l.return = t, Ul = l;
      else
        for (; Ul !== null; ) {
          switch (t = Ul, u = t.alternate, l = t.flags, t.tag) {
            case 0:
              if ((l & 4) !== 0 && (l = t.updateQueue, l = l !== null ? l.events : null, l !== null))
                for (e = 0; e < l.length; e++)
                  n = l[e], n.ref.impl = n.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((l & 1024) !== 0 && u !== null) {
                l = void 0, e = t, n = u.memoizedProps, u = u.memoizedState, a = e.stateNode;
                try {
                  var D = Xe(
                    e.type,
                    n
                  );
                  l = a.getSnapshotBeforeUpdate(
                    D,
                    u
                  ), a.__reactInternalSnapshotBeforeUpdate = l;
                } catch (q) {
                  nl(
                    e,
                    e.return,
                    q
                  );
                }
              }
              break;
            case 3:
              if ((l & 1024) !== 0) {
                if (l = t.stateNode.containerInfo, e = l.nodeType, e === 9)
                  lf(l);
                else if (e === 1)
                  switch (l.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      lf(l);
                      break;
                    default:
                      l.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((l & 1024) !== 0) throw Error(h(163));
          }
          if (l = t.sibling, l !== null) {
            l.return = t.return, Ul = l;
            break;
          }
          Ul = t.return;
        }
  }
  function ur(l, t, e) {
    var a = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        Jt(l, e), a & 4 && sn(5, e);
        break;
      case 1:
        if (Jt(l, e), a & 4)
          if (l = e.stateNode, t === null)
            try {
              l.componentDidMount();
            } catch (i) {
              nl(e, e.return, i);
            }
          else {
            var n = Xe(
              e.type,
              t.memoizedProps
            );
            t = t.memoizedState;
            try {
              l.componentDidUpdate(
                n,
                t,
                l.__reactInternalSnapshotBeforeUpdate
              );
            } catch (i) {
              nl(
                e,
                e.return,
                i
              );
            }
          }
        a & 64 && Po(e), a & 512 && on(e, e.return);
        break;
      case 3:
        if (Jt(l, e), a & 64 && (l = e.updateQueue, l !== null)) {
          if (t = null, e.child !== null)
            switch (e.child.tag) {
              case 27:
              case 5:
                t = e.child.stateNode;
                break;
              case 1:
                t = e.child.stateNode;
            }
          try {
            Zs(l, t);
          } catch (i) {
            nl(e, e.return, i);
          }
        }
        break;
      case 27:
        t === null && a & 4 && ar(e);
      case 26:
      case 5:
        Jt(l, e), t === null && a & 4 && tr(e), a & 512 && on(e, e.return);
        break;
      case 12:
        Jt(l, e);
        break;
      case 31:
        Jt(l, e), a & 4 && fr(l, e);
        break;
      case 13:
        Jt(l, e), a & 4 && sr(l, e), a & 64 && (l = e.memoizedState, l !== null && (l = l.dehydrated, l !== null && (e = Em.bind(
          null,
          e
        ), Xm(l, e))));
        break;
      case 22:
        if (a = e.memoizedState !== null || Kt, !a) {
          t = t !== null && t.memoizedState !== null || jl, n = Kt;
          var u = jl;
          Kt = a, (jl = t) && !u ? kt(
            l,
            e,
            (e.subtreeFlags & 8772) !== 0
          ) : Jt(l, e), Kt = n, jl = u;
        }
        break;
      case 30:
        break;
      default:
        Jt(l, e);
    }
  }
  function ir(l) {
    var t = l.alternate;
    t !== null && (l.alternate = null, ir(t)), l.child = null, l.deletions = null, l.sibling = null, l.tag === 5 && (t = l.stateNode, t !== null && ui(t)), l.stateNode = null, l.return = null, l.dependencies = null, l.memoizedProps = null, l.memoizedState = null, l.pendingProps = null, l.stateNode = null, l.updateQueue = null;
  }
  var gl = null, Fl = !1;
  function wt(l, t, e) {
    for (e = e.child; e !== null; )
      cr(l, t, e), e = e.sibling;
  }
  function cr(l, t, e) {
    if (nt && typeof nt.onCommitFiberUnmount == "function")
      try {
        nt.onCommitFiberUnmount(Ra, e);
      } catch {
      }
    switch (e.tag) {
      case 26:
        jl || Ut(e, t), wt(
          l,
          t,
          e
        ), e.memoizedState ? e.memoizedState.count-- : e.stateNode && (e = e.stateNode, e.parentNode.removeChild(e));
        break;
      case 27:
        jl || Ut(e, t);
        var a = gl, n = Fl;
        pe(e.type) && (gl = e.stateNode, Fl = !1), wt(
          l,
          t,
          e
        ), bn(e.stateNode), gl = a, Fl = n;
        break;
      case 5:
        jl || Ut(e, t);
      case 6:
        if (a = gl, n = Fl, gl = null, wt(
          l,
          t,
          e
        ), gl = a, Fl = n, gl !== null)
          if (Fl)
            try {
              (gl.nodeType === 9 ? gl.body : gl.nodeName === "HTML" ? gl.ownerDocument.body : gl).removeChild(e.stateNode);
            } catch (u) {
              nl(
                e,
                t,
                u
              );
            }
          else
            try {
              gl.removeChild(e.stateNode);
            } catch (u) {
              nl(
                e,
                t,
                u
              );
            }
        break;
      case 18:
        gl !== null && (Fl ? (l = gl, Pr(
          l.nodeType === 9 ? l.body : l.nodeName === "HTML" ? l.ownerDocument.body : l,
          e.stateNode
        ), Da(l)) : Pr(gl, e.stateNode));
        break;
      case 4:
        a = gl, n = Fl, gl = e.stateNode.containerInfo, Fl = !0, wt(
          l,
          t,
          e
        ), gl = a, Fl = n;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        re(2, e, t), jl || re(4, e, t), wt(
          l,
          t,
          e
        );
        break;
      case 1:
        jl || (Ut(e, t), a = e.stateNode, typeof a.componentWillUnmount == "function" && lr(
          e,
          t,
          a
        )), wt(
          l,
          t,
          e
        );
        break;
      case 21:
        wt(
          l,
          t,
          e
        );
        break;
      case 22:
        jl = (a = jl) || e.memoizedState !== null, wt(
          l,
          t,
          e
        ), jl = a;
        break;
      default:
        wt(
          l,
          t,
          e
        );
    }
  }
  function fr(l, t) {
    if (t.memoizedState === null && (l = t.alternate, l !== null && (l = l.memoizedState, l !== null))) {
      l = l.dehydrated;
      try {
        Da(l);
      } catch (e) {
        nl(t, t.return, e);
      }
    }
  }
  function sr(l, t) {
    if (t.memoizedState === null && (l = t.alternate, l !== null && (l = l.memoizedState, l !== null && (l = l.dehydrated, l !== null))))
      try {
        Da(l);
      } catch (e) {
        nl(t, t.return, e);
      }
  }
  function hm(l) {
    switch (l.tag) {
      case 31:
      case 13:
      case 19:
        var t = l.stateNode;
        return t === null && (t = l.stateNode = new nr()), t;
      case 22:
        return l = l.stateNode, t = l._retryCache, t === null && (t = l._retryCache = new nr()), t;
      default:
        throw Error(h(435, l.tag));
    }
  }
  function bu(l, t) {
    var e = hm(l);
    t.forEach(function(a) {
      if (!e.has(a)) {
        e.add(a);
        var n = Am.bind(null, l, a);
        a.then(n, n);
      }
    });
  }
  function Il(l, t) {
    var e = t.deletions;
    if (e !== null)
      for (var a = 0; a < e.length; a++) {
        var n = e[a], u = l, i = t, c = i;
        l: for (; c !== null; ) {
          switch (c.tag) {
            case 27:
              if (pe(c.type)) {
                gl = c.stateNode, Fl = !1;
                break l;
              }
              break;
            case 5:
              gl = c.stateNode, Fl = !1;
              break l;
            case 3:
            case 4:
              gl = c.stateNode.containerInfo, Fl = !0;
              break l;
          }
          c = c.return;
        }
        if (gl === null) throw Error(h(160));
        cr(u, i, n), gl = null, Fl = !1, u = n.alternate, u !== null && (u.return = null), n.return = null;
      }
    if (t.subtreeFlags & 13886)
      for (t = t.child; t !== null; )
        or(t, l), t = t.sibling;
  }
  var jt = null;
  function or(l, t) {
    var e = l.alternate, a = l.flags;
    switch (l.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        Il(t, l), Pl(l), a & 4 && (re(3, l, l.return), sn(3, l), re(5, l, l.return));
        break;
      case 1:
        Il(t, l), Pl(l), a & 512 && (jl || e === null || Ut(e, e.return)), a & 64 && Kt && (l = l.updateQueue, l !== null && (a = l.callbacks, a !== null && (e = l.shared.hiddenCallbacks, l.shared.hiddenCallbacks = e === null ? a : e.concat(a))));
        break;
      case 26:
        var n = jt;
        if (Il(t, l), Pl(l), a & 512 && (jl || e === null || Ut(e, e.return)), a & 4) {
          var u = e !== null ? e.memoizedState : null;
          if (a = l.memoizedState, e === null)
            if (a === null)
              if (l.stateNode === null) {
                l: {
                  a = l.type, e = l.memoizedProps, n = n.ownerDocument || n;
                  t: switch (a) {
                    case "title":
                      u = n.getElementsByTagName("title")[0], (!u || u[qa] || u[ql] || u.namespaceURI === "http://www.w3.org/2000/svg" || u.hasAttribute("itemprop")) && (u = n.createElement(a), n.head.insertBefore(
                        u,
                        n.querySelector("head > title")
                      )), Ql(u, a, e), u[ql] = l, Nl(u), a = u;
                      break l;
                    case "link":
                      var i = od(
                        "link",
                        "href",
                        n
                      ).get(a + (e.href || ""));
                      if (i) {
                        for (var c = 0; c < i.length; c++)
                          if (u = i[c], u.getAttribute("href") === (e.href == null || e.href === "" ? null : e.href) && u.getAttribute("rel") === (e.rel == null ? null : e.rel) && u.getAttribute("title") === (e.title == null ? null : e.title) && u.getAttribute("crossorigin") === (e.crossOrigin == null ? null : e.crossOrigin)) {
                            i.splice(c, 1);
                            break t;
                          }
                      }
                      u = n.createElement(a), Ql(u, a, e), n.head.appendChild(u);
                      break;
                    case "meta":
                      if (i = od(
                        "meta",
                        "content",
                        n
                      ).get(a + (e.content || ""))) {
                        for (c = 0; c < i.length; c++)
                          if (u = i[c], u.getAttribute("content") === (e.content == null ? null : "" + e.content) && u.getAttribute("name") === (e.name == null ? null : e.name) && u.getAttribute("property") === (e.property == null ? null : e.property) && u.getAttribute("http-equiv") === (e.httpEquiv == null ? null : e.httpEquiv) && u.getAttribute("charset") === (e.charSet == null ? null : e.charSet)) {
                            i.splice(c, 1);
                            break t;
                          }
                      }
                      u = n.createElement(a), Ql(u, a, e), n.head.appendChild(u);
                      break;
                    default:
                      throw Error(h(468, a));
                  }
                  u[ql] = l, Nl(u), a = u;
                }
                l.stateNode = a;
              } else
                rd(
                  n,
                  l.type,
                  l.stateNode
                );
            else
              l.stateNode = sd(
                n,
                a,
                l.memoizedProps
              );
          else
            u !== a ? (u === null ? e.stateNode !== null && (e = e.stateNode, e.parentNode.removeChild(e)) : u.count--, a === null ? rd(
              n,
              l.type,
              l.stateNode
            ) : sd(
              n,
              a,
              l.memoizedProps
            )) : a === null && l.stateNode !== null && xc(
              l,
              l.memoizedProps,
              e.memoizedProps
            );
        }
        break;
      case 27:
        Il(t, l), Pl(l), a & 512 && (jl || e === null || Ut(e, e.return)), e !== null && a & 4 && xc(
          l,
          l.memoizedProps,
          e.memoizedProps
        );
        break;
      case 5:
        if (Il(t, l), Pl(l), a & 512 && (jl || e === null || Ut(e, e.return)), l.flags & 32) {
          n = l.stateNode;
          try {
            Ie(n, "");
          } catch (D) {
            nl(l, l.return, D);
          }
        }
        a & 4 && l.stateNode != null && (n = l.memoizedProps, xc(
          l,
          n,
          e !== null ? e.memoizedProps : n
        )), a & 1024 && (Dc = !0);
        break;
      case 6:
        if (Il(t, l), Pl(l), a & 4) {
          if (l.stateNode === null)
            throw Error(h(162));
          a = l.memoizedProps, e = l.stateNode;
          try {
            e.nodeValue = a;
          } catch (D) {
            nl(l, l.return, D);
          }
        }
        break;
      case 3:
        if (Hu = null, n = jt, jt = Ru(t.containerInfo), Il(t, l), jt = n, Pl(l), a & 4 && e !== null && e.memoizedState.isDehydrated)
          try {
            Da(t.containerInfo);
          } catch (D) {
            nl(l, l.return, D);
          }
        Dc && (Dc = !1, rr(l));
        break;
      case 4:
        a = jt, jt = Ru(
          l.stateNode.containerInfo
        ), Il(t, l), Pl(l), jt = a;
        break;
      case 12:
        Il(t, l), Pl(l);
        break;
      case 31:
        Il(t, l), Pl(l), a & 4 && (a = l.updateQueue, a !== null && (l.updateQueue = null, bu(l, a)));
        break;
      case 13:
        Il(t, l), Pl(l), l.child.flags & 8192 && l.memoizedState !== null != (e !== null && e.memoizedState !== null) && (Eu = at()), a & 4 && (a = l.updateQueue, a !== null && (l.updateQueue = null, bu(l, a)));
        break;
      case 22:
        n = l.memoizedState !== null;
        var s = e !== null && e.memoizedState !== null, y = Kt, p = jl;
        if (Kt = y || n, jl = p || s, Il(t, l), jl = p, Kt = y, Pl(l), a & 8192)
          l: for (t = l.stateNode, t._visibility = n ? t._visibility & -2 : t._visibility | 1, n && (e === null || s || Kt || jl || Ze(l)), e = null, t = l; ; ) {
            if (t.tag === 5 || t.tag === 26) {
              if (e === null) {
                s = e = t;
                try {
                  if (u = s.stateNode, n)
                    i = u.style, typeof i.setProperty == "function" ? i.setProperty("display", "none", "important") : i.display = "none";
                  else {
                    c = s.stateNode;
                    var A = s.memoizedProps.style, v = A != null && A.hasOwnProperty("display") ? A.display : null;
                    c.style.display = v == null || typeof v == "boolean" ? "" : ("" + v).trim();
                  }
                } catch (D) {
                  nl(s, s.return, D);
                }
              }
            } else if (t.tag === 6) {
              if (e === null) {
                s = t;
                try {
                  s.stateNode.nodeValue = n ? "" : s.memoizedProps;
                } catch (D) {
                  nl(s, s.return, D);
                }
              }
            } else if (t.tag === 18) {
              if (e === null) {
                s = t;
                try {
                  var g = s.stateNode;
                  n ? ld(g, !0) : ld(s.stateNode, !1);
                } catch (D) {
                  nl(s, s.return, D);
                }
              }
            } else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === l) && t.child !== null) {
              t.child.return = t, t = t.child;
              continue;
            }
            if (t === l) break l;
            for (; t.sibling === null; ) {
              if (t.return === null || t.return === l) break l;
              e === t && (e = null), t = t.return;
            }
            e === t && (e = null), t.sibling.return = t.return, t = t.sibling;
          }
        a & 4 && (a = l.updateQueue, a !== null && (e = a.retryQueue, e !== null && (a.retryQueue = null, bu(l, e))));
        break;
      case 19:
        Il(t, l), Pl(l), a & 4 && (a = l.updateQueue, a !== null && (l.updateQueue = null, bu(l, a)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        Il(t, l), Pl(l);
    }
  }
  function Pl(l) {
    var t = l.flags;
    if (t & 2) {
      try {
        for (var e, a = l.return; a !== null; ) {
          if (er(a)) {
            e = a;
            break;
          }
          a = a.return;
        }
        if (e == null) throw Error(h(160));
        switch (e.tag) {
          case 27:
            var n = e.stateNode, u = jc(l);
            pu(l, u, n);
            break;
          case 5:
            var i = e.stateNode;
            e.flags & 32 && (Ie(i, ""), e.flags &= -33);
            var c = jc(l);
            pu(l, c, i);
            break;
          case 3:
          case 4:
            var s = e.stateNode.containerInfo, y = jc(l);
            Oc(
              l,
              y,
              s
            );
            break;
          default:
            throw Error(h(161));
        }
      } catch (p) {
        nl(l, l.return, p);
      }
      l.flags &= -3;
    }
    t & 4096 && (l.flags &= -4097);
  }
  function rr(l) {
    if (l.subtreeFlags & 1024)
      for (l = l.child; l !== null; ) {
        var t = l;
        rr(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), l = l.sibling;
      }
  }
  function Jt(l, t) {
    if (t.subtreeFlags & 8772)
      for (t = t.child; t !== null; )
        ur(l, t.alternate, t), t = t.sibling;
  }
  function Ze(l) {
    for (l = l.child; l !== null; ) {
      var t = l;
      switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          re(4, t, t.return), Ze(t);
          break;
        case 1:
          Ut(t, t.return);
          var e = t.stateNode;
          typeof e.componentWillUnmount == "function" && lr(
            t,
            t.return,
            e
          ), Ze(t);
          break;
        case 27:
          bn(t.stateNode);
        case 26:
        case 5:
          Ut(t, t.return), Ze(t);
          break;
        case 22:
          t.memoizedState === null && Ze(t);
          break;
        case 30:
          Ze(t);
          break;
        default:
          Ze(t);
      }
      l = l.sibling;
    }
  }
  function kt(l, t, e) {
    for (e = e && (t.subtreeFlags & 8772) !== 0, t = t.child; t !== null; ) {
      var a = t.alternate, n = l, u = t, i = u.flags;
      switch (u.tag) {
        case 0:
        case 11:
        case 15:
          kt(
            n,
            u,
            e
          ), sn(4, u);
          break;
        case 1:
          if (kt(
            n,
            u,
            e
          ), a = u, n = a.stateNode, typeof n.componentDidMount == "function")
            try {
              n.componentDidMount();
            } catch (y) {
              nl(a, a.return, y);
            }
          if (a = u, n = a.updateQueue, n !== null) {
            var c = a.stateNode;
            try {
              var s = n.shared.hiddenCallbacks;
              if (s !== null)
                for (n.shared.hiddenCallbacks = null, n = 0; n < s.length; n++)
                  Xs(s[n], c);
            } catch (y) {
              nl(a, a.return, y);
            }
          }
          e && i & 64 && Po(u), on(u, u.return);
          break;
        case 27:
          ar(u);
        case 26:
        case 5:
          kt(
            n,
            u,
            e
          ), e && a === null && i & 4 && tr(u), on(u, u.return);
          break;
        case 12:
          kt(
            n,
            u,
            e
          );
          break;
        case 31:
          kt(
            n,
            u,
            e
          ), e && i & 4 && fr(n, u);
          break;
        case 13:
          kt(
            n,
            u,
            e
          ), e && i & 4 && sr(n, u);
          break;
        case 22:
          u.memoizedState === null && kt(
            n,
            u,
            e
          ), on(u, u.return);
          break;
        case 30:
          break;
        default:
          kt(
            n,
            u,
            e
          );
      }
      t = t.sibling;
    }
  }
  function Mc(l, t) {
    var e = null;
    l !== null && l.memoizedState !== null && l.memoizedState.cachePool !== null && (e = l.memoizedState.cachePool.pool), l = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (l = t.memoizedState.cachePool.pool), l !== e && (l != null && l.refCount++, e != null && Wa(e));
  }
  function Nc(l, t) {
    l = null, t.alternate !== null && (l = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== l && (t.refCount++, l != null && Wa(l));
  }
  function Ot(l, t, e, a) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; )
        dr(
          l,
          t,
          e,
          a
        ), t = t.sibling;
  }
  function dr(l, t, e, a) {
    var n = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        Ot(
          l,
          t,
          e,
          a
        ), n & 2048 && sn(9, t);
        break;
      case 1:
        Ot(
          l,
          t,
          e,
          a
        );
        break;
      case 3:
        Ot(
          l,
          t,
          e,
          a
        ), n & 2048 && (l = null, t.alternate !== null && (l = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== l && (t.refCount++, l != null && Wa(l)));
        break;
      case 12:
        if (n & 2048) {
          Ot(
            l,
            t,
            e,
            a
          ), l = t.stateNode;
          try {
            var u = t.memoizedProps, i = u.id, c = u.onPostCommit;
            typeof c == "function" && c(
              i,
              t.alternate === null ? "mount" : "update",
              l.passiveEffectDuration,
              -0
            );
          } catch (s) {
            nl(t, t.return, s);
          }
        } else
          Ot(
            l,
            t,
            e,
            a
          );
        break;
      case 31:
        Ot(
          l,
          t,
          e,
          a
        );
        break;
      case 13:
        Ot(
          l,
          t,
          e,
          a
        );
        break;
      case 23:
        break;
      case 22:
        u = t.stateNode, i = t.alternate, t.memoizedState !== null ? u._visibility & 2 ? Ot(
          l,
          t,
          e,
          a
        ) : rn(l, t) : u._visibility & 2 ? Ot(
          l,
          t,
          e,
          a
        ) : (u._visibility |= 2, pa(
          l,
          t,
          e,
          a,
          (t.subtreeFlags & 10256) !== 0 || !1
        )), n & 2048 && Mc(i, t);
        break;
      case 24:
        Ot(
          l,
          t,
          e,
          a
        ), n & 2048 && Nc(t.alternate, t);
        break;
      default:
        Ot(
          l,
          t,
          e,
          a
        );
    }
  }
  function pa(l, t, e, a, n) {
    for (n = n && ((t.subtreeFlags & 10256) !== 0 || !1), t = t.child; t !== null; ) {
      var u = l, i = t, c = e, s = a, y = i.flags;
      switch (i.tag) {
        case 0:
        case 11:
        case 15:
          pa(
            u,
            i,
            c,
            s,
            n
          ), sn(8, i);
          break;
        case 23:
          break;
        case 22:
          var p = i.stateNode;
          i.memoizedState !== null ? p._visibility & 2 ? pa(
            u,
            i,
            c,
            s,
            n
          ) : rn(
            u,
            i
          ) : (p._visibility |= 2, pa(
            u,
            i,
            c,
            s,
            n
          )), n && y & 2048 && Mc(
            i.alternate,
            i
          );
          break;
        case 24:
          pa(
            u,
            i,
            c,
            s,
            n
          ), n && y & 2048 && Nc(i.alternate, i);
          break;
        default:
          pa(
            u,
            i,
            c,
            s,
            n
          );
      }
      t = t.sibling;
    }
  }
  function rn(l, t) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; ) {
        var e = l, a = t, n = a.flags;
        switch (a.tag) {
          case 22:
            rn(e, a), n & 2048 && Mc(
              a.alternate,
              a
            );
            break;
          case 24:
            rn(e, a), n & 2048 && Nc(a.alternate, a);
            break;
          default:
            rn(e, a);
        }
        t = t.sibling;
      }
  }
  var dn = 8192;
  function ba(l, t, e) {
    if (l.subtreeFlags & dn)
      for (l = l.child; l !== null; )
        hr(
          l,
          t,
          e
        ), l = l.sibling;
  }
  function hr(l, t, e) {
    switch (l.tag) {
      case 26:
        ba(
          l,
          t,
          e
        ), l.flags & dn && l.memoizedState !== null && Pm(
          e,
          jt,
          l.memoizedState,
          l.memoizedProps
        );
        break;
      case 5:
        ba(
          l,
          t,
          e
        );
        break;
      case 3:
      case 4:
        var a = jt;
        jt = Ru(l.stateNode.containerInfo), ba(
          l,
          t,
          e
        ), jt = a;
        break;
      case 22:
        l.memoizedState === null && (a = l.alternate, a !== null && a.memoizedState !== null ? (a = dn, dn = 16777216, ba(
          l,
          t,
          e
        ), dn = a) : ba(
          l,
          t,
          e
        ));
        break;
      default:
        ba(
          l,
          t,
          e
        );
    }
  }
  function mr(l) {
    var t = l.alternate;
    if (t !== null && (l = t.child, l !== null)) {
      t.child = null;
      do
        t = l.sibling, l.sibling = null, l = t;
      while (l !== null);
    }
  }
  function hn(l) {
    var t = l.deletions;
    if ((l.flags & 16) !== 0) {
      if (t !== null)
        for (var e = 0; e < t.length; e++) {
          var a = t[e];
          Ul = a, vr(
            a,
            l
          );
        }
      mr(l);
    }
    if (l.subtreeFlags & 10256)
      for (l = l.child; l !== null; )
        yr(l), l = l.sibling;
  }
  function yr(l) {
    switch (l.tag) {
      case 0:
      case 11:
      case 15:
        hn(l), l.flags & 2048 && re(9, l, l.return);
        break;
      case 3:
        hn(l);
        break;
      case 12:
        hn(l);
        break;
      case 22:
        var t = l.stateNode;
        l.memoizedState !== null && t._visibility & 2 && (l.return === null || l.return.tag !== 13) ? (t._visibility &= -3, Su(l)) : hn(l);
        break;
      default:
        hn(l);
    }
  }
  function Su(l) {
    var t = l.deletions;
    if ((l.flags & 16) !== 0) {
      if (t !== null)
        for (var e = 0; e < t.length; e++) {
          var a = t[e];
          Ul = a, vr(
            a,
            l
          );
        }
      mr(l);
    }
    for (l = l.child; l !== null; ) {
      switch (t = l, t.tag) {
        case 0:
        case 11:
        case 15:
          re(8, t, t.return), Su(t);
          break;
        case 22:
          e = t.stateNode, e._visibility & 2 && (e._visibility &= -3, Su(t));
          break;
        default:
          Su(t);
      }
      l = l.sibling;
    }
  }
  function vr(l, t) {
    for (; Ul !== null; ) {
      var e = Ul;
      switch (e.tag) {
        case 0:
        case 11:
        case 15:
          re(8, e, t);
          break;
        case 23:
        case 22:
          if (e.memoizedState !== null && e.memoizedState.cachePool !== null) {
            var a = e.memoizedState.cachePool.pool;
            a != null && a.refCount++;
          }
          break;
        case 24:
          Wa(e.memoizedState.cache);
      }
      if (a = e.child, a !== null) a.return = e, Ul = a;
      else
        l: for (e = l; Ul !== null; ) {
          a = Ul;
          var n = a.sibling, u = a.return;
          if (ir(a), a === e) {
            Ul = null;
            break l;
          }
          if (n !== null) {
            n.return = u, Ul = n;
            break l;
          }
          Ul = u;
        }
    }
  }
  var mm = {
    getCacheForType: function(l) {
      var t = Yl(zl), e = t.data.get(l);
      return e === void 0 && (e = l(), t.data.set(l, e)), e;
    },
    cacheSignal: function() {
      return Yl(zl).controller.signal;
    }
  }, ym = typeof WeakMap == "function" ? WeakMap : Map, tl = 0, rl = null, w = null, k = 0, al = 0, ot = null, de = !1, Sa = !1, Uc = !1, Wt = 0, bl = 0, he = 0, Le = 0, Rc = 0, rt = 0, Ea = 0, mn = null, lt = null, Cc = !1, Eu = 0, gr = 0, Au = 1 / 0, Tu = null, me = null, Dl = 0, ye = null, Aa = null, $t = 0, Hc = 0, qc = null, pr = null, yn = 0, Bc = null;
  function dt() {
    return (tl & 2) !== 0 && k !== 0 ? k & -k : b.T !== null ? Lc() : Rf();
  }
  function br() {
    if (rt === 0)
      if ((k & 536870912) === 0 || F) {
        var l = Nn;
        Nn <<= 1, (Nn & 3932160) === 0 && (Nn = 262144), rt = l;
      } else rt = 536870912;
    return l = ft.current, l !== null && (l.flags |= 32), rt;
  }
  function tt(l, t, e) {
    (l === rl && (al === 2 || al === 9) || l.cancelPendingCommit !== null) && (Ta(l, 0), ve(
      l,
      k,
      rt,
      !1
    )), Ha(l, e), ((tl & 2) === 0 || l !== rl) && (l === rl && ((tl & 2) === 0 && (Le |= e), bl === 4 && ve(
      l,
      k,
      rt,
      !1
    )), Rt(l));
  }
  function Sr(l, t, e) {
    if ((tl & 6) !== 0) throw Error(h(327));
    var a = !e && (t & 127) === 0 && (t & l.expiredLanes) === 0 || Ca(l, t), n = a ? pm(l, t) : Gc(l, t, !0), u = a;
    do {
      if (n === 0) {
        Sa && !a && ve(l, t, 0, !1);
        break;
      } else {
        if (e = l.current.alternate, u && !vm(e)) {
          n = Gc(l, t, !1), u = !1;
          continue;
        }
        if (n === 2) {
          if (u = t, l.errorRecoveryDisabledLanes & u)
            var i = 0;
          else
            i = l.pendingLanes & -536870913, i = i !== 0 ? i : i & 536870912 ? 536870912 : 0;
          if (i !== 0) {
            t = i;
            l: {
              var c = l;
              n = mn;
              var s = c.current.memoizedState.isDehydrated;
              if (s && (Ta(c, i).flags |= 256), i = Gc(
                c,
                i,
                !1
              ), i !== 2) {
                if (Uc && !s) {
                  c.errorRecoveryDisabledLanes |= u, Le |= u, n = 4;
                  break l;
                }
                u = lt, lt = n, u !== null && (lt === null ? lt = u : lt.push.apply(
                  lt,
                  u
                ));
              }
              n = i;
            }
            if (u = !1, n !== 2) continue;
          }
        }
        if (n === 1) {
          Ta(l, 0), ve(l, t, 0, !0);
          break;
        }
        l: {
          switch (a = l, u = n, u) {
            case 0:
            case 1:
              throw Error(h(345));
            case 4:
              if ((t & 4194048) !== t) break;
            case 6:
              ve(
                a,
                t,
                rt,
                !de
              );
              break l;
            case 2:
              lt = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(h(329));
          }
          if ((t & 62914560) === t && (n = Eu + 300 - at(), 10 < n)) {
            if (ve(
              a,
              t,
              rt,
              !de
            ), Rn(a, 0, !0) !== 0) break l;
            $t = t, a.timeoutHandle = Fr(
              Er.bind(
                null,
                a,
                e,
                lt,
                Tu,
                Cc,
                t,
                rt,
                Le,
                Ea,
                de,
                u,
                "Throttled",
                -0,
                0
              ),
              n
            );
            break l;
          }
          Er(
            a,
            e,
            lt,
            Tu,
            Cc,
            t,
            rt,
            Le,
            Ea,
            de,
            u,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    Rt(l);
  }
  function Er(l, t, e, a, n, u, i, c, s, y, p, A, v, g) {
    if (l.timeoutHandle = -1, A = t.subtreeFlags, A & 8192 || (A & 16785408) === 16785408) {
      A = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Ht
      }, hr(
        t,
        u,
        A
      );
      var D = (u & 62914560) === u ? Eu - at() : (u & 4194048) === u ? gr - at() : 0;
      if (D = ly(
        A,
        D
      ), D !== null) {
        $t = u, l.cancelPendingCommit = D(
          Dr.bind(
            null,
            l,
            t,
            u,
            e,
            a,
            n,
            i,
            c,
            s,
            p,
            A,
            null,
            v,
            g
          )
        ), ve(l, u, i, !y);
        return;
      }
    }
    Dr(
      l,
      t,
      u,
      e,
      a,
      n,
      i,
      c,
      s
    );
  }
  function vm(l) {
    for (var t = l; ; ) {
      var e = t.tag;
      if ((e === 0 || e === 11 || e === 15) && t.flags & 16384 && (e = t.updateQueue, e !== null && (e = e.stores, e !== null)))
        for (var a = 0; a < e.length; a++) {
          var n = e[a], u = n.getSnapshot;
          n = n.value;
          try {
            if (!it(u(), n)) return !1;
          } catch {
            return !1;
          }
        }
      if (e = t.child, t.subtreeFlags & 16384 && e !== null)
        e.return = t, t = e;
      else {
        if (t === l) break;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === l) return !0;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
    }
    return !0;
  }
  function ve(l, t, e, a) {
    t &= ~Rc, t &= ~Le, l.suspendedLanes |= t, l.pingedLanes &= ~t, a && (l.warmLanes |= t), a = l.expirationTimes;
    for (var n = t; 0 < n; ) {
      var u = 31 - ut(n), i = 1 << u;
      a[u] = -1, n &= ~i;
    }
    e !== 0 && Mf(l, e, t);
  }
  function zu() {
    return (tl & 6) === 0 ? (vn(0), !1) : !0;
  }
  function Yc() {
    if (w !== null) {
      if (al === 0)
        var l = w.return;
      else
        l = w, Gt = Ce = null, lc(l), ha = null, Fa = 0, l = w;
      for (; l !== null; )
        Io(l.alternate, l), l = l.return;
      w = null;
    }
  }
  function Ta(l, t) {
    var e = l.timeoutHandle;
    e !== -1 && (l.timeoutHandle = -1, qm(e)), e = l.cancelPendingCommit, e !== null && (l.cancelPendingCommit = null, e()), $t = 0, Yc(), rl = l, w = e = Bt(l.current, null), k = t, al = 0, ot = null, de = !1, Sa = Ca(l, t), Uc = !1, Ea = rt = Rc = Le = he = bl = 0, lt = mn = null, Cc = !1, (t & 8) !== 0 && (t |= t & 32);
    var a = l.entangledLanes;
    if (a !== 0)
      for (l = l.entanglements, a &= t; 0 < a; ) {
        var n = 31 - ut(a), u = 1 << n;
        t |= l[n], a &= ~u;
      }
    return Wt = t, Kn(), e;
  }
  function Ar(l, t) {
    X = null, b.H = un, t === da || t === Pn ? (t = Bs(), al = 3) : t === Zi ? (t = Bs(), al = 4) : al = t === vc ? 8 : t !== null && typeof t == "object" && typeof t.then == "function" ? 6 : 1, ot = t, w === null && (bl = 1, hu(
      l,
      bt(t, l.current)
    ));
  }
  function Tr() {
    var l = ft.current;
    return l === null ? !0 : (k & 4194048) === k ? Tt === null : (k & 62914560) === k || (k & 536870912) !== 0 ? l === Tt : !1;
  }
  function zr() {
    var l = b.H;
    return b.H = un, l === null ? un : l;
  }
  function _r() {
    var l = b.A;
    return b.A = mm, l;
  }
  function _u() {
    bl = 4, de || (k & 4194048) !== k && ft.current !== null || (Sa = !0), (he & 134217727) === 0 && (Le & 134217727) === 0 || rl === null || ve(
      rl,
      k,
      rt,
      !1
    );
  }
  function Gc(l, t, e) {
    var a = tl;
    tl |= 2;
    var n = zr(), u = _r();
    (rl !== l || k !== t) && (Tu = null, Ta(l, t)), t = !1;
    var i = bl;
    l: do
      try {
        if (al !== 0 && w !== null) {
          var c = w, s = ot;
          switch (al) {
            case 8:
              Yc(), i = 6;
              break l;
            case 3:
            case 2:
            case 9:
            case 6:
              ft.current === null && (t = !0);
              var y = al;
              if (al = 0, ot = null, za(l, c, s, y), e && Sa) {
                i = 0;
                break l;
              }
              break;
            default:
              y = al, al = 0, ot = null, za(l, c, s, y);
          }
        }
        gm(), i = bl;
        break;
      } catch (p) {
        Ar(l, p);
      }
    while (!0);
    return t && l.shellSuspendCounter++, Gt = Ce = null, tl = a, b.H = n, b.A = u, w === null && (rl = null, k = 0, Kn()), i;
  }
  function gm() {
    for (; w !== null; ) xr(w);
  }
  function pm(l, t) {
    var e = tl;
    tl |= 2;
    var a = zr(), n = _r();
    rl !== l || k !== t ? (Tu = null, Au = at() + 500, Ta(l, t)) : Sa = Ca(
      l,
      t
    );
    l: do
      try {
        if (al !== 0 && w !== null) {
          t = w;
          var u = ot;
          t: switch (al) {
            case 1:
              al = 0, ot = null, za(l, t, u, 1);
              break;
            case 2:
            case 9:
              if (Hs(u)) {
                al = 0, ot = null, jr(t);
                break;
              }
              t = function() {
                al !== 2 && al !== 9 || rl !== l || (al = 7), Rt(l);
              }, u.then(t, t);
              break l;
            case 3:
              al = 7;
              break l;
            case 4:
              al = 5;
              break l;
            case 7:
              Hs(u) ? (al = 0, ot = null, jr(t)) : (al = 0, ot = null, za(l, t, u, 7));
              break;
            case 5:
              var i = null;
              switch (w.tag) {
                case 26:
                  i = w.memoizedState;
                case 5:
                case 27:
                  var c = w;
                  if (i ? dd(i) : c.stateNode.complete) {
                    al = 0, ot = null;
                    var s = c.sibling;
                    if (s !== null) w = s;
                    else {
                      var y = c.return;
                      y !== null ? (w = y, xu(y)) : w = null;
                    }
                    break t;
                  }
              }
              al = 0, ot = null, za(l, t, u, 5);
              break;
            case 6:
              al = 0, ot = null, za(l, t, u, 6);
              break;
            case 8:
              Yc(), bl = 6;
              break l;
            default:
              throw Error(h(462));
          }
        }
        bm();
        break;
      } catch (p) {
        Ar(l, p);
      }
    while (!0);
    return Gt = Ce = null, b.H = a, b.A = n, tl = e, w !== null ? 0 : (rl = null, k = 0, Kn(), bl);
  }
  function bm() {
    for (; w !== null && !Zd(); )
      xr(w);
  }
  function xr(l) {
    var t = $o(l.alternate, l, Wt);
    l.memoizedProps = l.pendingProps, t === null ? xu(l) : w = t;
  }
  function jr(l) {
    var t = l, e = t.alternate;
    switch (t.tag) {
      case 15:
      case 0:
        t = Vo(
          e,
          t,
          t.pendingProps,
          t.type,
          void 0,
          k
        );
        break;
      case 11:
        t = Vo(
          e,
          t,
          t.pendingProps,
          t.type.render,
          t.ref,
          k
        );
        break;
      case 5:
        lc(t);
      default:
        Io(e, t), t = w = zs(t, Wt), t = $o(e, t, Wt);
    }
    l.memoizedProps = l.pendingProps, t === null ? xu(l) : w = t;
  }
  function za(l, t, e, a) {
    Gt = Ce = null, lc(t), ha = null, Fa = 0;
    var n = t.return;
    try {
      if (cm(
        l,
        n,
        t,
        e,
        k
      )) {
        bl = 1, hu(
          l,
          bt(e, l.current)
        ), w = null;
        return;
      }
    } catch (u) {
      if (n !== null) throw w = n, u;
      bl = 1, hu(
        l,
        bt(e, l.current)
      ), w = null;
      return;
    }
    t.flags & 32768 ? (F || a === 1 ? l = !0 : Sa || (k & 536870912) !== 0 ? l = !1 : (de = l = !0, (a === 2 || a === 9 || a === 3 || a === 6) && (a = ft.current, a !== null && a.tag === 13 && (a.flags |= 16384))), Or(t, l)) : xu(t);
  }
  function xu(l) {
    var t = l;
    do {
      if ((t.flags & 32768) !== 0) {
        Or(
          t,
          de
        );
        return;
      }
      l = t.return;
      var e = om(
        t.alternate,
        t,
        Wt
      );
      if (e !== null) {
        w = e;
        return;
      }
      if (t = t.sibling, t !== null) {
        w = t;
        return;
      }
      w = t = l;
    } while (t !== null);
    bl === 0 && (bl = 5);
  }
  function Or(l, t) {
    do {
      var e = rm(l.alternate, l);
      if (e !== null) {
        e.flags &= 32767, w = e;
        return;
      }
      if (e = l.return, e !== null && (e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null), !t && (l = l.sibling, l !== null)) {
        w = l;
        return;
      }
      w = l = e;
    } while (l !== null);
    bl = 6, w = null;
  }
  function Dr(l, t, e, a, n, u, i, c, s) {
    l.cancelPendingCommit = null;
    do
      ju();
    while (Dl !== 0);
    if ((tl & 6) !== 0) throw Error(h(327));
    if (t !== null) {
      if (t === l.current) throw Error(h(177));
      if (u = t.lanes | t.childLanes, u |= ji, Id(
        l,
        e,
        u,
        i,
        c,
        s
      ), l === rl && (w = rl = null, k = 0), Aa = t, ye = l, $t = e, Hc = u, qc = n, pr = a, (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? (l.callbackNode = null, l.callbackPriority = 0, Tm(Dn, function() {
        return Cr(), null;
      })) : (l.callbackNode = null, l.callbackPriority = 0), a = (t.flags & 13878) !== 0, (t.subtreeFlags & 13878) !== 0 || a) {
        a = b.T, b.T = null, n = _.p, _.p = 2, i = tl, tl |= 4;
        try {
          dm(l, t, e);
        } finally {
          tl = i, _.p = n, b.T = a;
        }
      }
      Dl = 1, Mr(), Nr(), Ur();
    }
  }
  function Mr() {
    if (Dl === 1) {
      Dl = 0;
      var l = ye, t = Aa, e = (t.flags & 13878) !== 0;
      if ((t.subtreeFlags & 13878) !== 0 || e) {
        e = b.T, b.T = null;
        var a = _.p;
        _.p = 2;
        var n = tl;
        tl |= 4;
        try {
          or(t, l);
          var u = Fc, i = ys(l.containerInfo), c = u.focusedElem, s = u.selectionRange;
          if (i !== c && c && c.ownerDocument && ms(
            c.ownerDocument.documentElement,
            c
          )) {
            if (s !== null && Ai(c)) {
              var y = s.start, p = s.end;
              if (p === void 0 && (p = y), "selectionStart" in c)
                c.selectionStart = y, c.selectionEnd = Math.min(
                  p,
                  c.value.length
                );
              else {
                var A = c.ownerDocument || document, v = A && A.defaultView || window;
                if (v.getSelection) {
                  var g = v.getSelection(), D = c.textContent.length, q = Math.min(s.start, D), fl = s.end === void 0 ? q : Math.min(s.end, D);
                  !g.extend && q > fl && (i = fl, fl = q, q = i);
                  var d = hs(
                    c,
                    q
                  ), o = hs(
                    c,
                    fl
                  );
                  if (d && o && (g.rangeCount !== 1 || g.anchorNode !== d.node || g.anchorOffset !== d.offset || g.focusNode !== o.node || g.focusOffset !== o.offset)) {
                    var m = A.createRange();
                    m.setStart(d.node, d.offset), g.removeAllRanges(), q > fl ? (g.addRange(m), g.extend(o.node, o.offset)) : (m.setEnd(o.node, o.offset), g.addRange(m));
                  }
                }
              }
            }
            for (A = [], g = c; g = g.parentNode; )
              g.nodeType === 1 && A.push({
                element: g,
                left: g.scrollLeft,
                top: g.scrollTop
              });
            for (typeof c.focus == "function" && c.focus(), c = 0; c < A.length; c++) {
              var E = A[c];
              E.element.scrollLeft = E.left, E.element.scrollTop = E.top;
            }
          }
          Gu = !!$c, Fc = $c = null;
        } finally {
          tl = n, _.p = a, b.T = e;
        }
      }
      l.current = t, Dl = 2;
    }
  }
  function Nr() {
    if (Dl === 2) {
      Dl = 0;
      var l = ye, t = Aa, e = (t.flags & 8772) !== 0;
      if ((t.subtreeFlags & 8772) !== 0 || e) {
        e = b.T, b.T = null;
        var a = _.p;
        _.p = 2;
        var n = tl;
        tl |= 4;
        try {
          ur(l, t.alternate, t);
        } finally {
          tl = n, _.p = a, b.T = e;
        }
      }
      Dl = 3;
    }
  }
  function Ur() {
    if (Dl === 4 || Dl === 3) {
      Dl = 0, Ld();
      var l = ye, t = Aa, e = $t, a = pr;
      (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? Dl = 5 : (Dl = 0, Aa = ye = null, Rr(l, l.pendingLanes));
      var n = l.pendingLanes;
      if (n === 0 && (me = null), ai(e), t = t.stateNode, nt && typeof nt.onCommitFiberRoot == "function")
        try {
          nt.onCommitFiberRoot(
            Ra,
            t,
            void 0,
            (t.current.flags & 128) === 128
          );
        } catch {
        }
      if (a !== null) {
        t = b.T, n = _.p, _.p = 2, b.T = null;
        try {
          for (var u = l.onRecoverableError, i = 0; i < a.length; i++) {
            var c = a[i];
            u(c.value, {
              componentStack: c.stack
            });
          }
        } finally {
          b.T = t, _.p = n;
        }
      }
      ($t & 3) !== 0 && ju(), Rt(l), n = l.pendingLanes, (e & 261930) !== 0 && (n & 42) !== 0 ? l === Bc ? yn++ : (yn = 0, Bc = l) : yn = 0, vn(0);
    }
  }
  function Rr(l, t) {
    (l.pooledCacheLanes &= t) === 0 && (t = l.pooledCache, t != null && (l.pooledCache = null, Wa(t)));
  }
  function ju() {
    return Mr(), Nr(), Ur(), Cr();
  }
  function Cr() {
    if (Dl !== 5) return !1;
    var l = ye, t = Hc;
    Hc = 0;
    var e = ai($t), a = b.T, n = _.p;
    try {
      _.p = 32 > e ? 32 : e, b.T = null, e = qc, qc = null;
      var u = ye, i = $t;
      if (Dl = 0, Aa = ye = null, $t = 0, (tl & 6) !== 0) throw Error(h(331));
      var c = tl;
      if (tl |= 4, yr(u.current), dr(
        u,
        u.current,
        i,
        e
      ), tl = c, vn(0, !1), nt && typeof nt.onPostCommitFiberRoot == "function")
        try {
          nt.onPostCommitFiberRoot(Ra, u);
        } catch {
        }
      return !0;
    } finally {
      _.p = n, b.T = a, Rr(l, t);
    }
  }
  function Hr(l, t, e) {
    t = bt(e, t), t = yc(l.stateNode, t, 2), l = fe(l, t, 2), l !== null && (Ha(l, 2), Rt(l));
  }
  function nl(l, t, e) {
    if (l.tag === 3)
      Hr(l, l, e);
    else
      for (; t !== null; ) {
        if (t.tag === 3) {
          Hr(
            t,
            l,
            e
          );
          break;
        } else if (t.tag === 1) {
          var a = t.stateNode;
          if (typeof t.type.getDerivedStateFromError == "function" || typeof a.componentDidCatch == "function" && (me === null || !me.has(a))) {
            l = bt(e, l), e = qo(2), a = fe(t, e, 2), a !== null && (Bo(
              e,
              a,
              t,
              l
            ), Ha(a, 2), Rt(a));
            break;
          }
        }
        t = t.return;
      }
  }
  function Qc(l, t, e) {
    var a = l.pingCache;
    if (a === null) {
      a = l.pingCache = new ym();
      var n = /* @__PURE__ */ new Set();
      a.set(t, n);
    } else
      n = a.get(t), n === void 0 && (n = /* @__PURE__ */ new Set(), a.set(t, n));
    n.has(e) || (Uc = !0, n.add(e), l = Sm.bind(null, l, t, e), t.then(l, l));
  }
  function Sm(l, t, e) {
    var a = l.pingCache;
    a !== null && a.delete(t), l.pingedLanes |= l.suspendedLanes & e, l.warmLanes &= ~e, rl === l && (k & e) === e && (bl === 4 || bl === 3 && (k & 62914560) === k && 300 > at() - Eu ? (tl & 2) === 0 && Ta(l, 0) : Rc |= e, Ea === k && (Ea = 0)), Rt(l);
  }
  function qr(l, t) {
    t === 0 && (t = Df()), l = Ne(l, t), l !== null && (Ha(l, t), Rt(l));
  }
  function Em(l) {
    var t = l.memoizedState, e = 0;
    t !== null && (e = t.retryLane), qr(l, e);
  }
  function Am(l, t) {
    var e = 0;
    switch (l.tag) {
      case 31:
      case 13:
        var a = l.stateNode, n = l.memoizedState;
        n !== null && (e = n.retryLane);
        break;
      case 19:
        a = l.stateNode;
        break;
      case 22:
        a = l.stateNode._retryCache;
        break;
      default:
        throw Error(h(314));
    }
    a !== null && a.delete(t), qr(l, e);
  }
  function Tm(l, t) {
    return Pu(l, t);
  }
  var Ou = null, _a = null, Xc = !1, Du = !1, Zc = !1, ge = 0;
  function Rt(l) {
    l !== _a && l.next === null && (_a === null ? Ou = _a = l : _a = _a.next = l), Du = !0, Xc || (Xc = !0, _m());
  }
  function vn(l, t) {
    if (!Zc && Du) {
      Zc = !0;
      do
        for (var e = !1, a = Ou; a !== null; ) {
          if (l !== 0) {
            var n = a.pendingLanes;
            if (n === 0) var u = 0;
            else {
              var i = a.suspendedLanes, c = a.pingedLanes;
              u = (1 << 31 - ut(42 | l) + 1) - 1, u &= n & ~(i & ~c), u = u & 201326741 ? u & 201326741 | 1 : u ? u | 2 : 0;
            }
            u !== 0 && (e = !0, Qr(a, u));
          } else
            u = k, u = Rn(
              a,
              a === rl ? u : 0,
              a.cancelPendingCommit !== null || a.timeoutHandle !== -1
            ), (u & 3) === 0 || Ca(a, u) || (e = !0, Qr(a, u));
          a = a.next;
        }
      while (e);
      Zc = !1;
    }
  }
  function zm() {
    Br();
  }
  function Br() {
    Du = Xc = !1;
    var l = 0;
    ge !== 0 && Hm() && (l = ge);
    for (var t = at(), e = null, a = Ou; a !== null; ) {
      var n = a.next, u = Yr(a, t);
      u === 0 ? (a.next = null, e === null ? Ou = n : e.next = n, n === null && (_a = e)) : (e = a, (l !== 0 || (u & 3) !== 0) && (Du = !0)), a = n;
    }
    Dl !== 0 && Dl !== 5 || vn(l), ge !== 0 && (ge = 0);
  }
  function Yr(l, t) {
    for (var e = l.suspendedLanes, a = l.pingedLanes, n = l.expirationTimes, u = l.pendingLanes & -62914561; 0 < u; ) {
      var i = 31 - ut(u), c = 1 << i, s = n[i];
      s === -1 ? ((c & e) === 0 || (c & a) !== 0) && (n[i] = Fd(c, t)) : s <= t && (l.expiredLanes |= c), u &= ~c;
    }
    if (t = rl, e = k, e = Rn(
      l,
      l === t ? e : 0,
      l.cancelPendingCommit !== null || l.timeoutHandle !== -1
    ), a = l.callbackNode, e === 0 || l === t && (al === 2 || al === 9) || l.cancelPendingCommit !== null)
      return a !== null && a !== null && li(a), l.callbackNode = null, l.callbackPriority = 0;
    if ((e & 3) === 0 || Ca(l, e)) {
      if (t = e & -e, t === l.callbackPriority) return t;
      switch (a !== null && li(a), ai(e)) {
        case 2:
        case 8:
          e = jf;
          break;
        case 32:
          e = Dn;
          break;
        case 268435456:
          e = Of;
          break;
        default:
          e = Dn;
      }
      return a = Gr.bind(null, l), e = Pu(e, a), l.callbackPriority = t, l.callbackNode = e, t;
    }
    return a !== null && a !== null && li(a), l.callbackPriority = 2, l.callbackNode = null, 2;
  }
  function Gr(l, t) {
    if (Dl !== 0 && Dl !== 5)
      return l.callbackNode = null, l.callbackPriority = 0, null;
    var e = l.callbackNode;
    if (ju() && l.callbackNode !== e)
      return null;
    var a = k;
    return a = Rn(
      l,
      l === rl ? a : 0,
      l.cancelPendingCommit !== null || l.timeoutHandle !== -1
    ), a === 0 ? null : (Sr(l, a, t), Yr(l, at()), l.callbackNode != null && l.callbackNode === e ? Gr.bind(null, l) : null);
  }
  function Qr(l, t) {
    if (ju()) return null;
    Sr(l, t, !0);
  }
  function _m() {
    Bm(function() {
      (tl & 6) !== 0 ? Pu(
        xf,
        zm
      ) : Br();
    });
  }
  function Lc() {
    if (ge === 0) {
      var l = oa;
      l === 0 && (l = Mn, Mn <<= 1, (Mn & 261888) === 0 && (Mn = 256)), ge = l;
    }
    return ge;
  }
  function Xr(l) {
    return l == null || typeof l == "symbol" || typeof l == "boolean" ? null : typeof l == "function" ? l : Bn("" + l);
  }
  function Zr(l, t) {
    var e = t.ownerDocument.createElement("input");
    return e.name = t.name, e.value = t.value, l.id && e.setAttribute("form", l.id), t.parentNode.insertBefore(e, t), l = new FormData(l), e.parentNode.removeChild(e), l;
  }
  function xm(l, t, e, a, n) {
    if (t === "submit" && e && e.stateNode === n) {
      var u = Xr(
        (n[Wl] || null).action
      ), i = a.submitter;
      i && (t = (t = i[Wl] || null) ? Xr(t.formAction) : i.getAttribute("formAction"), t !== null && (u = t, i = null));
      var c = new Xn(
        "action",
        "action",
        null,
        a,
        n
      );
      l.push({
        event: c,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (a.defaultPrevented) {
                if (ge !== 0) {
                  var s = i ? Zr(n, i) : new FormData(n);
                  sc(
                    e,
                    {
                      pending: !0,
                      data: s,
                      method: n.method,
                      action: u
                    },
                    null,
                    s
                  );
                }
              } else
                typeof u == "function" && (c.preventDefault(), s = i ? Zr(n, i) : new FormData(n), sc(
                  e,
                  {
                    pending: !0,
                    data: s,
                    method: n.method,
                    action: u
                  },
                  u,
                  s
                ));
            },
            currentTarget: n
          }
        ]
      });
    }
  }
  for (var Vc = 0; Vc < xi.length; Vc++) {
    var Kc = xi[Vc], jm = Kc.toLowerCase(), Om = Kc[0].toUpperCase() + Kc.slice(1);
    xt(
      jm,
      "on" + Om
    );
  }
  xt(ps, "onAnimationEnd"), xt(bs, "onAnimationIteration"), xt(Ss, "onAnimationStart"), xt("dblclick", "onDoubleClick"), xt("focusin", "onFocus"), xt("focusout", "onBlur"), xt(Vh, "onTransitionRun"), xt(Kh, "onTransitionStart"), xt(wh, "onTransitionCancel"), xt(Es, "onTransitionEnd"), $e("onMouseEnter", ["mouseout", "mouseover"]), $e("onMouseLeave", ["mouseout", "mouseover"]), $e("onPointerEnter", ["pointerout", "pointerover"]), $e("onPointerLeave", ["pointerout", "pointerover"]), je(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), je(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), je("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), je(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), je(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), je(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var gn = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), Dm = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(gn)
  );
  function Lr(l, t) {
    t = (t & 4) !== 0;
    for (var e = 0; e < l.length; e++) {
      var a = l[e], n = a.event;
      a = a.listeners;
      l: {
        var u = void 0;
        if (t)
          for (var i = a.length - 1; 0 <= i; i--) {
            var c = a[i], s = c.instance, y = c.currentTarget;
            if (c = c.listener, s !== u && n.isPropagationStopped())
              break l;
            u = c, n.currentTarget = y;
            try {
              u(n);
            } catch (p) {
              Vn(p);
            }
            n.currentTarget = null, u = s;
          }
        else
          for (i = 0; i < a.length; i++) {
            if (c = a[i], s = c.instance, y = c.currentTarget, c = c.listener, s !== u && n.isPropagationStopped())
              break l;
            u = c, n.currentTarget = y;
            try {
              u(n);
            } catch (p) {
              Vn(p);
            }
            n.currentTarget = null, u = s;
          }
      }
    }
  }
  function J(l, t) {
    var e = t[ni];
    e === void 0 && (e = t[ni] = /* @__PURE__ */ new Set());
    var a = l + "__bubble";
    e.has(a) || (Vr(t, l, 2, !1), e.add(a));
  }
  function wc(l, t, e) {
    var a = 0;
    t && (a |= 4), Vr(
      e,
      l,
      a,
      t
    );
  }
  var Mu = "_reactListening" + Math.random().toString(36).slice(2);
  function Jc(l) {
    if (!l[Mu]) {
      l[Mu] = !0, qf.forEach(function(e) {
        e !== "selectionchange" && (Dm.has(e) || wc(e, !1, l), wc(e, !0, l));
      });
      var t = l.nodeType === 9 ? l : l.ownerDocument;
      t === null || t[Mu] || (t[Mu] = !0, wc("selectionchange", !1, t));
    }
  }
  function Vr(l, t, e, a) {
    switch (bd(t)) {
      case 2:
        var n = ay;
        break;
      case 8:
        n = ny;
        break;
      default:
        n = sf;
    }
    e = n.bind(
      null,
      t,
      e,
      l
    ), n = void 0, !hi || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (n = !0), a ? n !== void 0 ? l.addEventListener(t, e, {
      capture: !0,
      passive: n
    }) : l.addEventListener(t, e, !0) : n !== void 0 ? l.addEventListener(t, e, {
      passive: n
    }) : l.addEventListener(t, e, !1);
  }
  function kc(l, t, e, a, n) {
    var u = a;
    if ((t & 1) === 0 && (t & 2) === 0 && a !== null)
      l: for (; ; ) {
        if (a === null) return;
        var i = a.tag;
        if (i === 3 || i === 4) {
          var c = a.stateNode.containerInfo;
          if (c === n) break;
          if (i === 4)
            for (i = a.return; i !== null; ) {
              var s = i.tag;
              if ((s === 3 || s === 4) && i.stateNode.containerInfo === n)
                return;
              i = i.return;
            }
          for (; c !== null; ) {
            if (i = Je(c), i === null) return;
            if (s = i.tag, s === 5 || s === 6 || s === 26 || s === 27) {
              a = u = i;
              continue l;
            }
            c = c.parentNode;
          }
        }
        a = a.return;
      }
    kf(function() {
      var y = u, p = ri(e), A = [];
      l: {
        var v = As.get(l);
        if (v !== void 0) {
          var g = Xn, D = l;
          switch (l) {
            case "keypress":
              if (Gn(e) === 0) break l;
            case "keydown":
            case "keyup":
              g = Ah;
              break;
            case "focusin":
              D = "focus", g = gi;
              break;
            case "focusout":
              D = "blur", g = gi;
              break;
            case "beforeblur":
            case "afterblur":
              g = gi;
              break;
            case "click":
              if (e.button === 2) break l;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              g = Ff;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              g = oh;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              g = _h;
              break;
            case ps:
            case bs:
            case Ss:
              g = hh;
              break;
            case Es:
              g = jh;
              break;
            case "scroll":
            case "scrollend":
              g = fh;
              break;
            case "wheel":
              g = Dh;
              break;
            case "copy":
            case "cut":
            case "paste":
              g = yh;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              g = Pf;
              break;
            case "toggle":
            case "beforetoggle":
              g = Nh;
          }
          var q = (t & 4) !== 0, fl = !q && (l === "scroll" || l === "scrollend"), d = q ? v !== null ? v + "Capture" : null : v;
          q = [];
          for (var o = y, m; o !== null; ) {
            var E = o;
            if (m = E.stateNode, E = E.tag, E !== 5 && E !== 26 && E !== 27 || m === null || d === null || (E = Ya(o, d), E != null && q.push(
              pn(o, E, m)
            )), fl) break;
            o = o.return;
          }
          0 < q.length && (v = new g(
            v,
            D,
            null,
            e,
            p
          ), A.push({ event: v, listeners: q }));
        }
      }
      if ((t & 7) === 0) {
        l: {
          if (v = l === "mouseover" || l === "pointerover", g = l === "mouseout" || l === "pointerout", v && e !== oi && (D = e.relatedTarget || e.fromElement) && (Je(D) || D[we]))
            break l;
          if ((g || v) && (v = p.window === p ? p : (v = p.ownerDocument) ? v.defaultView || v.parentWindow : window, g ? (D = e.relatedTarget || e.toElement, g = y, D = D ? Je(D) : null, D !== null && (fl = L(D), q = D.tag, D !== fl || q !== 5 && q !== 27 && q !== 6) && (D = null)) : (g = null, D = y), g !== D)) {
            if (q = Ff, E = "onMouseLeave", d = "onMouseEnter", o = "mouse", (l === "pointerout" || l === "pointerover") && (q = Pf, E = "onPointerLeave", d = "onPointerEnter", o = "pointer"), fl = g == null ? v : Ba(g), m = D == null ? v : Ba(D), v = new q(
              E,
              o + "leave",
              g,
              e,
              p
            ), v.target = fl, v.relatedTarget = m, E = null, Je(p) === y && (q = new q(
              d,
              o + "enter",
              D,
              e,
              p
            ), q.target = m, q.relatedTarget = fl, E = q), fl = E, g && D)
              t: {
                for (q = Mm, d = g, o = D, m = 0, E = d; E; E = q(E))
                  m++;
                E = 0;
                for (var C = o; C; C = q(C))
                  E++;
                for (; 0 < m - E; )
                  d = q(d), m--;
                for (; 0 < E - m; )
                  o = q(o), E--;
                for (; m--; ) {
                  if (d === o || o !== null && d === o.alternate) {
                    q = d;
                    break t;
                  }
                  d = q(d), o = q(o);
                }
                q = null;
              }
            else q = null;
            g !== null && Kr(
              A,
              v,
              g,
              q,
              !1
            ), D !== null && fl !== null && Kr(
              A,
              fl,
              D,
              q,
              !0
            );
          }
        }
        l: {
          if (v = y ? Ba(y) : window, g = v.nodeName && v.nodeName.toLowerCase(), g === "select" || g === "input" && v.type === "file")
            var I = cs;
          else if (us(v))
            if (fs)
              I = Xh;
            else {
              I = Gh;
              var N = Yh;
            }
          else
            g = v.nodeName, !g || g.toLowerCase() !== "input" || v.type !== "checkbox" && v.type !== "radio" ? y && si(y.elementType) && (I = cs) : I = Qh;
          if (I && (I = I(l, y))) {
            is(
              A,
              I,
              e,
              p
            );
            break l;
          }
          N && N(l, v, y), l === "focusout" && y && v.type === "number" && y.memoizedProps.value != null && fi(v, "number", v.value);
        }
        switch (N = y ? Ba(y) : window, l) {
          case "focusin":
            (us(N) || N.contentEditable === "true") && (ea = N, Ti = y, wa = null);
            break;
          case "focusout":
            wa = Ti = ea = null;
            break;
          case "mousedown":
            zi = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            zi = !1, vs(A, e, p);
            break;
          case "selectionchange":
            if (Lh) break;
          case "keydown":
          case "keyup":
            vs(A, e, p);
        }
        var Z;
        if (bi)
          l: {
            switch (l) {
              case "compositionstart":
                var W = "onCompositionStart";
                break l;
              case "compositionend":
                W = "onCompositionEnd";
                break l;
              case "compositionupdate":
                W = "onCompositionUpdate";
                break l;
            }
            W = void 0;
          }
        else
          ta ? as(l, e) && (W = "onCompositionEnd") : l === "keydown" && e.keyCode === 229 && (W = "onCompositionStart");
        W && (ls && e.locale !== "ko" && (ta || W !== "onCompositionStart" ? W === "onCompositionEnd" && ta && (Z = Wf()) : (te = p, mi = "value" in te ? te.value : te.textContent, ta = !0)), N = Nu(y, W), 0 < N.length && (W = new If(
          W,
          l,
          null,
          e,
          p
        ), A.push({ event: W, listeners: N }), Z ? W.data = Z : (Z = ns(e), Z !== null && (W.data = Z)))), (Z = Rh ? Ch(l, e) : Hh(l, e)) && (W = Nu(y, "onBeforeInput"), 0 < W.length && (N = new If(
          "onBeforeInput",
          "beforeinput",
          null,
          e,
          p
        ), A.push({
          event: N,
          listeners: W
        }), N.data = Z)), xm(
          A,
          l,
          y,
          e,
          p
        );
      }
      Lr(A, t);
    });
  }
  function pn(l, t, e) {
    return {
      instance: l,
      listener: t,
      currentTarget: e
    };
  }
  function Nu(l, t) {
    for (var e = t + "Capture", a = []; l !== null; ) {
      var n = l, u = n.stateNode;
      if (n = n.tag, n !== 5 && n !== 26 && n !== 27 || u === null || (n = Ya(l, e), n != null && a.unshift(
        pn(l, n, u)
      ), n = Ya(l, t), n != null && a.push(
        pn(l, n, u)
      )), l.tag === 3) return a;
      l = l.return;
    }
    return [];
  }
  function Mm(l) {
    if (l === null) return null;
    do
      l = l.return;
    while (l && l.tag !== 5 && l.tag !== 27);
    return l || null;
  }
  function Kr(l, t, e, a, n) {
    for (var u = t._reactName, i = []; e !== null && e !== a; ) {
      var c = e, s = c.alternate, y = c.stateNode;
      if (c = c.tag, s !== null && s === a) break;
      c !== 5 && c !== 26 && c !== 27 || y === null || (s = y, n ? (y = Ya(e, u), y != null && i.unshift(
        pn(e, y, s)
      )) : n || (y = Ya(e, u), y != null && i.push(
        pn(e, y, s)
      ))), e = e.return;
    }
    i.length !== 0 && l.push({ event: t, listeners: i });
  }
  var Nm = /\r\n?/g, Um = /\u0000|\uFFFD/g;
  function wr(l) {
    return (typeof l == "string" ? l : "" + l).replace(Nm, `
`).replace(Um, "");
  }
  function Jr(l, t) {
    return t = wr(t), wr(l) === t;
  }
  function cl(l, t, e, a, n, u) {
    switch (e) {
      case "children":
        typeof a == "string" ? t === "body" || t === "textarea" && a === "" || Ie(l, a) : (typeof a == "number" || typeof a == "bigint") && t !== "body" && Ie(l, "" + a);
        break;
      case "className":
        Hn(l, "class", a);
        break;
      case "tabIndex":
        Hn(l, "tabindex", a);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Hn(l, e, a);
        break;
      case "style":
        wf(l, a, u);
        break;
      case "data":
        if (t !== "object") {
          Hn(l, "data", a);
          break;
        }
      case "src":
      case "href":
        if (a === "" && (t !== "a" || e !== "href")) {
          l.removeAttribute(e);
          break;
        }
        if (a == null || typeof a == "function" || typeof a == "symbol" || typeof a == "boolean") {
          l.removeAttribute(e);
          break;
        }
        a = Bn("" + a), l.setAttribute(e, a);
        break;
      case "action":
      case "formAction":
        if (typeof a == "function") {
          l.setAttribute(
            e,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof u == "function" && (e === "formAction" ? (t !== "input" && cl(l, t, "name", n.name, n, null), cl(
            l,
            t,
            "formEncType",
            n.formEncType,
            n,
            null
          ), cl(
            l,
            t,
            "formMethod",
            n.formMethod,
            n,
            null
          ), cl(
            l,
            t,
            "formTarget",
            n.formTarget,
            n,
            null
          )) : (cl(l, t, "encType", n.encType, n, null), cl(l, t, "method", n.method, n, null), cl(l, t, "target", n.target, n, null)));
        if (a == null || typeof a == "symbol" || typeof a == "boolean") {
          l.removeAttribute(e);
          break;
        }
        a = Bn("" + a), l.setAttribute(e, a);
        break;
      case "onClick":
        a != null && (l.onclick = Ht);
        break;
      case "onScroll":
        a != null && J("scroll", l);
        break;
      case "onScrollEnd":
        a != null && J("scrollend", l);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(h(61));
          if (e = a.__html, e != null) {
            if (n.children != null) throw Error(h(60));
            l.innerHTML = e;
          }
        }
        break;
      case "multiple":
        l.multiple = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "muted":
        l.muted = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (a == null || typeof a == "function" || typeof a == "boolean" || typeof a == "symbol") {
          l.removeAttribute("xlink:href");
          break;
        }
        e = Bn("" + a), l.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          e
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        a != null && typeof a != "function" && typeof a != "symbol" ? l.setAttribute(e, "" + a) : l.removeAttribute(e);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        a && typeof a != "function" && typeof a != "symbol" ? l.setAttribute(e, "") : l.removeAttribute(e);
        break;
      case "capture":
      case "download":
        a === !0 ? l.setAttribute(e, "") : a !== !1 && a != null && typeof a != "function" && typeof a != "symbol" ? l.setAttribute(e, a) : l.removeAttribute(e);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        a != null && typeof a != "function" && typeof a != "symbol" && !isNaN(a) && 1 <= a ? l.setAttribute(e, a) : l.removeAttribute(e);
        break;
      case "rowSpan":
      case "start":
        a == null || typeof a == "function" || typeof a == "symbol" || isNaN(a) ? l.removeAttribute(e) : l.setAttribute(e, a);
        break;
      case "popover":
        J("beforetoggle", l), J("toggle", l), Cn(l, "popover", a);
        break;
      case "xlinkActuate":
        Ct(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          a
        );
        break;
      case "xlinkArcrole":
        Ct(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          a
        );
        break;
      case "xlinkRole":
        Ct(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          a
        );
        break;
      case "xlinkShow":
        Ct(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          a
        );
        break;
      case "xlinkTitle":
        Ct(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          a
        );
        break;
      case "xlinkType":
        Ct(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          a
        );
        break;
      case "xmlBase":
        Ct(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          a
        );
        break;
      case "xmlLang":
        Ct(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          a
        );
        break;
      case "xmlSpace":
        Ct(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          a
        );
        break;
      case "is":
        Cn(l, "is", a);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < e.length) || e[0] !== "o" && e[0] !== "O" || e[1] !== "n" && e[1] !== "N") && (e = ih.get(e) || e, Cn(l, e, a));
    }
  }
  function Wc(l, t, e, a, n, u) {
    switch (e) {
      case "style":
        wf(l, a, u);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(h(61));
          if (e = a.__html, e != null) {
            if (n.children != null) throw Error(h(60));
            l.innerHTML = e;
          }
        }
        break;
      case "children":
        typeof a == "string" ? Ie(l, a) : (typeof a == "number" || typeof a == "bigint") && Ie(l, "" + a);
        break;
      case "onScroll":
        a != null && J("scroll", l);
        break;
      case "onScrollEnd":
        a != null && J("scrollend", l);
        break;
      case "onClick":
        a != null && (l.onclick = Ht);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!Bf.hasOwnProperty(e))
          l: {
            if (e[0] === "o" && e[1] === "n" && (n = e.endsWith("Capture"), t = e.slice(2, n ? e.length - 7 : void 0), u = l[Wl] || null, u = u != null ? u[e] : null, typeof u == "function" && l.removeEventListener(t, u, n), typeof a == "function")) {
              typeof u != "function" && u !== null && (e in l ? l[e] = null : l.hasAttribute(e) && l.removeAttribute(e)), l.addEventListener(t, a, n);
              break l;
            }
            e in l ? l[e] = a : a === !0 ? l.setAttribute(e, "") : Cn(l, e, a);
          }
    }
  }
  function Ql(l, t, e) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        J("error", l), J("load", l);
        var a = !1, n = !1, u;
        for (u in e)
          if (e.hasOwnProperty(u)) {
            var i = e[u];
            if (i != null)
              switch (u) {
                case "src":
                  a = !0;
                  break;
                case "srcSet":
                  n = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(h(137, t));
                default:
                  cl(l, t, u, i, e, null);
              }
          }
        n && cl(l, t, "srcSet", e.srcSet, e, null), a && cl(l, t, "src", e.src, e, null);
        return;
      case "input":
        J("invalid", l);
        var c = u = i = n = null, s = null, y = null;
        for (a in e)
          if (e.hasOwnProperty(a)) {
            var p = e[a];
            if (p != null)
              switch (a) {
                case "name":
                  n = p;
                  break;
                case "type":
                  i = p;
                  break;
                case "checked":
                  s = p;
                  break;
                case "defaultChecked":
                  y = p;
                  break;
                case "value":
                  u = p;
                  break;
                case "defaultValue":
                  c = p;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (p != null)
                    throw Error(h(137, t));
                  break;
                default:
                  cl(l, t, a, p, e, null);
              }
          }
        Zf(
          l,
          u,
          c,
          s,
          y,
          i,
          n,
          !1
        );
        return;
      case "select":
        J("invalid", l), a = i = u = null;
        for (n in e)
          if (e.hasOwnProperty(n) && (c = e[n], c != null))
            switch (n) {
              case "value":
                u = c;
                break;
              case "defaultValue":
                i = c;
                break;
              case "multiple":
                a = c;
              default:
                cl(l, t, n, c, e, null);
            }
        t = u, e = i, l.multiple = !!a, t != null ? Fe(l, !!a, t, !1) : e != null && Fe(l, !!a, e, !0);
        return;
      case "textarea":
        J("invalid", l), u = n = a = null;
        for (i in e)
          if (e.hasOwnProperty(i) && (c = e[i], c != null))
            switch (i) {
              case "value":
                a = c;
                break;
              case "defaultValue":
                n = c;
                break;
              case "children":
                u = c;
                break;
              case "dangerouslySetInnerHTML":
                if (c != null) throw Error(h(91));
                break;
              default:
                cl(l, t, i, c, e, null);
            }
        Vf(l, a, n, u);
        return;
      case "option":
        for (s in e)
          e.hasOwnProperty(s) && (a = e[s], a != null) && (s === "selected" ? l.selected = a && typeof a != "function" && typeof a != "symbol" : cl(l, t, s, a, e, null));
        return;
      case "dialog":
        J("beforetoggle", l), J("toggle", l), J("cancel", l), J("close", l);
        break;
      case "iframe":
      case "object":
        J("load", l);
        break;
      case "video":
      case "audio":
        for (a = 0; a < gn.length; a++)
          J(gn[a], l);
        break;
      case "image":
        J("error", l), J("load", l);
        break;
      case "details":
        J("toggle", l);
        break;
      case "embed":
      case "source":
      case "link":
        J("error", l), J("load", l);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (y in e)
          if (e.hasOwnProperty(y) && (a = e[y], a != null))
            switch (y) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(h(137, t));
              default:
                cl(l, t, y, a, e, null);
            }
        return;
      default:
        if (si(t)) {
          for (p in e)
            e.hasOwnProperty(p) && (a = e[p], a !== void 0 && Wc(
              l,
              t,
              p,
              a,
              e,
              void 0
            ));
          return;
        }
    }
    for (c in e)
      e.hasOwnProperty(c) && (a = e[c], a != null && cl(l, t, c, a, e, null));
  }
  function Rm(l, t, e, a) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var n = null, u = null, i = null, c = null, s = null, y = null, p = null;
        for (g in e) {
          var A = e[g];
          if (e.hasOwnProperty(g) && A != null)
            switch (g) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                s = A;
              default:
                a.hasOwnProperty(g) || cl(l, t, g, null, a, A);
            }
        }
        for (var v in a) {
          var g = a[v];
          if (A = e[v], a.hasOwnProperty(v) && (g != null || A != null))
            switch (v) {
              case "type":
                u = g;
                break;
              case "name":
                n = g;
                break;
              case "checked":
                y = g;
                break;
              case "defaultChecked":
                p = g;
                break;
              case "value":
                i = g;
                break;
              case "defaultValue":
                c = g;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (g != null)
                  throw Error(h(137, t));
                break;
              default:
                g !== A && cl(
                  l,
                  t,
                  v,
                  g,
                  a,
                  A
                );
            }
        }
        ci(
          l,
          i,
          c,
          s,
          y,
          p,
          u,
          n
        );
        return;
      case "select":
        g = i = c = v = null;
        for (u in e)
          if (s = e[u], e.hasOwnProperty(u) && s != null)
            switch (u) {
              case "value":
                break;
              case "multiple":
                g = s;
              default:
                a.hasOwnProperty(u) || cl(
                  l,
                  t,
                  u,
                  null,
                  a,
                  s
                );
            }
        for (n in a)
          if (u = a[n], s = e[n], a.hasOwnProperty(n) && (u != null || s != null))
            switch (n) {
              case "value":
                v = u;
                break;
              case "defaultValue":
                c = u;
                break;
              case "multiple":
                i = u;
              default:
                u !== s && cl(
                  l,
                  t,
                  n,
                  u,
                  a,
                  s
                );
            }
        t = c, e = i, a = g, v != null ? Fe(l, !!e, v, !1) : !!a != !!e && (t != null ? Fe(l, !!e, t, !0) : Fe(l, !!e, e ? [] : "", !1));
        return;
      case "textarea":
        g = v = null;
        for (c in e)
          if (n = e[c], e.hasOwnProperty(c) && n != null && !a.hasOwnProperty(c))
            switch (c) {
              case "value":
                break;
              case "children":
                break;
              default:
                cl(l, t, c, null, a, n);
            }
        for (i in a)
          if (n = a[i], u = e[i], a.hasOwnProperty(i) && (n != null || u != null))
            switch (i) {
              case "value":
                v = n;
                break;
              case "defaultValue":
                g = n;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (n != null) throw Error(h(91));
                break;
              default:
                n !== u && cl(l, t, i, n, a, u);
            }
        Lf(l, v, g);
        return;
      case "option":
        for (var D in e)
          v = e[D], e.hasOwnProperty(D) && v != null && !a.hasOwnProperty(D) && (D === "selected" ? l.selected = !1 : cl(
            l,
            t,
            D,
            null,
            a,
            v
          ));
        for (s in a)
          v = a[s], g = e[s], a.hasOwnProperty(s) && v !== g && (v != null || g != null) && (s === "selected" ? l.selected = v && typeof v != "function" && typeof v != "symbol" : cl(
            l,
            t,
            s,
            v,
            a,
            g
          ));
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var q in e)
          v = e[q], e.hasOwnProperty(q) && v != null && !a.hasOwnProperty(q) && cl(l, t, q, null, a, v);
        for (y in a)
          if (v = a[y], g = e[y], a.hasOwnProperty(y) && v !== g && (v != null || g != null))
            switch (y) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (v != null)
                  throw Error(h(137, t));
                break;
              default:
                cl(
                  l,
                  t,
                  y,
                  v,
                  a,
                  g
                );
            }
        return;
      default:
        if (si(t)) {
          for (var fl in e)
            v = e[fl], e.hasOwnProperty(fl) && v !== void 0 && !a.hasOwnProperty(fl) && Wc(
              l,
              t,
              fl,
              void 0,
              a,
              v
            );
          for (p in a)
            v = a[p], g = e[p], !a.hasOwnProperty(p) || v === g || v === void 0 && g === void 0 || Wc(
              l,
              t,
              p,
              v,
              a,
              g
            );
          return;
        }
    }
    for (var d in e)
      v = e[d], e.hasOwnProperty(d) && v != null && !a.hasOwnProperty(d) && cl(l, t, d, null, a, v);
    for (A in a)
      v = a[A], g = e[A], !a.hasOwnProperty(A) || v === g || v == null && g == null || cl(l, t, A, v, a, g);
  }
  function kr(l) {
    switch (l) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function Cm() {
    if (typeof performance.getEntriesByType == "function") {
      for (var l = 0, t = 0, e = performance.getEntriesByType("resource"), a = 0; a < e.length; a++) {
        var n = e[a], u = n.transferSize, i = n.initiatorType, c = n.duration;
        if (u && c && kr(i)) {
          for (i = 0, c = n.responseEnd, a += 1; a < e.length; a++) {
            var s = e[a], y = s.startTime;
            if (y > c) break;
            var p = s.transferSize, A = s.initiatorType;
            p && kr(A) && (s = s.responseEnd, i += p * (s < c ? 1 : (c - y) / (s - y)));
          }
          if (--a, t += 8 * (u + i) / (n.duration / 1e3), l++, 10 < l) break;
        }
      }
      if (0 < l) return t / l / 1e6;
    }
    return navigator.connection && (l = navigator.connection.downlink, typeof l == "number") ? l : 5;
  }
  var $c = null, Fc = null;
  function Uu(l) {
    return l.nodeType === 9 ? l : l.ownerDocument;
  }
  function Wr(l) {
    switch (l) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function $r(l, t) {
    if (l === 0)
      switch (t) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return l === 1 && t === "foreignObject" ? 0 : l;
  }
  function Ic(l, t) {
    return l === "textarea" || l === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
  }
  var Pc = null;
  function Hm() {
    var l = window.event;
    return l && l.type === "popstate" ? l === Pc ? !1 : (Pc = l, !0) : (Pc = null, !1);
  }
  var Fr = typeof setTimeout == "function" ? setTimeout : void 0, qm = typeof clearTimeout == "function" ? clearTimeout : void 0, Ir = typeof Promise == "function" ? Promise : void 0, Bm = typeof queueMicrotask == "function" ? queueMicrotask : typeof Ir < "u" ? function(l) {
    return Ir.resolve(null).then(l).catch(Ym);
  } : Fr;
  function Ym(l) {
    setTimeout(function() {
      throw l;
    });
  }
  function pe(l) {
    return l === "head";
  }
  function Pr(l, t) {
    var e = t, a = 0;
    do {
      var n = e.nextSibling;
      if (l.removeChild(e), n && n.nodeType === 8)
        if (e = n.data, e === "/$" || e === "/&") {
          if (a === 0) {
            l.removeChild(n), Da(t);
            return;
          }
          a--;
        } else if (e === "$" || e === "$?" || e === "$~" || e === "$!" || e === "&")
          a++;
        else if (e === "html")
          bn(l.ownerDocument.documentElement);
        else if (e === "head") {
          e = l.ownerDocument.head, bn(e);
          for (var u = e.firstChild; u; ) {
            var i = u.nextSibling, c = u.nodeName;
            u[qa] || c === "SCRIPT" || c === "STYLE" || c === "LINK" && u.rel.toLowerCase() === "stylesheet" || e.removeChild(u), u = i;
          }
        } else
          e === "body" && bn(l.ownerDocument.body);
      e = n;
    } while (e);
    Da(t);
  }
  function ld(l, t) {
    var e = l;
    l = 0;
    do {
      var a = e.nextSibling;
      if (e.nodeType === 1 ? t ? (e._stashedDisplay = e.style.display, e.style.display = "none") : (e.style.display = e._stashedDisplay || "", e.getAttribute("style") === "" && e.removeAttribute("style")) : e.nodeType === 3 && (t ? (e._stashedText = e.nodeValue, e.nodeValue = "") : e.nodeValue = e._stashedText || ""), a && a.nodeType === 8)
        if (e = a.data, e === "/$") {
          if (l === 0) break;
          l--;
        } else
          e !== "$" && e !== "$?" && e !== "$~" && e !== "$!" || l++;
      e = a;
    } while (e);
  }
  function lf(l) {
    var t = l.firstChild;
    for (t && t.nodeType === 10 && (t = t.nextSibling); t; ) {
      var e = t;
      switch (t = t.nextSibling, e.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          lf(e), ui(e);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (e.rel.toLowerCase() === "stylesheet") continue;
      }
      l.removeChild(e);
    }
  }
  function Gm(l, t, e, a) {
    for (; l.nodeType === 1; ) {
      var n = e;
      if (l.nodeName.toLowerCase() !== t.toLowerCase()) {
        if (!a && (l.nodeName !== "INPUT" || l.type !== "hidden"))
          break;
      } else if (a) {
        if (!l[qa])
          switch (t) {
            case "meta":
              if (!l.hasAttribute("itemprop")) break;
              return l;
            case "link":
              if (u = l.getAttribute("rel"), u === "stylesheet" && l.hasAttribute("data-precedence"))
                break;
              if (u !== n.rel || l.getAttribute("href") !== (n.href == null || n.href === "" ? null : n.href) || l.getAttribute("crossorigin") !== (n.crossOrigin == null ? null : n.crossOrigin) || l.getAttribute("title") !== (n.title == null ? null : n.title))
                break;
              return l;
            case "style":
              if (l.hasAttribute("data-precedence")) break;
              return l;
            case "script":
              if (u = l.getAttribute("src"), (u !== (n.src == null ? null : n.src) || l.getAttribute("type") !== (n.type == null ? null : n.type) || l.getAttribute("crossorigin") !== (n.crossOrigin == null ? null : n.crossOrigin)) && u && l.hasAttribute("async") && !l.hasAttribute("itemprop"))
                break;
              return l;
            default:
              return l;
          }
      } else if (t === "input" && l.type === "hidden") {
        var u = n.name == null ? null : "" + n.name;
        if (n.type === "hidden" && l.getAttribute("name") === u)
          return l;
      } else return l;
      if (l = zt(l.nextSibling), l === null) break;
    }
    return null;
  }
  function Qm(l, t, e) {
    if (t === "") return null;
    for (; l.nodeType !== 3; )
      if ((l.nodeType !== 1 || l.nodeName !== "INPUT" || l.type !== "hidden") && !e || (l = zt(l.nextSibling), l === null)) return null;
    return l;
  }
  function td(l, t) {
    for (; l.nodeType !== 8; )
      if ((l.nodeType !== 1 || l.nodeName !== "INPUT" || l.type !== "hidden") && !t || (l = zt(l.nextSibling), l === null)) return null;
    return l;
  }
  function tf(l) {
    return l.data === "$?" || l.data === "$~";
  }
  function ef(l) {
    return l.data === "$!" || l.data === "$?" && l.ownerDocument.readyState !== "loading";
  }
  function Xm(l, t) {
    var e = l.ownerDocument;
    if (l.data === "$~") l._reactRetry = t;
    else if (l.data !== "$?" || e.readyState !== "loading")
      t();
    else {
      var a = function() {
        t(), e.removeEventListener("DOMContentLoaded", a);
      };
      e.addEventListener("DOMContentLoaded", a), l._reactRetry = a;
    }
  }
  function zt(l) {
    for (; l != null; l = l.nextSibling) {
      var t = l.nodeType;
      if (t === 1 || t === 3) break;
      if (t === 8) {
        if (t = l.data, t === "$" || t === "$!" || t === "$?" || t === "$~" || t === "&" || t === "F!" || t === "F")
          break;
        if (t === "/$" || t === "/&") return null;
      }
    }
    return l;
  }
  var af = null;
  function ed(l) {
    l = l.nextSibling;
    for (var t = 0; l; ) {
      if (l.nodeType === 8) {
        var e = l.data;
        if (e === "/$" || e === "/&") {
          if (t === 0)
            return zt(l.nextSibling);
          t--;
        } else
          e !== "$" && e !== "$!" && e !== "$?" && e !== "$~" && e !== "&" || t++;
      }
      l = l.nextSibling;
    }
    return null;
  }
  function ad(l) {
    l = l.previousSibling;
    for (var t = 0; l; ) {
      if (l.nodeType === 8) {
        var e = l.data;
        if (e === "$" || e === "$!" || e === "$?" || e === "$~" || e === "&") {
          if (t === 0) return l;
          t--;
        } else e !== "/$" && e !== "/&" || t++;
      }
      l = l.previousSibling;
    }
    return null;
  }
  function nd(l, t, e) {
    switch (t = Uu(e), l) {
      case "html":
        if (l = t.documentElement, !l) throw Error(h(452));
        return l;
      case "head":
        if (l = t.head, !l) throw Error(h(453));
        return l;
      case "body":
        if (l = t.body, !l) throw Error(h(454));
        return l;
      default:
        throw Error(h(451));
    }
  }
  function bn(l) {
    for (var t = l.attributes; t.length; )
      l.removeAttributeNode(t[0]);
    ui(l);
  }
  var _t = /* @__PURE__ */ new Map(), ud = /* @__PURE__ */ new Set();
  function Ru(l) {
    return typeof l.getRootNode == "function" ? l.getRootNode() : l.nodeType === 9 ? l : l.ownerDocument;
  }
  var Ft = _.d;
  _.d = {
    f: Zm,
    r: Lm,
    D: Vm,
    C: Km,
    L: wm,
    m: Jm,
    X: Wm,
    S: km,
    M: $m
  };
  function Zm() {
    var l = Ft.f(), t = zu();
    return l || t;
  }
  function Lm(l) {
    var t = ke(l);
    t !== null && t.tag === 5 && t.type === "form" ? Ao(t) : Ft.r(l);
  }
  var xa = typeof document > "u" ? null : document;
  function id(l, t, e) {
    var a = xa;
    if (a && typeof t == "string" && t) {
      var n = gt(t);
      n = 'link[rel="' + l + '"][href="' + n + '"]', typeof e == "string" && (n += '[crossorigin="' + e + '"]'), ud.has(n) || (ud.add(n), l = { rel: l, crossOrigin: e, href: t }, a.querySelector(n) === null && (t = a.createElement("link"), Ql(t, "link", l), Nl(t), a.head.appendChild(t)));
    }
  }
  function Vm(l) {
    Ft.D(l), id("dns-prefetch", l, null);
  }
  function Km(l, t) {
    Ft.C(l, t), id("preconnect", l, t);
  }
  function wm(l, t, e) {
    Ft.L(l, t, e);
    var a = xa;
    if (a && l && t) {
      var n = 'link[rel="preload"][as="' + gt(t) + '"]';
      t === "image" && e && e.imageSrcSet ? (n += '[imagesrcset="' + gt(
        e.imageSrcSet
      ) + '"]', typeof e.imageSizes == "string" && (n += '[imagesizes="' + gt(
        e.imageSizes
      ) + '"]')) : n += '[href="' + gt(l) + '"]';
      var u = n;
      switch (t) {
        case "style":
          u = ja(l);
          break;
        case "script":
          u = Oa(l);
      }
      _t.has(u) || (l = R(
        {
          rel: "preload",
          href: t === "image" && e && e.imageSrcSet ? void 0 : l,
          as: t
        },
        e
      ), _t.set(u, l), a.querySelector(n) !== null || t === "style" && a.querySelector(Sn(u)) || t === "script" && a.querySelector(En(u)) || (t = a.createElement("link"), Ql(t, "link", l), Nl(t), a.head.appendChild(t)));
    }
  }
  function Jm(l, t) {
    Ft.m(l, t);
    var e = xa;
    if (e && l) {
      var a = t && typeof t.as == "string" ? t.as : "script", n = 'link[rel="modulepreload"][as="' + gt(a) + '"][href="' + gt(l) + '"]', u = n;
      switch (a) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          u = Oa(l);
      }
      if (!_t.has(u) && (l = R({ rel: "modulepreload", href: l }, t), _t.set(u, l), e.querySelector(n) === null)) {
        switch (a) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (e.querySelector(En(u)))
              return;
        }
        a = e.createElement("link"), Ql(a, "link", l), Nl(a), e.head.appendChild(a);
      }
    }
  }
  function km(l, t, e) {
    Ft.S(l, t, e);
    var a = xa;
    if (a && l) {
      var n = We(a).hoistableStyles, u = ja(l);
      t = t || "default";
      var i = n.get(u);
      if (!i) {
        var c = { loading: 0, preload: null };
        if (i = a.querySelector(
          Sn(u)
        ))
          c.loading = 5;
        else {
          l = R(
            { rel: "stylesheet", href: l, "data-precedence": t },
            e
          ), (e = _t.get(u)) && nf(l, e);
          var s = i = a.createElement("link");
          Nl(s), Ql(s, "link", l), s._p = new Promise(function(y, p) {
            s.onload = y, s.onerror = p;
          }), s.addEventListener("load", function() {
            c.loading |= 1;
          }), s.addEventListener("error", function() {
            c.loading |= 2;
          }), c.loading |= 4, Cu(i, t, a);
        }
        i = {
          type: "stylesheet",
          instance: i,
          count: 1,
          state: c
        }, n.set(u, i);
      }
    }
  }
  function Wm(l, t) {
    Ft.X(l, t);
    var e = xa;
    if (e && l) {
      var a = We(e).hoistableScripts, n = Oa(l), u = a.get(n);
      u || (u = e.querySelector(En(n)), u || (l = R({ src: l, async: !0 }, t), (t = _t.get(n)) && uf(l, t), u = e.createElement("script"), Nl(u), Ql(u, "link", l), e.head.appendChild(u)), u = {
        type: "script",
        instance: u,
        count: 1,
        state: null
      }, a.set(n, u));
    }
  }
  function $m(l, t) {
    Ft.M(l, t);
    var e = xa;
    if (e && l) {
      var a = We(e).hoistableScripts, n = Oa(l), u = a.get(n);
      u || (u = e.querySelector(En(n)), u || (l = R({ src: l, async: !0, type: "module" }, t), (t = _t.get(n)) && uf(l, t), u = e.createElement("script"), Nl(u), Ql(u, "link", l), e.head.appendChild(u)), u = {
        type: "script",
        instance: u,
        count: 1,
        state: null
      }, a.set(n, u));
    }
  }
  function cd(l, t, e, a) {
    var n = (n = K.current) ? Ru(n) : null;
    if (!n) throw Error(h(446));
    switch (l) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof e.precedence == "string" && typeof e.href == "string" ? (t = ja(e.href), e = We(
          n
        ).hoistableStyles, a = e.get(t), a || (a = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, e.set(t, a)), a) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (e.rel === "stylesheet" && typeof e.href == "string" && typeof e.precedence == "string") {
          l = ja(e.href);
          var u = We(
            n
          ).hoistableStyles, i = u.get(l);
          if (i || (n = n.ownerDocument || n, i = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, u.set(l, i), (u = n.querySelector(
            Sn(l)
          )) && !u._p && (i.instance = u, i.state.loading = 5), _t.has(l) || (e = {
            rel: "preload",
            as: "style",
            href: e.href,
            crossOrigin: e.crossOrigin,
            integrity: e.integrity,
            media: e.media,
            hrefLang: e.hrefLang,
            referrerPolicy: e.referrerPolicy
          }, _t.set(l, e), u || Fm(
            n,
            l,
            e,
            i.state
          ))), t && a === null)
            throw Error(h(528, ""));
          return i;
        }
        if (t && a !== null)
          throw Error(h(529, ""));
        return null;
      case "script":
        return t = e.async, e = e.src, typeof e == "string" && t && typeof t != "function" && typeof t != "symbol" ? (t = Oa(e), e = We(
          n
        ).hoistableScripts, a = e.get(t), a || (a = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, e.set(t, a)), a) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(h(444, l));
    }
  }
  function ja(l) {
    return 'href="' + gt(l) + '"';
  }
  function Sn(l) {
    return 'link[rel="stylesheet"][' + l + "]";
  }
  function fd(l) {
    return R({}, l, {
      "data-precedence": l.precedence,
      precedence: null
    });
  }
  function Fm(l, t, e, a) {
    l.querySelector('link[rel="preload"][as="style"][' + t + "]") ? a.loading = 1 : (t = l.createElement("link"), a.preload = t, t.addEventListener("load", function() {
      return a.loading |= 1;
    }), t.addEventListener("error", function() {
      return a.loading |= 2;
    }), Ql(t, "link", e), Nl(t), l.head.appendChild(t));
  }
  function Oa(l) {
    return '[src="' + gt(l) + '"]';
  }
  function En(l) {
    return "script[async]" + l;
  }
  function sd(l, t, e) {
    if (t.count++, t.instance === null)
      switch (t.type) {
        case "style":
          var a = l.querySelector(
            'style[data-href~="' + gt(e.href) + '"]'
          );
          if (a)
            return t.instance = a, Nl(a), a;
          var n = R({}, e, {
            "data-href": e.href,
            "data-precedence": e.precedence,
            href: null,
            precedence: null
          });
          return a = (l.ownerDocument || l).createElement(
            "style"
          ), Nl(a), Ql(a, "style", n), Cu(a, e.precedence, l), t.instance = a;
        case "stylesheet":
          n = ja(e.href);
          var u = l.querySelector(
            Sn(n)
          );
          if (u)
            return t.state.loading |= 4, t.instance = u, Nl(u), u;
          a = fd(e), (n = _t.get(n)) && nf(a, n), u = (l.ownerDocument || l).createElement("link"), Nl(u);
          var i = u;
          return i._p = new Promise(function(c, s) {
            i.onload = c, i.onerror = s;
          }), Ql(u, "link", a), t.state.loading |= 4, Cu(u, e.precedence, l), t.instance = u;
        case "script":
          return u = Oa(e.src), (n = l.querySelector(
            En(u)
          )) ? (t.instance = n, Nl(n), n) : (a = e, (n = _t.get(u)) && (a = R({}, e), uf(a, n)), l = l.ownerDocument || l, n = l.createElement("script"), Nl(n), Ql(n, "link", a), l.head.appendChild(n), t.instance = n);
        case "void":
          return null;
        default:
          throw Error(h(443, t.type));
      }
    else
      t.type === "stylesheet" && (t.state.loading & 4) === 0 && (a = t.instance, t.state.loading |= 4, Cu(a, e.precedence, l));
    return t.instance;
  }
  function Cu(l, t, e) {
    for (var a = e.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), n = a.length ? a[a.length - 1] : null, u = n, i = 0; i < a.length; i++) {
      var c = a[i];
      if (c.dataset.precedence === t) u = c;
      else if (u !== n) break;
    }
    u ? u.parentNode.insertBefore(l, u.nextSibling) : (t = e.nodeType === 9 ? e.head : e, t.insertBefore(l, t.firstChild));
  }
  function nf(l, t) {
    l.crossOrigin == null && (l.crossOrigin = t.crossOrigin), l.referrerPolicy == null && (l.referrerPolicy = t.referrerPolicy), l.title == null && (l.title = t.title);
  }
  function uf(l, t) {
    l.crossOrigin == null && (l.crossOrigin = t.crossOrigin), l.referrerPolicy == null && (l.referrerPolicy = t.referrerPolicy), l.integrity == null && (l.integrity = t.integrity);
  }
  var Hu = null;
  function od(l, t, e) {
    if (Hu === null) {
      var a = /* @__PURE__ */ new Map(), n = Hu = /* @__PURE__ */ new Map();
      n.set(e, a);
    } else
      n = Hu, a = n.get(e), a || (a = /* @__PURE__ */ new Map(), n.set(e, a));
    if (a.has(l)) return a;
    for (a.set(l, null), e = e.getElementsByTagName(l), n = 0; n < e.length; n++) {
      var u = e[n];
      if (!(u[qa] || u[ql] || l === "link" && u.getAttribute("rel") === "stylesheet") && u.namespaceURI !== "http://www.w3.org/2000/svg") {
        var i = u.getAttribute(t) || "";
        i = l + i;
        var c = a.get(i);
        c ? c.push(u) : a.set(i, [u]);
      }
    }
    return a;
  }
  function rd(l, t, e) {
    l = l.ownerDocument || l, l.head.insertBefore(
      e,
      t === "title" ? l.querySelector("head > title") : null
    );
  }
  function Im(l, t, e) {
    if (e === 1 || t.itemProp != null) return !1;
    switch (l) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "")
          break;
        return !0;
      case "link":
        if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError)
          break;
        return t.rel === "stylesheet" ? (l = t.disabled, typeof t.precedence == "string" && l == null) : !0;
      case "script":
        if (t.async && typeof t.async != "function" && typeof t.async != "symbol" && !t.onLoad && !t.onError && t.src && typeof t.src == "string")
          return !0;
    }
    return !1;
  }
  function dd(l) {
    return !(l.type === "stylesheet" && (l.state.loading & 3) === 0);
  }
  function Pm(l, t, e, a) {
    if (e.type === "stylesheet" && (typeof a.media != "string" || matchMedia(a.media).matches !== !1) && (e.state.loading & 4) === 0) {
      if (e.instance === null) {
        var n = ja(a.href), u = t.querySelector(
          Sn(n)
        );
        if (u) {
          t = u._p, t !== null && typeof t == "object" && typeof t.then == "function" && (l.count++, l = qu.bind(l), t.then(l, l)), e.state.loading |= 4, e.instance = u, Nl(u);
          return;
        }
        u = t.ownerDocument || t, a = fd(a), (n = _t.get(n)) && nf(a, n), u = u.createElement("link"), Nl(u);
        var i = u;
        i._p = new Promise(function(c, s) {
          i.onload = c, i.onerror = s;
        }), Ql(u, "link", a), e.instance = u;
      }
      l.stylesheets === null && (l.stylesheets = /* @__PURE__ */ new Map()), l.stylesheets.set(e, t), (t = e.state.preload) && (e.state.loading & 3) === 0 && (l.count++, e = qu.bind(l), t.addEventListener("load", e), t.addEventListener("error", e));
    }
  }
  var cf = 0;
  function ly(l, t) {
    return l.stylesheets && l.count === 0 && Yu(l, l.stylesheets), 0 < l.count || 0 < l.imgCount ? function(e) {
      var a = setTimeout(function() {
        if (l.stylesheets && Yu(l, l.stylesheets), l.unsuspend) {
          var u = l.unsuspend;
          l.unsuspend = null, u();
        }
      }, 6e4 + t);
      0 < l.imgBytes && cf === 0 && (cf = 62500 * Cm());
      var n = setTimeout(
        function() {
          if (l.waitingForImages = !1, l.count === 0 && (l.stylesheets && Yu(l, l.stylesheets), l.unsuspend)) {
            var u = l.unsuspend;
            l.unsuspend = null, u();
          }
        },
        (l.imgBytes > cf ? 50 : 800) + t
      );
      return l.unsuspend = e, function() {
        l.unsuspend = null, clearTimeout(a), clearTimeout(n);
      };
    } : null;
  }
  function qu() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) Yu(this, this.stylesheets);
      else if (this.unsuspend) {
        var l = this.unsuspend;
        this.unsuspend = null, l();
      }
    }
  }
  var Bu = null;
  function Yu(l, t) {
    l.stylesheets = null, l.unsuspend !== null && (l.count++, Bu = /* @__PURE__ */ new Map(), t.forEach(ty, l), Bu = null, qu.call(l));
  }
  function ty(l, t) {
    if (!(t.state.loading & 4)) {
      var e = Bu.get(l);
      if (e) var a = e.get(null);
      else {
        e = /* @__PURE__ */ new Map(), Bu.set(l, e);
        for (var n = l.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), u = 0; u < n.length; u++) {
          var i = n[u];
          (i.nodeName === "LINK" || i.getAttribute("media") !== "not all") && (e.set(i.dataset.precedence, i), a = i);
        }
        a && e.set(null, a);
      }
      n = t.instance, i = n.getAttribute("data-precedence"), u = e.get(i) || a, u === a && e.set(null, n), e.set(i, n), this.count++, a = qu.bind(this), n.addEventListener("load", a), n.addEventListener("error", a), u ? u.parentNode.insertBefore(n, u.nextSibling) : (l = l.nodeType === 9 ? l.head : l, l.insertBefore(n, l.firstChild)), t.state.loading |= 4;
    }
  }
  var An = {
    $$typeof: Tl,
    Provider: null,
    Consumer: null,
    _currentValue: Y,
    _currentValue2: Y,
    _threadCount: 0
  };
  function ey(l, t, e, a, n, u, i, c, s) {
    this.tag = 1, this.containerInfo = l, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = ti(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = ti(0), this.hiddenUpdates = ti(null), this.identifierPrefix = a, this.onUncaughtError = n, this.onCaughtError = u, this.onRecoverableError = i, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = s, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function hd(l, t, e, a, n, u, i, c, s, y, p, A) {
    return l = new ey(
      l,
      t,
      e,
      i,
      s,
      y,
      p,
      A,
      c
    ), t = 1, u === !0 && (t |= 24), u = ct(3, null, null, t), l.current = u, u.stateNode = l, t = Gi(), t.refCount++, l.pooledCache = t, t.refCount++, u.memoizedState = {
      element: a,
      isDehydrated: e,
      cache: t
    }, Li(u), l;
  }
  function md(l) {
    return l ? (l = ua, l) : ua;
  }
  function yd(l, t, e, a, n, u) {
    n = md(n), a.context === null ? a.context = n : a.pendingContext = n, a = ce(t), a.payload = { element: e }, u = u === void 0 ? null : u, u !== null && (a.callback = u), e = fe(l, a, t), e !== null && (tt(e, l, t), Pa(e, l, t));
  }
  function vd(l, t) {
    if (l = l.memoizedState, l !== null && l.dehydrated !== null) {
      var e = l.retryLane;
      l.retryLane = e !== 0 && e < t ? e : t;
    }
  }
  function ff(l, t) {
    vd(l, t), (l = l.alternate) && vd(l, t);
  }
  function gd(l) {
    if (l.tag === 13 || l.tag === 31) {
      var t = Ne(l, 67108864);
      t !== null && tt(t, l, 67108864), ff(l, 67108864);
    }
  }
  function pd(l) {
    if (l.tag === 13 || l.tag === 31) {
      var t = dt();
      t = ei(t);
      var e = Ne(l, t);
      e !== null && tt(e, l, t), ff(l, t);
    }
  }
  var Gu = !0;
  function ay(l, t, e, a) {
    var n = b.T;
    b.T = null;
    var u = _.p;
    try {
      _.p = 2, sf(l, t, e, a);
    } finally {
      _.p = u, b.T = n;
    }
  }
  function ny(l, t, e, a) {
    var n = b.T;
    b.T = null;
    var u = _.p;
    try {
      _.p = 8, sf(l, t, e, a);
    } finally {
      _.p = u, b.T = n;
    }
  }
  function sf(l, t, e, a) {
    if (Gu) {
      var n = of(a);
      if (n === null)
        kc(
          l,
          t,
          a,
          Qu,
          e
        ), Sd(l, a);
      else if (iy(
        n,
        l,
        t,
        e,
        a
      ))
        a.stopPropagation();
      else if (Sd(l, a), t & 4 && -1 < uy.indexOf(l)) {
        for (; n !== null; ) {
          var u = ke(n);
          if (u !== null)
            switch (u.tag) {
              case 3:
                if (u = u.stateNode, u.current.memoizedState.isDehydrated) {
                  var i = xe(u.pendingLanes);
                  if (i !== 0) {
                    var c = u;
                    for (c.pendingLanes |= 2, c.entangledLanes |= 2; i; ) {
                      var s = 1 << 31 - ut(i);
                      c.entanglements[1] |= s, i &= ~s;
                    }
                    Rt(u), (tl & 6) === 0 && (Au = at() + 500, vn(0));
                  }
                }
                break;
              case 31:
              case 13:
                c = Ne(u, 2), c !== null && tt(c, u, 2), zu(), ff(u, 2);
            }
          if (u = of(a), u === null && kc(
            l,
            t,
            a,
            Qu,
            e
          ), u === n) break;
          n = u;
        }
        n !== null && a.stopPropagation();
      } else
        kc(
          l,
          t,
          a,
          null,
          e
        );
    }
  }
  function of(l) {
    return l = ri(l), rf(l);
  }
  var Qu = null;
  function rf(l) {
    if (Qu = null, l = Je(l), l !== null) {
      var t = L(l);
      if (t === null) l = null;
      else {
        var e = t.tag;
        if (e === 13) {
          if (l = sl(t), l !== null) return l;
          l = null;
        } else if (e === 31) {
          if (l = ll(t), l !== null) return l;
          l = null;
        } else if (e === 3) {
          if (t.stateNode.current.memoizedState.isDehydrated)
            return t.tag === 3 ? t.stateNode.containerInfo : null;
          l = null;
        } else t !== l && (l = null);
      }
    }
    return Qu = l, null;
  }
  function bd(l) {
    switch (l) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (Vd()) {
          case xf:
            return 2;
          case jf:
            return 8;
          case Dn:
          case Kd:
            return 32;
          case Of:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var df = !1, be = null, Se = null, Ee = null, Tn = /* @__PURE__ */ new Map(), zn = /* @__PURE__ */ new Map(), Ae = [], uy = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function Sd(l, t) {
    switch (l) {
      case "focusin":
      case "focusout":
        be = null;
        break;
      case "dragenter":
      case "dragleave":
        Se = null;
        break;
      case "mouseover":
      case "mouseout":
        Ee = null;
        break;
      case "pointerover":
      case "pointerout":
        Tn.delete(t.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        zn.delete(t.pointerId);
    }
  }
  function _n(l, t, e, a, n, u) {
    return l === null || l.nativeEvent !== u ? (l = {
      blockedOn: t,
      domEventName: e,
      eventSystemFlags: a,
      nativeEvent: u,
      targetContainers: [n]
    }, t !== null && (t = ke(t), t !== null && gd(t)), l) : (l.eventSystemFlags |= a, t = l.targetContainers, n !== null && t.indexOf(n) === -1 && t.push(n), l);
  }
  function iy(l, t, e, a, n) {
    switch (t) {
      case "focusin":
        return be = _n(
          be,
          l,
          t,
          e,
          a,
          n
        ), !0;
      case "dragenter":
        return Se = _n(
          Se,
          l,
          t,
          e,
          a,
          n
        ), !0;
      case "mouseover":
        return Ee = _n(
          Ee,
          l,
          t,
          e,
          a,
          n
        ), !0;
      case "pointerover":
        var u = n.pointerId;
        return Tn.set(
          u,
          _n(
            Tn.get(u) || null,
            l,
            t,
            e,
            a,
            n
          )
        ), !0;
      case "gotpointercapture":
        return u = n.pointerId, zn.set(
          u,
          _n(
            zn.get(u) || null,
            l,
            t,
            e,
            a,
            n
          )
        ), !0;
    }
    return !1;
  }
  function Ed(l) {
    var t = Je(l.target);
    if (t !== null) {
      var e = L(t);
      if (e !== null) {
        if (t = e.tag, t === 13) {
          if (t = sl(e), t !== null) {
            l.blockedOn = t, Cf(l.priority, function() {
              pd(e);
            });
            return;
          }
        } else if (t === 31) {
          if (t = ll(e), t !== null) {
            l.blockedOn = t, Cf(l.priority, function() {
              pd(e);
            });
            return;
          }
        } else if (t === 3 && e.stateNode.current.memoizedState.isDehydrated) {
          l.blockedOn = e.tag === 3 ? e.stateNode.containerInfo : null;
          return;
        }
      }
    }
    l.blockedOn = null;
  }
  function Xu(l) {
    if (l.blockedOn !== null) return !1;
    for (var t = l.targetContainers; 0 < t.length; ) {
      var e = of(l.nativeEvent);
      if (e === null) {
        e = l.nativeEvent;
        var a = new e.constructor(
          e.type,
          e
        );
        oi = a, e.target.dispatchEvent(a), oi = null;
      } else
        return t = ke(e), t !== null && gd(t), l.blockedOn = e, !1;
      t.shift();
    }
    return !0;
  }
  function Ad(l, t, e) {
    Xu(l) && e.delete(t);
  }
  function cy() {
    df = !1, be !== null && Xu(be) && (be = null), Se !== null && Xu(Se) && (Se = null), Ee !== null && Xu(Ee) && (Ee = null), Tn.forEach(Ad), zn.forEach(Ad);
  }
  function Zu(l, t) {
    l.blockedOn === t && (l.blockedOn = null, df || (df = !0, S.unstable_scheduleCallback(
      S.unstable_NormalPriority,
      cy
    )));
  }
  var Lu = null;
  function Td(l) {
    Lu !== l && (Lu = l, S.unstable_scheduleCallback(
      S.unstable_NormalPriority,
      function() {
        Lu === l && (Lu = null);
        for (var t = 0; t < l.length; t += 3) {
          var e = l[t], a = l[t + 1], n = l[t + 2];
          if (typeof a != "function") {
            if (rf(a || e) === null)
              continue;
            break;
          }
          var u = ke(e);
          u !== null && (l.splice(t, 3), t -= 3, sc(
            u,
            {
              pending: !0,
              data: n,
              method: e.method,
              action: a
            },
            a,
            n
          ));
        }
      }
    ));
  }
  function Da(l) {
    function t(s) {
      return Zu(s, l);
    }
    be !== null && Zu(be, l), Se !== null && Zu(Se, l), Ee !== null && Zu(Ee, l), Tn.forEach(t), zn.forEach(t);
    for (var e = 0; e < Ae.length; e++) {
      var a = Ae[e];
      a.blockedOn === l && (a.blockedOn = null);
    }
    for (; 0 < Ae.length && (e = Ae[0], e.blockedOn === null); )
      Ed(e), e.blockedOn === null && Ae.shift();
    if (e = (l.ownerDocument || l).$$reactFormReplay, e != null)
      for (a = 0; a < e.length; a += 3) {
        var n = e[a], u = e[a + 1], i = n[Wl] || null;
        if (typeof u == "function")
          i || Td(e);
        else if (i) {
          var c = null;
          if (u && u.hasAttribute("formAction")) {
            if (n = u, i = u[Wl] || null)
              c = i.formAction;
            else if (rf(n) !== null) continue;
          } else c = i.action;
          typeof c == "function" ? e[a + 1] = c : (e.splice(a, 3), a -= 3), Td(e);
        }
      }
  }
  function zd() {
    function l(u) {
      u.canIntercept && u.info === "react-transition" && u.intercept({
        handler: function() {
          return new Promise(function(i) {
            return n = i;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function t() {
      n !== null && (n(), n = null), a || setTimeout(e, 20);
    }
    function e() {
      if (!a && !navigation.transition) {
        var u = navigation.currentEntry;
        u && u.url != null && navigation.navigate(u.url, {
          state: u.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var a = !1, n = null;
      return navigation.addEventListener("navigate", l), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(e, 100), function() {
        a = !0, navigation.removeEventListener("navigate", l), navigation.removeEventListener("navigatesuccess", t), navigation.removeEventListener("navigateerror", t), n !== null && (n(), n = null);
      };
    }
  }
  function hf(l) {
    this._internalRoot = l;
  }
  Vu.prototype.render = hf.prototype.render = function(l) {
    var t = this._internalRoot;
    if (t === null) throw Error(h(409));
    var e = t.current, a = dt();
    yd(e, a, l, t, null, null);
  }, Vu.prototype.unmount = hf.prototype.unmount = function() {
    var l = this._internalRoot;
    if (l !== null) {
      this._internalRoot = null;
      var t = l.containerInfo;
      yd(l.current, 2, null, l, null, null), zu(), t[we] = null;
    }
  };
  function Vu(l) {
    this._internalRoot = l;
  }
  Vu.prototype.unstable_scheduleHydration = function(l) {
    if (l) {
      var t = Rf();
      l = { blockedOn: null, target: l, priority: t };
      for (var e = 0; e < Ae.length && t !== 0 && t < Ae[e].priority; e++) ;
      Ae.splice(e, 0, l), e === 0 && Ed(l);
    }
  };
  var _d = U.version;
  if (_d !== "19.2.7")
    throw Error(
      h(
        527,
        _d,
        "19.2.7"
      )
    );
  _.findDOMNode = function(l) {
    var t = l._reactInternals;
    if (t === void 0)
      throw typeof l.render == "function" ? Error(h(188)) : (l = Object.keys(l).join(","), Error(h(268, l)));
    return l = T(t), l = l !== null ? $(l) : null, l = l === null ? null : l.stateNode, l;
  };
  var fy = {
    bundleType: 0,
    version: "19.2.7",
    rendererPackageName: "react-dom",
    currentDispatcherRef: b,
    reconcilerVersion: "19.2.7"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Ku = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Ku.isDisabled && Ku.supportsFiber)
      try {
        Ra = Ku.inject(
          fy
        ), nt = Ku;
      } catch {
      }
  }
  return jn.createRoot = function(l, t) {
    if (!B(l)) throw Error(h(299));
    var e = !1, a = "", n = Uo, u = Ro, i = Co;
    return t != null && (t.unstable_strictMode === !0 && (e = !0), t.identifierPrefix !== void 0 && (a = t.identifierPrefix), t.onUncaughtError !== void 0 && (n = t.onUncaughtError), t.onCaughtError !== void 0 && (u = t.onCaughtError), t.onRecoverableError !== void 0 && (i = t.onRecoverableError)), t = hd(
      l,
      1,
      !1,
      null,
      null,
      e,
      a,
      null,
      n,
      u,
      i,
      zd
    ), l[we] = t.current, Jc(l), new hf(t);
  }, jn.hydrateRoot = function(l, t, e) {
    if (!B(l)) throw Error(h(299));
    var a = !1, n = "", u = Uo, i = Ro, c = Co, s = null;
    return e != null && (e.unstable_strictMode === !0 && (a = !0), e.identifierPrefix !== void 0 && (n = e.identifierPrefix), e.onUncaughtError !== void 0 && (u = e.onUncaughtError), e.onCaughtError !== void 0 && (i = e.onCaughtError), e.onRecoverableError !== void 0 && (c = e.onRecoverableError), e.formState !== void 0 && (s = e.formState)), t = hd(
      l,
      1,
      !0,
      t,
      e ?? null,
      a,
      n,
      s,
      u,
      i,
      c,
      zd
    ), t.context = md(null), e = t.current, a = dt(), a = ei(a), n = ce(a), n.callback = null, fe(e, n, a), e = a, t.current.lanes = e, Ha(t, e), Rt(t), l[we] = t.current, Jc(l), new Vu(t);
  }, jn.version = "19.2.7", jn;
}
var Hd;
function py() {
  if (Hd) return yf.exports;
  Hd = 1;
  function S() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(S);
      } catch (U) {
        console.error(U);
      }
  }
  return S(), yf.exports = gy(), yf.exports;
}
var by = py(), wl = Tf();
const Sf = {
  mode: "local_qa",
  qaBanner: !0,
  commerceEnabled: !1,
  analyticsEnabled: !0,
  coreVariantId: "",
  deckVariantId: "",
  checkoutPath: "/checkout",
  cartAddPath: "/cart/add.js",
  cartUpdatePath: "/cart/update.js",
  assetUrls: {}
};
let wu = null;
function qd(S) {
  return typeof S == "object" && S !== null;
}
function Na() {
  if (wu) return wu;
  if (typeof document > "u") return Sf;
  const S = document.querySelector("script[data-sc-fad-config]");
  let U = {};
  try {
    const j = S?.textContent ? JSON.parse(S.textContent) : {};
    U = qd(j) ? j : {};
  } catch {
    U = {};
  }
  return wu = {
    ...Sf,
    ...U,
    assetUrls: qd(U.assetUrls) ? U.assetUrls : Sf.assetUrls
  }, wu;
}
function Sy(S) {
  return Na().assetUrls[S] ?? S;
}
function Ey() {
  try {
    return window.__scFighterArchetypeAnalyticsConsent === !0 || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === !0;
  } catch {
    return !1;
  }
}
function Ma(S, U = {}) {
  const j = Na();
  if (window.__scFighterArchetypeEvents ??= [], window.__scFighterArchetypeQa ??= {
    getEvents: () => [...window.__scFighterArchetypeEvents ?? []]
  }, S === "landing_page_view" && window.__scFighterArchetypeEvents.some((L) => L.event === S))
    return window.__scFighterArchetypeEvents.find((L) => L.event === S);
  const h = j.analyticsEnabled && Ey(), B = {
    ...U,
    event: S,
    namespace: "fighter_archetype_decoder",
    currency: "USD",
    qa_mode: j.mode !== "shopify_live",
    consent_state: h ? "allowed" : "denied_or_unknown",
    timestamp: (/* @__PURE__ */ new Date()).toISOString()
  };
  if (window.__scFighterArchetypeEvents.push(B), h) {
    window.dataLayer?.push(B), window.gtag?.("event", `fighter_archetype_decoder:${S}`, B);
    try {
      window.Shopify?.analytics?.publish?.(`fighter_archetype_decoder:${S}`, B);
    } catch {
    }
  }
  return B;
}
const Bd = {
  corePrice: 29,
  bundlePrice: 41
};
function Ju(S) {
  return S ? Bd.bundlePrice : Bd.corePrice;
}
function ku(S, U) {
  if (!/^\d+$/.test(S))
    throw new Error(`${U} is not configured with a verified Shopify variant ID.`);
  return Number(S);
}
function Ay(S, U, j) {
  const h = [{ id: ku(U, "Fighter Archetype Decoder"), quantity: 1 }];
  return S && h.push({ id: ku(j, "Archetype Adjustment Field Deck"), quantity: 1 }), h;
}
function Ty(S, U = {}) {
  const j = /* @__PURE__ */ new Set(["spear", "wall", "net", "ghost", "spiral", "mixed", "inconclusive"]), h = U.result && j.has(U.result) ? U.result : void 0;
  return {
    __sc_offer: "fighter_archetype_decoder",
    __sc_archetype_adjustment_deck: S ? "yes" : "no",
    __sc_expected_total_usd: String(Ju(S)),
    ...h ? { __sc_archetype_starting_point: h } : {}
  };
}
function zy(S, U = {}) {
  const j = Na(), h = Ay(S, j.coreVariantId, j.deckVariantId);
  return {
    targetVariantIds: {
      core: ku(j.coreVariantId, "Fighter Archetype Decoder"),
      deck: ku(j.deckVariantId, "Archetype Adjustment Field Deck")
    },
    items: h,
    update: {
      updates: {
        [j.coreVariantId]: 1,
        [j.deckVariantId]: S ? 1 : 0
      },
      attributes: Ty(S, U)
    },
    checkoutPath: j.checkoutPath
  };
}
function Ef(S) {
  return Number(S.variant_id ?? S.id ?? 0);
}
function Yd(S, U) {
  return (S.items ?? []).filter((j) => Ef(j) === U).reduce((j, h) => j + Number(h.quantity ?? 0), 0);
}
function Qd(S, U) {
  return new Map((S.items ?? []).filter((j) => !U.has(Ef(j))).map((j) => [String(j.key ?? Ef(j)), Number(j.quantity ?? 0)]));
}
function _y(S, U, j, h, B) {
  if (Yd(S, U) !== 1)
    throw new Error("Shopify did not preserve exactly one Fighter Archetype Decoder.");
  if (Yd(S, j) !== (h ? 1 : 0))
    throw new Error("Shopify did not preserve the exact optional deck selection.");
  const sl = Qd(S, /* @__PURE__ */ new Set([U, j]));
  if (sl.size !== B.size || [...B].some(([ll, O]) => sl.get(ll) !== O))
    throw new Error("Shopify changed an unrelated cart item; checkout was stopped.");
}
async function xy(S, U = {}, j = fetch) {
  const h = Na();
  if (!h.commerceEnabled)
    throw new Error("Fighter Archetype Decoder checkout is disabled until exact products and protected delivery are verified.");
  const B = zy(S, U), L = await j("/cart.js", {
    method: "GET",
    headers: { Accept: "application/json" },
    credentials: "same-origin"
  });
  if (!L.ok) throw new Error("Shopify could not verify the current cart safely.");
  const sl = await L.json(), ll = /* @__PURE__ */ new Set([B.targetVariantIds.core, B.targetVariantIds.deck]), O = Qd(sl, ll), T = await j(h.cartUpdatePath, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    credentials: "same-origin",
    body: JSON.stringify(B.update)
  });
  if (!T.ok) throw new Error("Shopify could not set the exact digital offer quantities.");
  const $ = await T.json();
  return _y(
    $,
    B.targetVariantIds.core,
    B.targetVariantIds.deck,
    S,
    O
  ), B.checkoutPath;
}
const jy = ["spear", "wall", "net", "ghost", "spiral"], ze = [
  {
    id: "D01",
    axis: "initiative",
    prompt: "At the first clear opening, what usually happens?",
    choices: [
      { label: "Enter directly before the opening changes.", value: "spear" },
      { label: "Hold position and make the other person enter first.", value: "wall" },
      { label: "Seek contact and build from the reaction.", value: "net" },
      { label: "Draw the action and answer after it starts.", value: "ghost" },
      { label: "Change angle or level before choosing the entry.", value: "spiral" }
    ]
  },
  {
    id: "D02",
    axis: "initiative",
    prompt: "When neither person has a clean advantage, what restores clarity?",
    choices: [
      { label: "A committed first action.", value: "spear" },
      { label: "A stable line that denies easy access.", value: "wall" },
      { label: "A safe point of contact.", value: "net" },
      { label: "Space and a timing cue.", value: "ghost" },
      { label: "A change in relationship or angle.", value: "spiral" }
    ]
  },
  {
    id: "D03",
    axis: "preferred range",
    prompt: "Which range feels easiest to organize?",
    choices: [
      { label: "The range where one direct entry can arrive.", value: "spear" },
      { label: "The range where base and frames can deny movement.", value: "wall" },
      { label: "The range where contact can be maintained.", value: "net" },
      { label: "The range where the first action can miss or fall short.", value: "ghost" },
      { label: "The range where transitions between positions stay available.", value: "spiral" }
    ]
  },
  {
    id: "D04",
    axis: "preferred range",
    prompt: "When range becomes unclear, what do you tend to do?",
    choices: [
      { label: "Close it quickly.", value: "spear" },
      { label: "Set the boundary and wait.", value: "wall" },
      { label: "Touch, attach, or hand-fight to locate it.", value: "net" },
      { label: "Exit until the picture is clear.", value: "ghost" },
      { label: "Step off-line and re-enter from a new relationship.", value: "spiral" }
    ]
  },
  {
    id: "D05",
    axis: "direction of pressure",
    prompt: "Where does your pressure usually travel?",
    choices: [
      { label: "Forward through the clearest line.", value: "spear" },
      { label: "Back into the ground and outward through structure.", value: "wall" },
      { label: "Around or through connected points.", value: "net" },
      { label: "Away from the first line, then back into the opening.", value: "ghost" },
      { label: "Across angles and transitions.", value: "spiral" }
    ]
  },
  {
    id: "D06",
    axis: "direction of pressure",
    prompt: "When a partner resists your first direction, what is most natural?",
    choices: [
      { label: "Increase commitment or find a second direct route.", value: "spear" },
      { label: "Strengthen the base and deny displacement.", value: "wall" },
      { label: "Follow the resistance into another connection.", value: "net" },
      { label: "Let the resistance travel past and return.", value: "ghost" },
      { label: "Change the direction once and observe the new response.", value: "spiral" }
    ]
  },
  {
    id: "D07",
    axis: "reaction to resistance",
    prompt: "A planned action is blocked early. What happens next?",
    choices: [
      { label: "Drive to the next direct option.", value: "spear" },
      { label: "Stop the partner from gaining more ground.", value: "wall" },
      { label: "Link another controlled action to the contact.", value: "net" },
      { label: "Disengage and wait for the follow-up.", value: "ghost" },
      { label: "Switch the relationship, then stabilize.", value: "spiral" }
    ]
  },
  {
    id: "D08",
    axis: "reaction to resistance",
    prompt: "Under controlled pressure, where does your attention go first?",
    choices: [
      { label: "The next line forward.", value: "spear" },
      { label: "The part of the position that must not collapse.", value: "wall" },
      { label: "The contact point that reveals the partner’s reaction.", value: "net" },
      { label: "The exit and counter window.", value: "ghost" },
      { label: "The moment the current answer stops working.", value: "spiral" }
    ]
  },
  {
    id: "D09",
    axis: "recovery after a failed action",
    prompt: "After a miss or failed action, what is the usual recovery?",
    choices: [
      { label: "Continue immediately with a second direct action.", value: "spear" },
      { label: "Rebuild base and deny the return.", value: "wall" },
      { label: "Reconnect before the partner escapes.", value: "net" },
      { label: "Leave range and reset.", value: "ghost" },
      { label: "Change angle or task, then settle.", value: "spiral" }
    ]
  },
  {
    id: "D10",
    axis: "recovery after a failed action",
    prompt: "What failure feels most uncomfortable?",
    choices: [
      { label: "Losing the initiative.", value: "spear" },
      { label: "Losing structure or ground.", value: "wall" },
      { label: "Losing connection.", value: "net" },
      { label: "Being held in the exchange.", value: "ghost" },
      { label: "Being forced to repeat an answer that is not working.", value: "spiral" }
    ]
  }
];
function Oy(S) {
  const U = S.slice(0, ze.length), j = U.filter((ll) => ll !== null);
  if (j.length < 8) return "inconclusive";
  const h = jy.map((ll) => ({ id: ll, score: j.filter((O) => O === ll).length })).sort((ll, O) => O.score - ll.score), [B, L] = h, sl = new Set(
    U.flatMap(
      (ll, O) => ll === B.id ? [ze[O].axis] : []
    )
  );
  return B.score >= 4 && B.score - L.score >= 2 && sl.size >= 3 ? B.id : B.score - L.score <= 1 ? "mixed" : "inconclusive";
}
const Dt = {
  id: "FAD-D15",
  name: "Change the Answer",
  purpose: "Test one alternative when a familiar default stops producing a useful result.",
  startingPosition: "Choose one prior drill and name the default lens. Partner B uses its cooperative starting position.",
  allowedActions: "Round 1: A uses the familiar answer once. Round 2: B repeats the same safe cue and A uses the selected adjustment. Round 3: A chooses familiar, adjusted, or reset and explains the choice afterward.",
  prohibitedActions: "No surprise resistance, no new technique, no contact above the agreed drill, and no treating the alternative as automatically better. No head contact, hard sparring, joint finishes, neck pressure, spinal loading, uncontrolled takedowns, weapons, or competition-speed resistance.",
  intensityCeiling: "Technical pace only, no more than 3/10 effort. Either partner can pause immediately.",
  duration: "Three rounds of five controlled repetitions with a full debrief between rounds.",
  successMeasure: "A remains within the drill constraints, can name the cue that changed the decision, and identifies one observable difference without claiming a winner.",
  regression: "Perform all three rounds as shadow movement with a coach giving verbal cues.",
  stopConditions: [
    "Either partner withdraws consent or asks to stop.",
    "Pain, dizziness, confusion, vision change, unusual headache, nausea, numbness, weakness, loss of balance, or any suspected concussion.",
    "Equipment failure, an unsafe surface, uncontrolled speed, or loss of the agreed technical intensity."
  ]
}, Dy = [
  { day: "Day 1", phase: "Observe", action: "Complete the diagnostic from memory, mark confidence, and write one context where the result may change.", intensity: "No physical drill." },
  { day: "Day 2", phase: "Observe", action: "Have a coach or partner complete the diagnostic from recent controlled training and compare only observable differences.", intensity: "No physical drill." },
  { day: "Day 3", phase: "Observe", action: "Record three moments when your default created useful information and three when it narrowed your options.", intensity: "No physical drill." },
  { day: "Day 4", phase: "Isolate", action: "Run the first drill linked to your starting lens at the regression level.", intensity: "3/10 maximum." },
  { day: "Day 5", phase: "Isolate", action: "Repeat that drill and record one success measure rather than an impression.", intensity: "3/10 maximum." },
  { day: "Day 6", phase: "Isolate", action: "Run the second drill linked to your starting lens.", intensity: "3/10 maximum." },
  { day: "Day 7", phase: "Review", action: "Rest from partner drilling. Write what the lens explains and what it does not explain.", intensity: "Reflection only." },
  { day: "Day 8", phase: "Contrast", action: "Choose the lens most unlike your starting lens and shadow its first drill.", intensity: "No contact." },
  { day: "Day 9", phase: "Contrast", action: "Run the regression of that contrast drill with a cooperative partner.", intensity: "2/10 maximum." },
  { day: "Day 10", phase: "Contrast", action: "Use the matchup matrix to choose one adjustment against a common partner tendency.", intensity: "Planning only." },
  { day: "Day 11", phase: "Test", action: "Run the chosen adjustment in its safest matching drill.", intensity: "3/10 maximum." },
  { day: "Day 12", phase: "Test", action: "Repeat and record whether position, information, or recovery changed.", intensity: "3/10 maximum." },
  { day: "Day 13", phase: "Reset", action: "Run FAD-D14 Recovery Before Transition, regardless of starting lens.", intensity: "No contact." },
  { day: "Day 14", phase: "Review", action: "Re-score the diagnostic using only Days 4-13. Mixed or inconclusive is acceptable.", intensity: "Reflection only." },
  { day: "Day 15", phase: "Integrate", action: "Select one familiar drill and prepare Change the Answer with a partner.", intensity: "Planning and consent check." },
  { day: "Day 16", phase: "Integrate", action: "Run Change the Answer at the regression level.", intensity: "2/10 maximum." },
  { day: "Day 17", phase: "Integrate", action: "Repeat only if all stop and consent checks remain green.", intensity: "3/10 maximum." },
  { day: "Day 18", phase: "Coach", action: "Ask a coach to observe one cue: initiative, range, pressure direction, resistance response, or recovery.", intensity: "No new intensity." },
  { day: "Day 19", phase: "Coach", action: "Run one drill while the coach records only that cue.", intensity: "3/10 maximum." },
  { day: "Day 20", phase: "Choose", action: "Write a two-sentence plan: the default you will notice and the alternative you will test next.", intensity: "Reflection only." },
  { day: "Day 21", phase: "Close", action: "Review the evidence, keep one drill, retire one drill, and name one question for qualified coaching.", intensity: "No test or graduation claim." }
], Af = [
  { id: "spear", name: "Spear", lens: "Direct initiative, linear entry, and commitment.", blind: "Commitment can become predictability when the first answer fails." },
  { id: "wall", name: "Wall", lens: "Base, denial, containment, and pressure absorption.", blind: "Containment can become passivity when the exchange demands initiative." },
  { id: "net", name: "Net", lens: "Attachment, entanglement, reaction chaining, and control.", blind: "Connection can become over-attachment when the structure changes." },
  { id: "ghost", name: "Ghost", lens: "Evasion, counter timing, misdirection, and exit.", blind: "Evasion can surrender initiative when the exit has no return." },
  { id: "spiral", name: "Spiral", lens: "Adaptive switching, angle change, recovery, and transition.", blind: "Adaptation can become indecision without a stable first rule." }
], My = [
  ["Is this a personality test?", "No. It is a Spiral Combat coaching heuristic about observable training choices. It is not psychology, biology, a fixed identity, or a validated taxonomy."],
  ["Does one archetype beat the others?", "No. Each lens can be useful or limiting depending on range, rules, resistance, and the moment. Mixed and inconclusive results are valid."],
  ["Will it predict who wins?", "No. It does not predict fights or guarantee improvement. It gives practitioners and coaches a shared language for noticing defaults and selecting controlled drills."],
  ["What is included for $29?", "A 28-page cinematic illustrated Codex, searchable semantic training companion, five-archetype diagnostic, adjustment matrix, 15 controlled drills, the complete Change the Answer sample drill, a 21-day start protocol, accessible editions, and a printable worksheet. The Fighter Beneath the Pattern, the philosophical companion, is also included."],
  ["Is the $12 deck physical?", "No. The 30-card Archetype Adjustment Field Deck is phone-first and digital. It is optional, unchecked by default, and includes an accessible edition and printable six-card quick sheet."],
  ["What should stop a drill?", "Stop immediately for pain, dizziness, confusion, vision change, unusual headache, loss of balance, nausea, numbness, weakness, suspected concussion, unsafe space, equipment failure, or either partner withdrawing consent."]
], Ve = {
  cover: "/assets/fighter-archetype-decoder/page-01.png",
  framework: "/assets/fighter-archetype-decoder/page-08.png",
  diagnostic: "/assets/fighter-archetype-decoder/page-14.png",
  drill: "/assets/fighter-archetype-decoder/page-21.png",
  protocol: "/assets/fighter-archetype-decoder/page-26.png",
  deck: "/assets/fighter-archetype-decoder/deck-preview.png"
};
function Ke({ asset: S, label: U, source: j }) {
  return Na().assetUrls[S] ? /* @__PURE__ */ f.jsx("img", { src: Sy(S), alt: U, loading: "lazy" }) : /* @__PURE__ */ f.jsxs("div", { className: "fad-asset-pending", "data-final-asset": S, "data-source-manifest-path": j, children: [
    /* @__PURE__ */ f.jsx("span", { children: "Verified product image pending" }),
    /* @__PURE__ */ f.jsx("strong", { children: U }),
    /* @__PURE__ */ f.jsx("small", { children: "This review build will not substitute generic art." })
  ] });
}
function Gd(S) {
  if (S === "mixed") return { title: "Mixed pattern", body: "Your answers do not support one dominant starting point. Use coach observation across several rounds and begin with the situation where your choices become least flexible." };
  if (S === "inconclusive") return { title: "Inconclusive", body: "Your answers are distributed too evenly to name a useful starting point. That uncertainty is honest. Repeat after observed rounds instead of forcing a label." };
  const U = Af.find((j) => j.id === S);
  return { title: `${U.name} starting lens`, body: `${U.lens} Watch the boundary: ${U.blind}` };
}
function Ny() {
  const S = Na(), U = wl.useRef(null), j = wl.useRef(null), h = wl.useRef(null), B = wl.useRef(!1), [L, sl] = wl.useState(0), [ll, O] = wl.useState([]), [T, $] = wl.useState(null), [R, dl] = wl.useState(!1), [Rl, Cl] = wl.useState(!1), [Ml, ht] = wl.useState(!1), [Xl, mt] = wl.useState(null), [Tl, Jl] = wl.useState(0), et = wl.useMemo(() => T ? Gd(T) : null, [T]);
  wl.useEffect(() => {
    document.body.classList.add("sc-fad-page"), Ma("landing_page_view");
    const H = () => {
      if (!U.current) return;
      const hl = Math.min(1, Math.max(0, window.scrollY / Math.max(1, document.documentElement.scrollHeight - innerHeight)));
      U.current.style.setProperty("--scroll-progress", hl.toFixed(4));
    };
    return H(), window.addEventListener("scroll", H, { passive: !0 }), () => {
      document.body.classList.remove("sc-fad-page"), window.removeEventListener("scroll", H);
    };
  }, []), wl.useEffect(() => {
    if (!Rl) return;
    const hl = j.current?.querySelectorAll("button:not([disabled]), a[href], input:not([disabled])"), vl = hl?.[0], Ll = hl?.[hl.length - 1];
    vl?.focus();
    const b = (_) => {
      _.key === "Escape" && kl(), !(_.key !== "Tab" || !vl || !Ll) && (_.shiftKey && document.activeElement === vl && (_.preventDefault(), Ll.focus()), !_.shiftKey && document.activeElement === Ll && (_.preventDefault(), vl.focus()));
    };
    return document.addEventListener("keydown", b), () => document.removeEventListener("keydown", b);
  }, [Rl]);
  function Hl(H) {
    L === 0 && ll.length === 0 && Ma("diagnostic_started");
    const hl = [...ll, H];
    if (L < ze.length - 1) {
      O(hl), sl(L + 1);
      return;
    }
    const vl = Oy(hl);
    O(hl), $(vl), Ma("diagnostic_completed", { result: vl });
  }
  function V() {
    sl(0), O([]), $(null);
  }
  function Ol(H) {
    h.current = document.activeElement, Cl(!0), mt(null), Ma("primary_cta", { source: H });
  }
  function kl() {
    Cl(!1), h.current?.focus();
  }
  function It() {
    const H = !R;
    dl(H), Ma(H ? "deck_added" : "deck_removed", { total_usd: Ju(H) });
  }
  async function yt() {
    if (!B.current) {
      B.current = !0, Ma("checkout_initiated", { deck_added: R, total_usd: Ju(R), diagnostic_result: T }), ht(!0), mt(null);
      try {
        const H = await xy(R, { result: T ?? void 0 });
        window.location.assign(H);
      } catch (H) {
        mt(H instanceof Error ? H.message : "Checkout is unavailable.");
      } finally {
        ht(!1), B.current = !1;
      }
    }
  }
  return /* @__PURE__ */ f.jsxs("div", { "data-sc-fad": !0, "data-runtime-mode": S.mode, ref: U, children: [
    S.qaBanner && /* @__PURE__ */ f.jsx("p", { className: "fad-qa", children: "Local review build · commerce disabled · final product imagery pending hash verification" }),
    /* @__PURE__ */ f.jsxs("header", { className: "fad-nav", "data-section-order": "1", children: [
      /* @__PURE__ */ f.jsxs("a", { className: "fad-wordmark", href: "#top", "aria-label": "Spiral Combat, return to top", children: [
        /* @__PURE__ */ f.jsx("i", {}),
        "SPIRAL COMBAT"
      ] }),
      /* @__PURE__ */ f.jsxs("nav", { "aria-label": "Offer navigation", children: [
        /* @__PURE__ */ f.jsx("a", { href: "#framework", children: "Framework" }),
        /* @__PURE__ */ f.jsx("a", { href: "#diagnostic", children: "Diagnostic" }),
        /* @__PURE__ */ f.jsx("a", { href: "#drill", children: "Sample drill" })
      ] }),
      /* @__PURE__ */ f.jsxs("button", { type: "button", onClick: () => Ol("sticky-navigation"), children: [
        /* @__PURE__ */ f.jsx("span", { children: "$29" }),
        " Get the Decoder"
      ] })
    ] }),
    /* @__PURE__ */ f.jsxs("main", { id: "top", children: [
      /* @__PURE__ */ f.jsxs("section", { className: "fad-hero", "data-section-order": "2", children: [
        /* @__PURE__ */ f.jsxs("div", { className: "fad-hero-copy", children: [
          /* @__PURE__ */ f.jsx("p", { className: "fad-kicker", children: "FIVE COACHING LENSES · FIFTEEN CONTROLLED DRILLS · 21 DAYS" }),
          /* @__PURE__ */ f.jsx("h1", { children: "Your strongest fighting pattern creates your most predictable blind spot." }),
          /* @__PURE__ */ f.jsx("p", { className: "fad-lead", children: "Identify the combat pattern you default to, see where it tends to fail, and build a controlled corrective training plan." }),
          /* @__PURE__ */ f.jsxs("div", { className: "fad-actions", children: [
            /* @__PURE__ */ f.jsxs("button", { type: "button", onClick: () => Ol("hero"), children: [
              "Get the complete digital edition ",
              /* @__PURE__ */ f.jsx("strong", { children: "$29" })
            ] }),
            /* @__PURE__ */ f.jsx("a", { href: "#diagnostic", children: "Take the diagnostic" })
          ] }),
          /* @__PURE__ */ f.jsx("p", { className: "fad-trust", children: "One payment · protected My Library access · no subscription · nothing shipped" })
        ] }),
        /* @__PURE__ */ f.jsxs("div", { className: "fad-hero-art", children: [
          /* @__PURE__ */ f.jsx(Ke, { asset: Ve.cover, label: "Fighter Archetype Decoder Codex cover", source: "product/art/pages/page-01.png" }),
          /* @__PURE__ */ f.jsx("span", { className: "fad-orbit fad-orbit-one" }),
          /* @__PURE__ */ f.jsx("span", { className: "fad-orbit fad-orbit-two" })
        ] })
      ] }),
      /* @__PURE__ */ f.jsxs("section", { className: "fad-framework", id: "framework", "data-section-order": "3", children: [
        /* @__PURE__ */ f.jsxs("div", { className: "fad-section-heading", children: [
          /* @__PURE__ */ f.jsx("p", { className: "fad-kicker", children: "THE FIVE-PATTERN JOURNEY" }),
          /* @__PURE__ */ f.jsxs("h2", { children: [
            "A default is useful.",
            /* @__PURE__ */ f.jsx("br", {}),
            "Until the situation changes."
          ] }),
          /* @__PURE__ */ f.jsx("p", { children: "Move from pattern recognition to adjustment. These are observable coaching lenses—not permanent identities." })
        ] }),
        /* @__PURE__ */ f.jsx("div", { className: "fad-archetype-rail", children: Af.map((H, hl) => /* @__PURE__ */ f.jsxs("article", { children: [
          /* @__PURE__ */ f.jsxs("span", { children: [
            "0",
            hl + 1
          ] }),
          /* @__PURE__ */ f.jsx("h3", { children: H.name }),
          /* @__PURE__ */ f.jsx("p", { children: H.lens }),
          /* @__PURE__ */ f.jsx("small", { children: H.blind })
        ] }, H.id)) })
      ] }),
      /* @__PURE__ */ f.jsxs("section", { className: "fad-diagnostic", id: "diagnostic", "data-section-order": "4", children: [
        /* @__PURE__ */ f.jsxs("div", { children: [
          /* @__PURE__ */ f.jsx("p", { className: "fad-kicker", children: "10-OBSERVATION COACHING WORKSHEET" }),
          /* @__PURE__ */ f.jsx("h2", { children: "What pattern do you default to under resistance?" }),
          /* @__PURE__ */ f.jsx("p", { children: "Answer from recent observed training behavior—not aspiration. Complete at least eight observed items; mark an item unobserved when the context is unclear. The result selects what to observe and test first. It is not a validated test, percentage, rank, diagnosis, or prediction." })
        ] }),
        /* @__PURE__ */ f.jsx("div", { className: "fad-diagnostic-card", children: T ? /* @__PURE__ */ f.jsxs("div", { className: "fad-result", children: [
          /* @__PURE__ */ f.jsx("p", { className: "fad-step", children: "YOUR HONEST STARTING POINT" }),
          /* @__PURE__ */ f.jsx("h3", { children: et?.title }),
          /* @__PURE__ */ f.jsx("p", { children: et?.body }),
          /* @__PURE__ */ f.jsx("small", { children: "A named lens requires at least eight observed answers, four observations for that lens, a lead of at least two, and evidence across at least three axes. Mixed and inconclusive outcomes are valid. This is a drill-selection aid—not a verdict, rank, fixed identity, or prediction." }),
          /* @__PURE__ */ f.jsx("button", { type: "button", onClick: V, children: "Retake without saving" })
        ] }) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          /* @__PURE__ */ f.jsxs("p", { className: "fad-step", children: [
            ze[L].id,
            " · OBSERVATION ",
            L + 1,
            " / ",
            ze.length,
            " · ",
            ze[L].axis
          ] }),
          /* @__PURE__ */ f.jsx("h3", { children: ze[L].prompt }),
          /* @__PURE__ */ f.jsxs("div", { className: "fad-choice-list", children: [
            ze[L].choices.map(({ label: H, value: hl }) => /* @__PURE__ */ f.jsxs("button", { type: "button", onClick: () => Hl(hl), children: [
              /* @__PURE__ */ f.jsxs("span", { children: [
                Af.find((vl) => vl.id === hl)?.name,
                ": ",
                H
              ] }),
              /* @__PURE__ */ f.jsx("i", { "aria-hidden": "true", children: "→" })
            ] }, hl)),
            /* @__PURE__ */ f.jsxs("button", { className: "fad-unobserved", type: "button", onClick: () => Hl(null), children: [
              /* @__PURE__ */ f.jsx("span", { children: "Mark this item unobserved" }),
              /* @__PURE__ */ f.jsx("i", { "aria-hidden": "true", children: "—" })
            ] })
          ] })
        ] }) })
      ] }),
      /* @__PURE__ */ f.jsxs("section", { className: "fad-mechanism", "data-section-order": "5", children: [
        /* @__PURE__ */ f.jsx("p", { className: "fad-kicker", children: "THE PROBLEM AND MECHANISM" }),
        /* @__PURE__ */ f.jsx("h2", { children: "Your strength becomes a blind spot when it keeps answering a question the exchange stopped asking." }),
        /* @__PURE__ */ f.jsxs("div", { className: "fad-mechanism-grid", children: [
          /* @__PURE__ */ f.jsxs("article", { children: [
            /* @__PURE__ */ f.jsx("span", { children: "01" }),
            /* @__PURE__ */ f.jsx("h3", { children: "Notice the default" }),
            /* @__PURE__ */ f.jsx("p", { children: "Use initiative, range, pressure, resistance, and recovery as observable axes." })
          ] }),
          /* @__PURE__ */ f.jsxs("article", { children: [
            /* @__PURE__ */ f.jsx("span", { children: "02" }),
            /* @__PURE__ */ f.jsx("h3", { children: "Name the boundary" }),
            /* @__PURE__ */ f.jsx("p", { children: "Find the situation where the default becomes rigid, late, or costly." })
          ] }),
          /* @__PURE__ */ f.jsxs("article", { children: [
            /* @__PURE__ */ f.jsx("span", { children: "03" }),
            /* @__PURE__ */ f.jsx("h3", { children: "Change one answer" }),
            /* @__PURE__ */ f.jsx("p", { children: "Use controlled resistance and a measurable alternative—not random variety." })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ f.jsxs("section", { className: "fad-product", id: "offer", "data-section-order": "6", children: [
        /* @__PURE__ */ f.jsx("div", { className: "fad-product-art", children: /* @__PURE__ */ f.jsx(Ke, { asset: Ve.framework, label: "Illustrated five-archetype framework preview", source: "product/art/pages/page-08.png" }) }),
        /* @__PURE__ */ f.jsxs("div", { children: [
          /* @__PURE__ */ f.jsx("p", { className: "fad-kicker", children: "THE $29 CORE OFFER" }),
          /* @__PURE__ */ f.jsxs("h2", { children: [
            "Memorable doctrine.",
            /* @__PURE__ */ f.jsx("br", {}),
            "Exact practice."
          ] }),
          /* @__PURE__ */ f.jsxs("ul", { children: [
            /* @__PURE__ */ f.jsx("li", { children: "28-page cinematic illustrated Codex" }),
            /* @__PURE__ */ f.jsx("li", { children: "Searchable semantic training companion; plus The Fighter Beneath the Pattern" }),
            /* @__PURE__ */ f.jsx("li", { children: "Five-archetype diagnostic and adjustment matrix" }),
            /* @__PURE__ */ f.jsx("li", { children: "15 controlled drills with regressions and success measures" }),
            /* @__PURE__ */ f.jsx("li", { children: "Complete Change the Answer sample drill" }),
            /* @__PURE__ */ f.jsx("li", { children: "21-day start protocol, accessible editions, and worksheet" })
          ] }),
          /* @__PURE__ */ f.jsx("button", { type: "button", onClick: () => Ol("core-reveal"), children: "Get protected digital access · $29" })
        ] })
      ] }),
      /* @__PURE__ */ f.jsxs("section", { className: "fad-relationship", "data-section-order": "7", children: [
        /* @__PURE__ */ f.jsx("p", { className: "fad-kicker", children: "ONE CORE · ONE HONEST OPTION" }),
        /* @__PURE__ */ f.jsxs("div", { children: [
          /* @__PURE__ */ f.jsxs("article", { children: [
            /* @__PURE__ */ f.jsx("span", { children: "INCLUDED" }),
            /* @__PURE__ */ f.jsx("h3", { children: "The Fighter Archetype Decoder" }),
            /* @__PURE__ */ f.jsx("p", { children: "The Codex makes the framework memorable. The companion keeps the diagnostic, drills, safety, and exact instruction searchable. Also included: The Fighter Beneath the Pattern, the philosophical companion." }),
            /* @__PURE__ */ f.jsx("strong", { children: "$29 one-time" })
          ] }),
          /* @__PURE__ */ f.jsxs("article", { children: [
            /* @__PURE__ */ f.jsx("span", { children: "OPTIONAL · UNCHECKED" }),
            /* @__PURE__ */ f.jsx("h3", { children: "Archetype Adjustment Field Deck" }),
            /* @__PURE__ */ f.jsx("p", { children: "Thirty phone-first drill and observation cards, an accessible edition, and a printable six-card quick sheet derived from the core." }),
            /* @__PURE__ */ f.jsx("strong", { children: "+$12 one-time" })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ f.jsxs("section", { className: "fad-previews", "data-section-order": "8", children: [
        /* @__PURE__ */ f.jsxs("div", { className: "fad-section-heading", children: [
          /* @__PURE__ */ f.jsx("p", { className: "fad-kicker", children: "INSIDE THE ILLUSTRATED CODEX" }),
          /* @__PURE__ */ f.jsx("h2", { children: "Preview the illustrated pages." }),
          /* @__PURE__ */ f.jsx("p", { children: "Three illustrated pages from the core book. Try the diagnostic above and read the sample drill below." })
        ] }),
        /* @__PURE__ */ f.jsxs("div", { className: "fad-preview-grid", children: [
          /* @__PURE__ */ f.jsx(Ke, { asset: Ve.diagnostic, label: "Illustrated figure beside a spiral and curved paths.", source: "product/art/pages/page-14.png" }),
          /* @__PURE__ */ f.jsx(Ke, { asset: Ve.drill, label: "Illustrated figures connected by curved paths.", source: "product/art/pages/page-21.png" }),
          /* @__PURE__ */ f.jsx(Ke, { asset: Ve.protocol, label: "Illustrated figures along a looping path.", source: "product/art/pages/page-26.png" })
        ] })
      ] }),
      /* @__PURE__ */ f.jsxs("section", { className: "fad-sample", id: "drill", "data-section-order": "9", children: [
        /* @__PURE__ */ f.jsxs("div", { children: [
          /* @__PURE__ */ f.jsxs("p", { className: "fad-kicker", children: [
            "COMPLETE SAMPLE DRILL · ",
            Dt.id
          ] }),
          /* @__PURE__ */ f.jsx("h2", { children: Dt.name }),
          /* @__PURE__ */ f.jsx("p", { children: Dt.purpose })
        ] }),
        /* @__PURE__ */ f.jsxs("article", { children: [
          /* @__PURE__ */ f.jsxs("p", { children: [
            /* @__PURE__ */ f.jsx("strong", { children: "Starting position" }),
            " ",
            Dt.startingPosition
          ] }),
          /* @__PURE__ */ f.jsxs("p", { children: [
            /* @__PURE__ */ f.jsx("strong", { children: "Allowed" }),
            " ",
            Dt.allowedActions
          ] }),
          /* @__PURE__ */ f.jsxs("p", { children: [
            /* @__PURE__ */ f.jsx("strong", { children: "Prohibited" }),
            " ",
            Dt.prohibitedActions
          ] }),
          /* @__PURE__ */ f.jsxs("p", { children: [
            /* @__PURE__ */ f.jsx("strong", { children: "Intensity" }),
            " ",
            Dt.intensityCeiling
          ] }),
          /* @__PURE__ */ f.jsxs("p", { children: [
            /* @__PURE__ */ f.jsx("strong", { children: "Duration" }),
            " ",
            Dt.duration
          ] }),
          /* @__PURE__ */ f.jsxs("p", { children: [
            /* @__PURE__ */ f.jsx("strong", { children: "Success" }),
            " ",
            Dt.successMeasure
          ] }),
          /* @__PURE__ */ f.jsxs("p", { children: [
            /* @__PURE__ */ f.jsx("strong", { children: "Regression" }),
            " ",
            Dt.regression
          ] }),
          /* @__PURE__ */ f.jsxs("p", { children: [
            /* @__PURE__ */ f.jsx("strong", { children: "Stop" }),
            " ",
            Dt.stopConditions.join(" ")
          ] })
        ] })
      ] }),
      /* @__PURE__ */ f.jsxs("section", { className: "fad-protocol", "data-section-order": "10", children: [
        /* @__PURE__ */ f.jsxs("div", { className: "fad-section-heading", children: [
          /* @__PURE__ */ f.jsx("p", { className: "fad-kicker", children: "THE EXACT 21-DAY START PROTOCOL" }),
          /* @__PURE__ */ f.jsx("h2", { children: "Observe. Isolate. Contrast. Integrate." }),
          /* @__PURE__ */ f.jsx("p", { children: "This selects observations and controlled drills. It is not a performance guarantee, return-to-play progression, or competition clearance." })
        ] }),
        /* @__PURE__ */ f.jsx("div", { className: "fad-protocol-days", children: Dy.map((H) => /* @__PURE__ */ f.jsxs("article", { children: [
          /* @__PURE__ */ f.jsxs("span", { children: [
            H.day,
            " · ",
            H.phase
          ] }),
          /* @__PURE__ */ f.jsx("h3", { children: H.action }),
          /* @__PURE__ */ f.jsxs("p", { children: [
            /* @__PURE__ */ f.jsx("strong", { children: "Intensity boundary:" }),
            " ",
            H.intensity
          ] })
        ] }, H.day)) })
      ] }),
      /* @__PURE__ */ f.jsxs("section", { className: "fad-codex-reveal", "data-section-order": "11", children: [
        /* @__PURE__ */ f.jsxs("div", { children: [
          /* @__PURE__ */ f.jsx("p", { className: "fad-kicker", children: "THE 28-PAGE ILLUSTRATED CODEX" }),
          /* @__PURE__ */ f.jsxs("h2", { children: [
            "Five silhouettes.",
            /* @__PURE__ */ f.jsx("br", {}),
            "One changing fighter."
          ] }),
          /* @__PURE__ */ f.jsx("p", { children: "Premium black, bone, and restrained gold. The visual doctrine stays cinematic while exact instructional text remains in the searchable companion." })
        ] }),
        /* @__PURE__ */ f.jsx(Ke, { asset: Ve.cover, label: "28-page illustrated Codex", source: "product/art/pages/page-01.png" })
      ,/* SC_ALLOWLISTED_READ_PREVIEW_START */(f.jsx("div",{className:"sc-read-preview","data-sc-read-preview":"fighter-archetype-decoder",role:"region","aria-labelledby":"sc-read-fighter-archetype-decoder",dangerouslySetInnerHTML:{__html:"<div class=\"sc-read-preview__layout\"><figure class=\"sc-read-preview__figure\"><img src=\"__SC_READ_IMAGE_0__\" alt=\"The Fighter Beneath the Pattern — Actual opening cover artwork\" loading=\"lazy\" decoding=\"async\" width=\"660\" height=\"990\"><figcaption>Actual opening cover artwork · PDF page 1</figcaption></figure><div class=\"sc-read-preview__copy\"><p class=\"sc-read-preview__eyebrow\">READ · 92-PAGE PHILOSOPHICAL COMPANION</p><h3 id=\"sc-read-fighter-archetype-decoder\">The Fighter Beneath the Pattern</h3><p class=\"sc-read-preview__subtitle\">Identity, Adaptation, and the Freedom to Change</p><p class=\"sc-read-preview__distinction\">Included with your core purchase: The Fighter Beneath the Pattern, a philosophical companion distinct from the practical training materials.</p><details><summary>Selected chapters</summary><ul><li>Chapter 1: Before You Had a Type</li><li>Chapter 2: A Strength Becomes a Story</li><li>Chapter 3: The Comfort of a Familiar Answer</li><li>Chapter 4: Map, Habit, Identity</li><li>Chapter 5: Spear and the Morality of Initiative</li></ul></details><details><summary>Read a short excerpt</summary><blockquote><p>The reader is larger than the useful pattern. So is everyone else.</p><cite>Chapter 1 — Before You Had a Type · PDF page 5</cite></blockquote><p class=\"sc-read-preview__context\">A reflective lens, not a personality diagnosis, fixed type or performance prediction</p></details></div></div>".replace("__SC_READ_IMAGE_0__",new URL("sc-read-fighter-archetype-page-01.png",import.meta.url).href)}}))/* SC_ALLOWLISTED_READ_PREVIEW_END */] }),
      /* @__PURE__ */ f.jsxs("section", { className: "fad-deck", "data-section-order": "12", children: [
        /* @__PURE__ */ f.jsx(Ke, { asset: Ve.deck, label: "30-card Archetype Adjustment Field Deck preview", source: "product/addon/archetype-adjustment-field-deck.pdf" }),
        /* @__PURE__ */ f.jsxs("div", { children: [
          /* @__PURE__ */ f.jsx("p", { className: "fad-kicker", children: "OPTIONAL +$12 · UNCHECKED BY DEFAULT" }),
          /* @__PURE__ */ f.jsx("h2", { children: "Carry the adjustment, not the whole manual." }),
          /* @__PURE__ */ f.jsx("p", { children: "Thirty phone-first cards reformat the approved core drills and observation cues. No additional claims, no subscription, and nothing shipped." }),
          /* @__PURE__ */ f.jsxs("ul", { children: [
            /* @__PURE__ */ f.jsx("li", { children: "30 semantic drill and observation cards" }),
            /* @__PURE__ */ f.jsx("li", { children: "Accessible edition" }),
            /* @__PURE__ */ f.jsx("li", { children: "Printable six-card quick sheet" })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ f.jsxs("section", { className: "fad-boundaries", "data-section-order": "13", children: [
        /* @__PURE__ */ f.jsxs("div", { children: [
          /* @__PURE__ */ f.jsx("p", { className: "fad-kicker", children: "WHO IT IS FOR" }),
          /* @__PURE__ */ f.jsx("h2", { children: "Adult practitioners and coaches who want clearer training conversations." }),
          /* @__PURE__ */ f.jsx("p", { children: "MMA, Brazilian Jiu-Jitsu, Muay Thai, striking, grappling, and mixed-rules contexts using controlled technical practice." })
        ] }),
        /* @__PURE__ */ f.jsxs("div", { children: [
          /* @__PURE__ */ f.jsx("p", { className: "fad-kicker", children: "WHO IT IS NOT FOR" }),
          /* @__PURE__ */ f.jsx("h2", { children: "Anyone looking for a fixed identity, fight prediction, or medical answer." }),
          /* @__PURE__ */ f.jsx("p", { children: "Not medical advice, mental-health treatment, self-defence certification, competition clearance, or a substitute for qualified coaching." })
        ] })
      ] }),
      /* @__PURE__ */ f.jsxs("section", { className: "fad-research", "data-section-order": "14", children: [
        /* @__PURE__ */ f.jsx("p", { className: "fad-kicker", children: "RESEARCH AND PROVENANCE" }),
        /* @__PURE__ */ f.jsxs("div", { children: [
          /* @__PURE__ */ f.jsxs("h2", { children: [
            "The five lenses are coaching tools.",
            /* @__PURE__ */ f.jsx("br", {}),
            "The boundaries are explicit."
          ] }),
          /* @__PURE__ */ f.jsxs("div", { children: [
            /* @__PURE__ */ f.jsx("p", { children: "Representative-learning research supports preserving useful performance information in training tasks. It does not validate these five archetypes or predict outcomes." }),
            /* @__PURE__ */ f.jsxs("ol", { children: [
              /* @__PURE__ */ f.jsx("li", { children: /* @__PURE__ */ f.jsx("a", { href: "https://pubmed.ncbi.nlm.nih.gov/33253204/", target: "_blank", rel: "noreferrer", children: "Representative learning design review" }) }),
              /* @__PURE__ */ f.jsx("li", { children: /* @__PURE__ */ f.jsx("a", { href: "https://bjsm.bmj.com/content/53/6/328", target: "_blank", rel: "noreferrer", children: "Combat-sport concussion consensus" }) }),
              /* @__PURE__ */ f.jsx("li", { children: /* @__PURE__ */ f.jsx("a", { href: "https://pubmed.ncbi.nlm.nih.gov/28954799/", target: "_blank", rel: "noreferrer", children: "Olympic combat-sport injury review" }) })
            ] })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ f.jsxs("section", { className: "fad-summary", "data-section-order": "15", children: [
        /* @__PURE__ */ f.jsx("p", { className: "fad-kicker", children: "THE FIGHTER ARCHETYPE DECODER" }),
        /* @__PURE__ */ f.jsxs("h2", { children: [
          "Name your default.",
          /* @__PURE__ */ f.jsx("br", {}),
          "Train the missing answer."
        ] }),
        /* @__PURE__ */ f.jsx("p", { children: "28 illustrated pages · searchable companion · philosophical book included · 15 controlled drills · 21-day protocol · protected digital delivery" }),
        /* @__PURE__ */ f.jsxs("div", { children: [
          /* @__PURE__ */ f.jsx("strong", { children: "$29" }),
          /* @__PURE__ */ f.jsx("button", { type: "button", onClick: () => Ol("offer-summary"), children: "Get the complete edition →" })
        ] })
      ] }),
      /* @__PURE__ */ f.jsxs("section", { className: "fad-faq", "data-section-order": "16", children: [
        /* @__PURE__ */ f.jsxs("div", { className: "fad-section-heading", children: [
          /* @__PURE__ */ f.jsx("p", { className: "fad-kicker", children: "FIELD QUESTIONS" }),
          /* @__PURE__ */ f.jsx("h2", { children: "Before you begin." })
        ] }),
        /* @__PURE__ */ f.jsx("div", { children: My.map(([H, hl], vl) => /* @__PURE__ */ f.jsxs("article", { className: Tl === vl ? "is-open" : "", children: [
          /* @__PURE__ */ f.jsxs("button", { type: "button", "aria-expanded": Tl === vl, onClick: () => Jl(Tl === vl ? null : vl), children: [
            /* @__PURE__ */ f.jsx("span", { children: H }),
            /* @__PURE__ */ f.jsx("i", { "aria-hidden": "true", children: "+" })
          ] }),
          /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("p", { children: hl }) })
        ] }, H)) })
      ] }),
      /* @__PURE__ */ f.jsxs("footer", { children: [
        /* @__PURE__ */ f.jsxs("a", { className: "fad-wordmark", href: "#top", children: [
          /* @__PURE__ */ f.jsx("i", {}),
          "SPIRAL COMBAT"
        ] }),
        /* @__PURE__ */ f.jsx("p", { children: "Train responsibly. Use progressive resistance, qualified supervision, partner consent, and the rules of your discipline." }),
        /* @__PURE__ */ f.jsxs("nav", { children: [
          /* @__PURE__ */ f.jsx("a", { href: "/pages/terms-of-service", children: "Terms" }),
          /* @__PURE__ */ f.jsx("a", { href: "/pages/privacy-policy", children: "Privacy" }),
          /* @__PURE__ */ f.jsx("a", { href: "mailto:mike@spiralcombat.com", children: "Support" })
        ] })
      ] })
    ] }),
    Rl && /* @__PURE__ */ f.jsx("div", { className: "fad-checkout-backdrop", role: "presentation", onMouseDown: (H) => H.target === H.currentTarget && kl(), children: /* @__PURE__ */ f.jsxs("section", { className: "fad-checkout", "data-section-order": "17", role: "dialog", "aria-modal": "true", "aria-labelledby": "fad-checkout-title", ref: j, children: [
      /* @__PURE__ */ f.jsx("button", { className: "fad-checkout-close", type: "button", onClick: kl, "aria-label": "Close checkout panel", children: "×" }),
      /* @__PURE__ */ f.jsx("p", { className: "fad-kicker", children: "SECURE ONE-TIME CHECKOUT" }),
      /* @__PURE__ */ f.jsx("h2", { id: "fad-checkout-title", children: "The Fighter Archetype Decoder" }),
      T && /* @__PURE__ */ f.jsxs("p", { className: "fad-checkout-result", children: [
        "Diagnostic context: ",
        /* @__PURE__ */ f.jsx("strong", { children: Gd(T).title }),
        ". This is not a rank or fixed identity."
      ] }),
      /* @__PURE__ */ f.jsxs("ul", { children: [
        /* @__PURE__ */ f.jsx("li", { children: "28-page illustrated Codex" }),
        /* @__PURE__ */ f.jsx("li", { children: "Searchable companion and diagnostic; plus The Fighter Beneath the Pattern" }),
        /* @__PURE__ */ f.jsx("li", { children: "15 controlled drills and 21-day protocol" }),
        /* @__PURE__ */ f.jsx("li", { children: "Accessible editions and worksheet" })
      ] }),
      /* @__PURE__ */ f.jsxs("button", { className: R ? "fad-bump is-selected" : "fad-bump", type: "button", role: "checkbox", "aria-checked": R, onClick: It, children: [
        /* @__PURE__ */ f.jsx("i", { "aria-hidden": "true", children: R ? "✓" : "" }),
        /* @__PURE__ */ f.jsxs("span", { children: [
          /* @__PURE__ */ f.jsx("strong", { children: "Add the 30-card Adjustment Field Deck" }),
          /* @__PURE__ */ f.jsx("small", { children: "Phone-first digital cards + accessible edition + quick sheet. Optional and nothing shipped." })
        ] }),
        /* @__PURE__ */ f.jsx("b", { children: "+$12" })
      ] }),
      /* @__PURE__ */ f.jsxs("div", { className: "fad-total", children: [
        /* @__PURE__ */ f.jsx("span", { children: "Order total" }),
        /* @__PURE__ */ f.jsxs("strong", { children: [
          "$",
          Ju(R),
          " USD"
        ] })
      ] }),
      S.qaBanner && /* @__PURE__ */ f.jsx("p", { className: "fad-checkout-qa", children: "Local QA: checkout is intentionally disabled until exact Shopify variants and protected Member delivery are verified." }),
      /* @__PURE__ */ f.jsx("button", { className: "fad-checkout-submit", type: "button", disabled: Ml, onClick: yt, children: Ml ? "Preparing checkout…" : S.commerceEnabled ? "Continue to secure checkout" : "Check purchase availability" }),
      Xl && /* @__PURE__ */ f.jsx("p", { role: "status", className: "fad-checkout-status", children: Xl }),
      /* @__PURE__ */ f.jsx("p", { className: "fad-checkout-trust", children: "One payment. No subscription. No shipping. Protected My Library access follows verified payment. Refund-aware access is handled by the Member Platform." })
    ] }) })
  ] });
}
window.__scFighterArchetypeAuthorized !== !1 && document.querySelectorAll("[data-sc-fad-root]").forEach((S) => {
  S.dataset.scMounted !== "true" && (S.dataset.scMounted = "true", by.createRoot(S).render(/* @__PURE__ */ f.jsx(Ny, {})));
});
